
/* ---- r-endtrim 5 Sep 2026: the "Why 50mm?" explainer ------------------------------
   Built once per page, by whichever cut table loaded first, then shared. The button is
   added per ROW (the coated note is per row - 86 of them on the flat bar page, 112 on
   angles) but the PANEL is created once and guarded by window.__aaEndtrim.
   Content source: theme-patches\endtrim-explainer-2026-09-05\panel.py - regenerate,
   never hand-edit one of the four copies. ------------------------------------------ */
function aaEndtrimPanel() {
  if (window.__aaEndtrim) return window.__aaEndtrim;
  var st = document.createElement('style');
  st.textContent = '.aa-endtrim-why{appearance:none;border:0;background:none;padding:0;margin:0 0 0 6px;font:inherit;font-size:12px;font-weight:600;color:#0b6f8c;text-decoration:underline;text-underline-offset:2px;cursor:pointer;white-space:nowrap}.aa-endtrim-why:hover{color:#08536a}.aa-et-ov{position:fixed;inset:0;z-index:2147483600;background:rgba(15,23,42,.55);display:none;align-items:flex-start;justify-content:center;padding:24px 14px;overflow:auto}.aa-et-ov[data-open="1"]{display:flex}.aa-et-box{background:#fff;border-radius:14px;max-width:780px;width:100%;box-shadow:0 18px 50px rgba(15,23,42,.3);padding:22px 24px 18px;position:relative;font:14px/1.5 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;color:#14181d}.aa-et-box h3{margin:0 0 6px;font-size:19px;line-height:1.25}.aa-et-lead{margin:0 0 16px;color:#5d6772}.aa-et-x{position:absolute;top:10px;right:12px;appearance:none;border:0;background:none;font-size:26px;line-height:1;color:#8a939e;cursor:pointer;padding:4px 8px;border-radius:6px}.aa-et-x:hover{background:#f1f5f9;color:#14181d}.aa-et-ov svg{width:100%;height:auto;display:block;margin:0 0 14px}.aa-et-grid{display:grid;grid-template-columns:1fr;gap:10px}@media (min-width:640px){.aa-et-grid{grid-template-columns:1fr 1fr 1fr}}.aa-et-card{background:#f7f8fa;border:1px solid #e0e4e9;border-radius:9px;padding:12px 13px}.aa-et-card h4{margin:0 0 4px;font-size:13.5px}.aa-et-card p{margin:0;font-size:12.5px;line-height:1.5;color:#5d6772}.aa-et-ok{color:#2c6b4a;font-weight:600}.aa-et-foot{margin:14px 0 0;font-size:12px;color:#8a939e;text-align:center}@media print{.aa-endtrim-why,.aa-et-ov{display:none !important}}';
  document.head.appendChild(st);
  var ov = document.createElement('div');
  ov.className = 'aa-et-ov';
  ov.setAttribute('role', 'dialog');
  ov.setAttribute('aria-modal', 'true');
  ov.innerHTML = '<div class="aa-et-box"><button type="button" class="aa-et-x" aria-label="Close">&#215;</button><h3>Why we plan your cuts 50mm in from each end</h3><p class="aa-et-lead">Coated and anodised bar has to be <em>held</em> while it is finished, and the ends are where it is held. We cannot tell which end until the bar is in front of us &mdash; so we cut your pieces from the middle, and you get clean, finished pieces every time.</p><svg viewBox="0 0 700 232" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="A 6500mm bar. Powder coated and anodised both reserve 50mm at each end, leaving 6400mm. Mill finish uses all 6500mm."><g font-family="-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif"><text x="16" y="14" font-size="12" font-weight="700" fill="#14181d">Powder coated</text><text x="16" y="27" font-size="10.5" fill="#5d6772">Hung by a hole of about 10mm. Usually one end, sometimes both.</text><rect x="16" y="34" width="668" height="26" fill="#c9d4dd" stroke="#7d8b98"/><rect x="16" y="34" width="5.1" height="26" fill="#e8d9b0" stroke="#b8860b"/><rect x="678.9" y="34" width="5.1" height="26" fill="#e8d9b0" stroke="#b8860b"/><text x="16" y="74" font-size="10.5" fill="#8a5a00">50 &#183; usually</text><text x="684" y="74" font-size="10.5" fill="#8a5a00" text-anchor="end">50 &#183; sometimes</text><text x="350" y="51" font-size="11.5" font-weight="700" fill="#2c6b4a" text-anchor="middle">6400mm we cut your pieces from</text><text x="16" y="90" font-size="12" font-weight="700" fill="#14181d">Anodised</text><text x="16" y="103" font-size="10.5" fill="#5d6772">Clamped at both ends - that is how the current gets in.</text><rect x="16" y="110" width="668" height="26" fill="#c9d4dd" stroke="#7d8b98"/><rect x="16" y="110" width="5.1" height="26" fill="#e8d9b0" stroke="#b8860b"/><rect x="678.9" y="110" width="5.1" height="26" fill="#e8d9b0" stroke="#b8860b"/><text x="16" y="150" font-size="10.5" fill="#8a5a00">50 &#183; always</text><text x="684" y="150" font-size="10.5" fill="#8a5a00" text-anchor="end">50 &#183; always</text><text x="350" y="127" font-size="11.5" font-weight="700" fill="#2c6b4a" text-anchor="middle">6400mm we cut your pieces from</text><text x="16" y="166" font-size="12" font-weight="700" fill="#14181d">Mill finish (uncoated)</text><text x="16" y="179" font-size="10.5" fill="#5d6772">Nothing is done to the ends.</text><rect x="16" y="186" width="668" height="26" fill="#c9d4dd" stroke="#7d8b98"/><text x="350" y="203" font-size="11.5" font-weight="700" fill="#2c6b4a" text-anchor="middle">all 6500mm usable</text><text x="350" y="228" font-size="10.5" fill="#8a939e" text-anchor="middle">Drawn to scale. A 6500mm bar; the 50mm ends are the shaded slivers.</text></g></svg><div class="aa-et-grid"><div class="aa-et-card"><h4>Powder coated &mdash; a small hole</h4><p>The bar hangs from a punched hole of about 10mm so it can be sprayed all round. Usually one end, sometimes both, depending on where the bar came from &mdash; and because it is done by hand it can sit anywhere in that 50mm. That is why we keep the whole 50mm out of your finished pieces.</p></div><div class="aa-et-card"><h4>Anodised &mdash; a clamp mark, both ends</h4><p>Anodising runs a current through the bar, and the clamp is how the current gets in. That contact spot is the one place the finish cannot form, so it is bare there &mdash; always, and always at both ends.</p></div><div class="aa-et-card"><h4>Taking it uncut? <span class="aa-et-ok">You get the lot.</span></h4><p>Order a full length with no cuts and the whole bar is yours, ends and all. The 50mm only applies when we are cutting finished pieces for you.</p></div></div><p class="aa-et-foot">Wherever we cut, that face is raw aluminium &mdash; the finish is on the outside, not through it.</p></div>';
  document.body.appendChild(ov);
  var last = null;
  function close() {
    ov.removeAttribute('data-open');
    if (last) { try { last.focus(); } catch (e) {} }
    last = null;
  }
  /* Delegated: these tables rebuild a row on every finish change, so a button bound at
     creation would be gone a moment later. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('[data-aa-endtrim]');
    if (b) {
      e.preventDefault();
      last = b;
      ov.setAttribute('data-open', '1');
      var x = ov.querySelector('.aa-et-x');
      if (x) { try { x.focus(); } catch (e2) {} }
      return;
    }
    if (t === ov || t.closest('.aa-et-x')) close();
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && ov.getAttribute('data-open')) close();
  });
  window.__aaEndtrim = ov;
  return ov;
}
/* aa-cut-table-1d.js  -  THE ONE 1D CUT ENGINE. Serves the ANGLES, CHANNEL and FLAT BAR
   collection tables, which until 14 Sep 2026 each carried their own copy.
   THIS FILE IS aa-cut-table-flatbar.js, BYTE FOR BYTE, WITH THIS HEADER INSTEAD OF ITS OWN.
   Not a rewrite and not a merge in the usual sense - MEASURED first, comments and whitespace
   stripped:
       angles  3,342 code lines   channel 3,362 (+20)   flatbar 3,378 (+16)
   and ZERO lines existed only in a smaller file. Flatbar was already a strict superset of
   channel, which was a strict superset of angles. All 36 extra lines are the two OPTIONAL
   filters - internal size and square/radius corners - and every one of them is already
   guarded by whether that <select> exists in the page:
       const filterInternal = document.getElementById('aa-filter-internal-' + SID)  -> null
       var internalVal = filterInternal ? filterInternal.value : 'all'              -> 'all'
       if (filterInternal) { ... }                                                  -> skipped
       rebuildNumericSelect(null, ...)                                              -> returns
   The angles and channel sections never render those selects, so this file behaves on their
   pages exactly as their own copies did. No per-family config, no branch on a family name:
   the DOM the section already renders is the only thing that decides.
   WHY IT MATTERS more than 400 KB: a fix used to land in one copy of four and the other
   three kept the bug. Both money bugs we have had came out of that - $3 against $1 a cut on
   31 July, $802.79 against $71.12 on 13 September.
   KNOWN DEAD, LEFT ALONE ON PURPOSE so this file is provably the flatbar one: radiusValues
   is built from data-internal-leg and never read. The radius select's options are hard-coded
   in Liquid (square / radius) and the predicate reads data-corner-type, so the FILTER IS
   CORRECT - those two lines are simply unused. Delete them in a change that is about them.
   RHS IS NOT HERE. assets/aa-cut-table-rhs.js differs by 719 lines - no normalizeColour, no
   getFinishSwatchColour, no updateFinishSwatch, and it delegates to assets/aa-rhs-table.js,
   a flat global loaded before it. That is its own job with its own risk.
   Loaded WITHOUT defer, in the position the inline block occupied, so execution order is
   unchanged. */
var SID = (window.AA_CT_CFG && AA_CT_CFG.sectionId) || '';

(function() {
  var wrapper = document.getElementById('collection-table-' + SID + '');
  if (!wrapper) return;

  const filterFeature = document.getElementById('aa-filter-feature-' + SID + '');
  const filterDim1 = document.getElementById('aa-filter-dim1-' + SID + '');
  const filterDim2 = document.getElementById('aa-filter-dim2-' + SID + '');
  const filterDim3 = document.getElementById('aa-filter-dim3-' + SID + '');
  const filterInternal = document.getElementById('aa-filter-internal-' + SID + '');
  const filterRadius   = document.getElementById('aa-filter-radius-' + SID + '');
  const filterLength   = document.getElementById('aa-filter-length-' + SID + '');
  const filterFinish   = document.getElementById('aa-filter-finish-' + SID + '');
  const FILTER_INTERNAL_LABEL = AA_CT_CFG.filter_internal_label;
  const FILTER_RADIUS_LABEL   = AA_CT_CFG.filter_radius_label;
  const FILTER_FINISH_LABEL = AA_CT_CFG.filter_finish_label;
  const clearFiltersBtn = document.getElementById('aa-filter-clear-' + SID + '');

  const quickModal = wrapper.querySelector('.aa-quick-modal');
  const quickModalImage = wrapper.querySelector('.aa-quick-image');
  const quickModalTitle = wrapper.querySelector('.aa-quick-title');
  const quickModalShortSpec = wrapper.querySelector('.aa-quick-short-spec');
  const quickModalDescription = wrapper.querySelector('.aa-quick-description');
  const quickModalDim1Value = wrapper.querySelector('.aa-quick-dim1-value');
  const quickModalDim2Card = wrapper.querySelector('.aa-quick-dim2-card');
  const quickModalDim2Value = wrapper.querySelector('.aa-quick-dim2-value');
  const quickModalDim3Card = wrapper.querySelector('.aa-quick-dim3-card');
  const quickModalDim3Value = wrapper.querySelector('.aa-quick-dim3-value');
  const quickModalFinish = wrapper.querySelector('.aa-quick-finish');
  const quickModalRadius = wrapper.querySelector('.aa-quick-radius-value');
  const quickModalRadiusCard = wrapper.querySelector('.aa-quick-radius-card');
  const quickModalCut = wrapper.querySelector('.aa-quick-cut');
  const quickModalPowder = wrapper.querySelector('.aa-quick-powder');
  const quickCloseBtn = wrapper.querySelector('.aa-quick-close');

 var _feeData = JSON.parse(document.getElementById('aa-fee-data-' + SID + '').textContent || '{}');
  var POWDER_FEE_VARIANTS = _feeData.powderFee || {};

  /* The powder fee map used to be colour -> id. It carries the price too now, so
     the estimate can SHOW the $50 instead of springing it at checkout. Both
     shapes handled: a stale cached render emitting a bare number still adds to
     cart correctly, it just will not price. */
  function aaPowderFeeEntry(colourKey) {
    var v = POWDER_FEE_VARIANTS[colourKey];
    if (!v) return null;
    if (typeof v === 'object') return { id: v.id, price: Number(v.price) || 0 };
    return { id: v, price: 0 };
  }
  function aaPowderFeeId(colourKey) {
    var e = aaPowderFeeEntry(colourKey);
    return e ? e.id : undefined;
  }
  /* r655 (26 Sep 2026) - the setup fee is free once a colour reaches the coater's minimum. The rule lives in
     assets/aa-cart-guard.js (AACartGuard.pcSetupWaived); these only ask it. No guard on the page = today's
     behaviour (the fee is added), the safe way to be wrong. The row's product title carries the sizes. */
  function aaPcAreaFor(row, lengthMm, qty) {
    var G = window.AACartGuard;
    if (!G || !G.pcAreaM2 || !row) return 0;
    return G.pcAreaM2(row.getAttribute('data-quick-title') || '', (Number(lengthMm) || 0) / 1000, qty);
  }
  function aaPcWaived(cart, feeVariantId, extraM2) {
    var G = window.AACartGuard;
    try { return !!(G && G.pcSetupWaived && cart && G.pcSetupWaived(cart, feeVariantId, extraM2)); } catch (e) { return false; }
  }
  function aaPcFreeFrom(row) {
    var G = window.AACartGuard;
    try { return (G && G.pcFreeFromLengths && row) ? G.pcFreeFromLengths(row.getAttribute('data-quick-title') || '', 6.5) : 0; } catch (e) { return 0; }
  }
  /* An EDIT replaces the old job (the cut add removes its lines first), so the old job's bars must not count
     toward the minimum as well as the new plan's. Same test the edit removal uses: the edited line's key, or a
     line carrying its Design link. No edit in progress = the cart as it is. */
  function aaPcCartForFee(cart, row) {
    var ed = window.__aaCutEdit || null;
    if (!cart || !ed || !row || (row.getAttribute('data-handle') || '') !== ed.handle) return cart;
    var items = cart.items || [], old = null;
    items.forEach(function (it) { if (it.key === ed.key) old = it; });
    var d = old ? ((old.properties || {})['Design link'] || '') : '';
    return { items: items.filter(function (it) {
      return !(it.key === ed.key || (d && (it.properties || {})['Design link'] === d));
    }) };
  }

  /* Cart snapshot, refreshed when a panel opens. The setup fee is charged once
     per colour per ORDER, so a job added when one is already in the cart must not
     be quoted another $50. */
  var AA_CART_CACHE = null;
  /* r656 (27 Sep 2026) - D149 + D150, the table row's side: under the setup fee line, the price EACH with the setup
     at 1 / 4 / 10 lengths and from the free-from count; under Add to cart, what this row's quantity comes to; and an
     order of 80 m2 of one size in one colour told it is a mill run. DISPLAY ONLY - the add path is untouched; the
     numbers are its own arithmetic (lengths x the variant price, plus the fee line unless the cart holds it or the
     guard waives it). Anything unreadable = the row as before. */
  var AA_PE_MILL_M2 = 80, AA_PE_CART_ASKED = false;
  function aaPeMoney(cents) {
    var p = (Math.round(Number(cents) || 0) / 100).toFixed(2).split('.');
    return '$' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + p[1];
  }
  /* A cart change re-draws only this block on the rows showing a custom colour - a pure read of the row
     (selectedVariantData), never the whole row update, so no cut estimate or planner call rides on a cart refresh. */
  function aaPeRefreshRows() {
    wrapper.querySelectorAll('.aa-main-row[data-selected-finish-type="custom"]').forEach(function (r) {
      try {
        var res = selectedVariantData(r);
        if (res && res.type === 'custom') aaPeRow(r, res, r.getAttribute('data-default-lead-time') || FALLBACK_LEAD_TIME);
      } catch (e) {}
    });
  }
  document.documentElement.addEventListener('cart:refresh', function () {
    try { fetchCart().then(function (c) { AA_CART_CACHE = c; aaPeRefreshRows(); }).catch(function () {}); } catch (e) {}
  });

  /* r776 (7 Oct 2026) - THE FREE-SETUP BAR. Patryk ~10:40 pm: the price-each line is "too much information - that isn't our
     problem"; "a bar that shows it contribute to having a surcharge free". His ticks ~10:56 pm: as drawn, % and lengths.
     How close this colour is to a free setup = the colour's coated area already in the cart + this add, against the coater's
     minimum. EVERY number is asked of assets/aa-cart-guard.js (_pcColourAreaM2, PC_FREE_M2, pcSetupWaived - the rule the cart
     itself applies), so the bar and the charge cannot disagree: "free setup" is shown exactly when pcSetupWaived says so, and
     "N more lengths" is the smallest N for which pcSetupWaived says so. DISPLAY ONLY. Anything unreadable = no bar.
     r776b (8 Oct 2026) - his screenshot of three Woodland Grey rows on the angle table, 30/30/20, each bar on its own (75%,
     75%, 67%): "its not working towards the same colour free setup fee". Ticks: "Yes, count them", "Setup once, for all
     rows". Then: "i dont like how we are showing the price including setup fee" and "these are for custom powder coating
     colour... normal exstock doesnt cover it". So the bar also counts this colour's OTHER rows set up on the table
     (othersM2 - a third, lighter part); lengths just added are counted once, in the cart, never again as "these N"; and the
     setup is said by the bar ("the $50 setup in your cart comes off") so the price line under it is the lengths alone.
     Custom colours only, as before: a stocked colour has no setup fee, so no fee id, so no bar. */
  function aaPbState(G, cart, feeId, extraM2, perM2, othersM2) {
    var min = Number(G && G.PC_FREE_M2) || 0;
    if (!(min > 0) || !G._pcColourAreaM2 || !G.pcSetupWaived || !cart || !cart.items || !feeId) return null;
    var inCart = Number(G._pcColourAreaM2(cart, feeId)) || 0, add = Number(extraM2) || 0, oth = Number(othersM2) || 0;
    var reached = !!G.pcSetupWaived(cart, feeId, add + oth), alone = !!G.pcSetupWaived(cart, feeId, add), more = 0, m;
    if (!reached && perM2 > 0) {
      for (m = 1; m <= 5000; m++) { if (G.pcSetupWaived(cart, feeId, add + oth + m * perM2)) { more = m; break; } }
    }
    var feeIn = cart.items.some(function (it) { return Number(it.variant_id) === Number(feeId); });
    var pctCart = Math.min(100, inCart / min * 100), pctSelf = Math.min(100, (inCart + add) / min * 100),
      pctAll = Math.min(100, (inCart + add + oth) / min * 100);
    return { reached: reached, alone: alone, more: more, feeIn: feeIn, add: add, oth: oth,
      pctCart: pctCart, pctSelf: pctSelf, pctAll: pctAll, pct: reached ? 100 : Math.max(0, Math.min(99, Math.round(pctAll))) };
  }
  function aaPbEsc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function aaPbFee(cents) {
    var c = Math.round(Number(cents) || 0);
    return c % 100 === 0 ? "$" + (c / 100) : "$" + (c / 100).toFixed(2);
  }
  /* st from aaPbState; fee = the setup fee in cents; addLabel = this add's part ("these 10"); othLabel = the other rows' part.
     The parts, painted widest first: the other rows (lightest), this add, what is in the cart (darkest). */
  function aaPbHtml(colour, st, fee, addLabel, px, othLabel) {
    var fs = px || 13, C = aaPbEsc(colour), F = aaPbFee(fee), parts = [];
    if (st.reached) parts.push([100, "#1f8a4c", ""]);
    else {
      if (st.oth > 0 && st.pctAll > st.pctSelf) parts.push([st.pctAll, "#8fdbe8", othLabel || "your other rows"]);
      if (st.add > 0 && st.pctSelf > st.pctCart) parts.push([st.pctSelf, "#22b8cf", addLabel || "this add"]);
      if (st.pctCart > 0) parts.push([st.pctCart, "#0e7490", "in your cart"]);
    }
    var bar = "<div class=\"aa-pb-bar\" style=\"margin:7px 0 4px;height:10px;border-radius:5px;background:#e3e7ec;position:relative;overflow:hidden;\">" +
      parts.map(function (p) { return "<i style=\"position:absolute;left:0;top:0;bottom:0;width:" + p[0].toFixed(1) + "%;background:" + p[1] + ";\"></i>"; }).join("") + "</div>";
    var key = (!st.reached && parts.length > 1) ? "<div class=\"aa-pb-key\" style=\"font-size:" + (fs - 1.5) + "px;color:#64748b;margin-bottom:2px;\">" +
      parts.slice().reverse().map(function (p, i) {
        return "<span style=\"display:inline-block;width:9px;height:9px;border-radius:2px;background:" + p[1] + ";vertical-align:-1px;margin:" + (i ? "0 4px 0 8px" : "0 4px 0 0") + ";\"></span>" + aaPbEsc(p[2]);
      }).join(" ") + "</div>" : "";
    var words;
    if (st.reached && st.alone) words = "<b style=\"color:#1f8a4c;\">" + C + ": free setup</b> - this colour reaches the minimum" + (st.feeIn ? ", so the " + F + " setup in your cart comes off." : ".");
    else if (st.reached) words = "<b style=\"color:#1f8a4c;\">" + C + ": free setup once these rows are in your cart</b> - together they reach the minimum.";
    else words = "<b style=\"color:#0f172a;\">" + C + ": " + st.pct + "% of the way to free setup" + (st.oth > 0 ? "</b>, counting your other " + C + " rows. " : ".</b> ") +
      (st.more ? (st.more === 1 ? "1 more length" : st.more + " more lengths") + " of this size and the " + F + " comes off." : "Add more of this colour and the " + F + " comes off.");
    return "<div class=\"aa-pb\" style=\"font-size:" + fs + "px;line-height:1.45;\">" + bar + key + "<div class=\"aa-pb-words\">" + words + "</div></div>";
  }
  /* r776b - this colour's OTHER rows on this table that you have set up (a custom colour chosen, a quantity in the box),
     counted the way each row's own Add to cart would send them: the same fee switch (data-powder-fee-enabled and
     data-powder-available, as the add path reads them - a row that would not declare the setup fee does not count), the same
     quantity reading, the same area. Not counted: a row a filter has hidden (you cannot see it), and a row whose lengths were
     just added - they are in the cart already; counting them again is what showed "these 4" beside "in your cart" for the
     same 4. */
  function aaPbRowQty(row) {
    var qi = row ? row.querySelector('.aa-table-qty') : null;
    return Math.max(1, parseInt(qi && qi.value, 10) || 1);
  }
  function aaPbFeeOn(row) {
    return !!row && row.getAttribute('data-powder-fee-enabled') === 'true' && row.getAttribute('data-powder-available') === 'true';
  }
  function aaPbJustAdded(row, res, n, cart) {
    if (!row || !res || row.__aaPbAdded !== String(res.id) + '|' + n) return false;
    var have = 0;
    ((cart && cart.items) || []).forEach(function (it) { if (Number(it.variant_id) === Number(res.id)) have += Number(it.quantity) || 0; });
    return have >= n;
  }
  function aaPbOthersM2(row, feeId, cart) {
    var tot = 0;
    wrapper.querySelectorAll('.aa-main-row[data-selected-finish-type="custom"]').forEach(function (r) {
      if (r === row || !aaPbFeeOn(r) || !r.getClientRects().length) return;
      try {
        var res = selectedVariantData(r);
        if (!res || res.type !== 'custom' || !res.id) return;
        var fe = aaPowderFeeEntry(normalizeColour(res.powderColour || res.finish || ''));
        if (!fe || Number(fe.id) !== Number(feeId)) return;
        var k = aaPbRowQty(r);
        if (!aaPbJustAdded(r, res, k, cart)) tot += aaPcAreaFor(r, res.lengthMm || 6500, k);
      } catch (e) {}
    });
    return tot;
  }
  /* Any row's quantity, colour or length (or a filter) changing moves the other rows' bars: redraw every custom row's block,
     batched to one redraw per tick. Display only - the same pure read aaPeRefreshRows does on a cart change. */
  var AA_PB_TICK = 0;
  function aaPbSoon() {
    if (AA_PB_TICK) return;
    AA_PB_TICK = setTimeout(function () { AA_PB_TICK = 0; try { aaPeRefreshRows(); } catch (e) {} }, 0);
  }
  ['input', 'change', 'click'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (ev === 'click') { if (t.closest('[id^="aa-filter-clear-"]')) aaPbSoon(); return; }
      if (t.matches && (t.matches('select[id^="aa-filter-"]') || (t.matches('.aa-table-qty, .aa-finish-choice, .aa-length-select') && wrapper.contains(t)))) aaPbSoon();
    });
  });
  function aaPeRow(row, resolved, leadTime) {
    var G = window.AACartGuard;
    var ladder = row ? row.querySelector('.aa-pe-ladder') : null;
    if (ladder) ladder.style.display = 'none';
    if (!G || !G.pcSetupWaived || !row || !resolved || resolved.type !== 'custom' || !aaPbFeeOn(row)) return;
    var fe = aaPowderFeeEntry(normalizeColour(resolved.powderColour || resolved.finish || ''));
    var Pc = Number(resolved.priceCents) || 0, Fc = fe ? Number(fe.price) || 0 : 0, feeId = fe ? Number(fe.id) : 0;
    var a = aaPcAreaFor(row, resolved.lengthMm || 6500, 1), N = aaPcFreeFrom(row);
    var feeLine = row.querySelector('.aa-powder-fee-line');
    if (!(Pc > 0 && Fc > 0 && a > 0 && N > 1 && feeId && feeLine)) return;
    if (!ladder) {
      ladder = document.createElement('div');
      ladder.className = 'aa-pe-ladder';
      ladder.style.cssText = 'font-size:12px; color:#64748b; line-height:1.45;';
      feeLine.parentNode.insertBefore(ladder, feeLine.nextSibling);
    }
    /* r776: no price-each ladder any more (Patryk ~10:40 pm 7 Oct: "too much information"); the bar instead. */
    var qi = row.querySelector('.aa-table-qty');
    var n = Math.max(1, parseInt(qi && qi.value, 10) || 1);
    var cart = AA_CART_CACHE, big = n * a >= AA_PE_MILL_M2 - 1e-9;
    if (!cart && !AA_PE_CART_ASKED) {
      AA_PE_CART_ASKED = true;
      try { fetchCart().then(function (c) { AA_CART_CACHE = c; aaPeRefreshRows(); }).catch(function () {}); } catch (e) {}
    }
    /* r776b: the lengths alone (Patryk 8 Oct: "i dont like how we are showing the price including setup fee") - exactly what
       this row's own line will be in the cart. The $50 is its own line there; here the setup line above and the bar say it. */
    var yours = (n === 1 ? 'Your 1 length: ' : 'Your ' + n + ' lengths: ') + aaPeMoney(n * Pc) + ' ex GST.';
    var aaPbOut = '';
    if (cart && cart.items) {
      var aaPbDone = aaPbJustAdded(row, resolved, n, cart), same = 0;
      cart.items.forEach(function (it) { if (Number(it.variant_id) === Number(resolved.id)) same += Number(it.quantity) || 0; });
      big = (same + (aaPbDone ? 0 : n)) * a >= AA_PE_MILL_M2 - 1e-9;
      var aaPbSt = aaPbState(G, cart, feeId, aaPbDone ? 0 : n * a, a, aaPbOthersM2(row, feeId, cart));
      var aaPbCol = String(resolved.powderColour || resolved.finish || '').replace(/\s*powder[\s-]*coat(ed)?\s*/i, ' ').trim();
      if (aaPbSt && aaPbCol) aaPbOut = aaPbHtml(aaPbCol, aaPbSt, Fc, n === 1 ? 'this 1' : 'these ' + n, 12, 'your other rows');
    }
    /* All three lines live in the one block under the setup fee line - the row's lead line and order note are
       hidden on this table, and the availability column is written just before this runs (see the call site). */
    var MILL = 'An order this size is made as a mill run: allow 3-4 weeks. Ask us for a volume price: (03) 8725 0851.';
    ladder.innerHTML = aaPbOut +
      (yours ? '<span class="aa-pe-y" style="color:#0f172a;">' + yours + '</span>' : '') +
      (big ? (yours ? '<br>' : '') + '<span class="aa-pe-m" style="color:#0f172a;">' + MILL + '</span>' : '');
    ladder.style.display = 'block';
    var av = row.querySelector('.aa-availability-note');
    if (av) {
      if (big) av.textContent = '3-4 weeks (mill run)';
      else if (av.textContent === '3-4 weeks (mill run)') av.textContent = leadTime;
    }
  }
  function aaRefreshCartCache(row) {
    try {
      fetchCart().then(function (cart) {
        AA_CART_CACHE = cart;
        if (row) updateCutEstimate(row);
      }).catch(function () {});
    } catch (e) {}
  }
  var CUTTING_VARIANTS = _feeData.cuttingFee || {};

  const POWDER_SWATCHES = {
  'black': '#2b2b2b',
  'white pearl': '#f5f5f5',
  'monument': '#5b5d60',
  'woodland grey': '#4b5751',
  'surfmist': '#d9ddd6'
};
  const FINISH_SWATCHES = {
    'mill': '#d8dee4',
    'black': '#2b2b2b',
    'white': '#f8fafc',
    'anodised': '#c0c7ce'
  };

  const MAX_VISUAL_GROUPS = 8;
  const FALLBACK_LEAD_TIME = AA_CT_CFG.fallback_powder_lead_time;
  const MAX_FREE_CUTS = AA_CT_CFG.max_free_cuts_per_order;
  const CUT_WARNING_TEXT = AA_CT_CFG.cut_warning_text;
  const CUT_TO_SIZE_TEXT = window.innerWidth <= 767
    ? 'Cut to size'
    : AA_CT_CFG.label_cut_to_size;

  /* Inline SVG, never an emoji. Rebuilt here because the toggle below REWRITES the button's
     innerHTML on every open/close - a markup-only fix would be wiped on the first click.
     The children are pointer-events:none in the CSS above; without that the delegated
     handler never sees the click. */
  /* ONE owner for the button's label. Everything that resets the button must call this.
     Do NOT use textContent on .aa-cut-toggle - it wipes the icon and the span, and the
     button quietly becomes a different button. That is exactly what happened after
     "Cancel cutting" (Patryk, 15 Jul 2026). */
  function aaSetCutLabel(btn) {
    if (!btn) return;

    /* Has this row actually got cut sizes in it? If so the service is ACTIVE, and the button
       must say so - "Cut to size" gives the customer no way to tell it is already on. */
    var active = false;
    var row = btn.closest('tr');
    var panel = getCutPanelRow(row);
    if (panel && panel.classList.contains('aa-cut-panel-row')) {
      var lens = panel.querySelectorAll('.aa-cut-length');
      for (var i = 0; i < lens.length; i++) {
        if (String(lens[i].value || '').trim() !== '') { active = true; break; }
      }
    }

    /* Mobile has a full row to itself, so it can carry the plainer, more explicit label.
       Desktop lives in a narrow Services column - "Add cut-to-size service" there would widen
       the whole table. Same voice, sized to the space. */
    /* This button opens the AluCut Optimiser. "Cut to size" made it sound like a checkbox on
       a cutting option; it is a tool that works out the cheapest way to cover the customer's
       cut list from the stock this product actually comes in. Name it. */
    /* Two lines: what it is, then what it does for you. A first-timer understands the
       benefit before clicking - "AluCut" alone means nothing to them. */
    var l1 = active ? 'Edit AluCut sizes' : 'Cut to size';
    var l2 = active ? 'Your cut list is added' : 'AluCut works out your lengths & price';

    btn.classList.remove('aa-cut-toggle--open');
    btn.classList.toggle('aa-cut-active', active);
    if (row) row.classList.toggle('aa-has-cuts', active);   /* the whole card shows it */

    /* Chevron says "this opens something". Not shown once the plan exists - then it is an
       edit, not a discovery. */
    /* Tick when a plan exists, chevron when it does not. A chevron promises "this opens
       something new"; once a plan exists it is an edit, not a discovery. */
    var tail = active
      ? '<span class="aa-cut-tick" aria-hidden="true">\u2713</span>'
      : '<span class="aa-cut-chev" aria-hidden="true">\u203A</span>';
    btn.innerHTML = AA_CUT_ICON + '<span class="aa-cut-label"><span class="aa-cut-l1">' + l1 + '</span><span class="aa-cut-l2">' + l2 + '</span></span>' + tail;
  }

  const AA_CUT_ICON = "<svg width=\"17\" height=\"17\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><circle cx=\"6\" cy=\"6\" r=\"2.3\"/><circle cx=\"6\" cy=\"18\" r=\"2.3\"/><path d=\"M8.1 7.4 L20 17\"/><path d=\"M8.1 16.6 L20 7\"/></svg>";

  // Update button text on mobile on load
  if (window.innerWidth <= 767) {
    wrapper.querySelectorAll('button.aa-cut-toggle').forEach(function(btn) {
      if (!btn.classList.contains('aa-cut-toggle--open')) {
        btn.innerHTML = AA_CUT_ICON + '<span class="aa-cut-label"><span class="aa-cut-l1">Cut to size</span><span class="aa-cut-l2">AluCut works out your lengths &amp; price</span></span><span class="aa-cut-chev" aria-hidden="true">\u203A</span>';
      }
    });
    // Populate finish count hints
    wrapper.querySelectorAll('tr.aa-main-row').forEach(function(row) {
      var select = row.querySelector('.aa-finish-choice');
      var hint = row.querySelector('.aa-finish-count-hint');
      if (select && hint) {
        var count = select.options.length;
        if (count > 1) {
          hint.textContent = count + ' finishes available — tap to select';
        }
      }
    });
  }
  const POWDER_BADGE_TEXT = AA_CT_CFG.material_badge_powder_text;
  const STOCKED_BADGE_TEXT = AA_CT_CFG.material_badge_stocked_text;
  const FILTER_DIM1_LABEL = AA_CT_CFG.filter_dim_1_label;
  const FILTER_DIM2_LABEL = AA_CT_CFG.filter_dim_2_label;
  const FILTER_DIM3_LABEL = AA_CT_CFG.filter_dim_3_label;
  const FILTER_LENGTH_LABEL = AA_CT_CFG.filter_length_label;

  function moneyFromCents(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function normalizeColour(value) {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function normalizeNumericString(value) {
    if (value === null || value === undefined) return '';
    var str = String(value).trim();
    if (!str) return '';
    var num = Number(str);
    if (Number.isNaN(num)) return str;
    return String(num);
  }

  function safeValue(value, suffix) {
    if (value === null || value === undefined || value === '') return 'Not specified';
    return suffix ? String(value) + suffix : String(value);
  }

  function escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatQuickDescription(text) {
    var cleaned = String(text || '')
      .replace(/\s+/g, ' ')
      .replace(/\s*•\s*/g, ' • ')
      .trim();

    if (!cleaned) {
      return '<p style="margin:0;">No additional description available.</p>';
    }

    cleaned = cleaned
      .replace(/(Specifications:)/gi, '\n$1')
      .replace(/(Applications:)/gi, '\n$1')
      .replace(/(Uses:)/gi, '\n$1')
      .replace(/(Finish:)/gi, '\n$1')
      .replace(/(Length:)/gi, '\n$1')
      .replace(/(Notes:)/gi, '\n$1')
      .replace(/(Common Applications)/gi, '\n$1');

    var blocks = cleaned
      .split(/\n+/)
      .map(function(part) { return part.trim(); })
      .filter(Boolean);

    if (blocks.length <= 1) {
      var sentenceParts = cleaned
        .split(/(?<=\.)\s+(?=[A-Z])/)
        .map(function(part) { return part.trim(); })
        .filter(Boolean);

      if (sentenceParts.length > 1) {
        blocks = [];
        var current = [];
        sentenceParts.forEach(function(sentence, index) {
          current.push(sentence);
          if (current.length === 2 || index === sentenceParts.length - 1) {
            blocks.push(current.join(' '));
            current = [];
          }
        });
      } else {
        blocks = [cleaned];
      }
    }

    return blocks.map(function(block) {
      return '<p style="margin:0 0 10px 0;">' + escapeHtml(block) + '</p>';
    }).join('');
  }

  function rowMatchesFeature(row, featureVal) {
    var cutAvailable = row.getAttribute('data-cut-available') === 'true';
    var powderAvailable = row.getAttribute('data-powder-available') === 'true';

    if (featureVal === 'cut') return cutAvailable;
    if (featureVal === 'powder') return powderAvailable;
    if (featureVal === 'both') return cutAvailable && powderAvailable;
    return true;
  }

  function getRowLengths(row) {
    var raw = row.getAttribute('data-length-options') || '';
    if (!raw) return [];
    return raw.split(',').map(function(v) {
      return normalizeNumericString(v);
    }).filter(Boolean);
  }

  function lengthMmToLabel(mm) {
    var num = Number(mm);
    if (!num) return mm;
    return (num / 1000).toFixed(num % 1000 === 0 ? 1 : 2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1') + 'm';
  }

  function rebuildAlphaSelect(select, values, placeholder, selectedValue) {
    if (!select) return;
    select.innerHTML = '<option value="all">' + placeholder + '</option>';
    var entries = (values instanceof Map)
      ? Array.from(values.entries())
      : Array.from(values).map(function(v) { return [v, v]; });
    entries.sort(function(a, b) { return a[1].localeCompare(b[1]); });
    entries.forEach(function(entry) {
      var opt = document.createElement('option');
      opt.value = entry[0];
      opt.textContent = entry[1];
      if (entry[0] === selectedValue) opt.selected = true;
      select.appendChild(opt);
    });
  }

    function rebuildNumericSelect(select, values, placeholder, selectedValue) {
    if (!select) return;

    select.innerHTML = '';
    var firstOpt = document.createElement('option');
    firstOpt.value = 'all';
    firstOpt.textContent = placeholder;
    select.appendChild(firstOpt);

    Array.from(values)
      .sort(function(a, b) { return Number(a) - Number(b); })
      .forEach(function(val) {
        var opt = document.createElement('option');
        opt.value = val;
        opt.textContent = val + ' mm';
        select.appendChild(opt);
      });

    if (selectedValue && values.has(selectedValue)) {
      select.value = selectedValue;
    } else {
      select.value = 'all';
    }
  }

  function rebuildLengthSelect(select, values, placeholder, selectedValue) {
    if (!select) return;

    select.innerHTML = '';
    var firstOpt = document.createElement('option');
    firstOpt.value = 'all';
    firstOpt.textContent = placeholder;
    select.appendChild(firstOpt);

    Array.from(values)
      .sort(function(a, b) { return Number(a) - Number(b); })
      .forEach(function(val) {
        var opt = document.createElement('option');
        opt.value = val;
        opt.textContent = lengthMmToLabel(val);
        select.appendChild(opt);
      });

    if (selectedValue && values.has(selectedValue)) {
      select.value = selectedValue;
    } else {
      select.value = 'all';
    }
  }

  function refreshCascadingFilters() {
    if (!filterFeature || !filterDim1 || !filterDim2 || !filterDim3 || !filterLength) return;

    var featureVal = filterFeature.value;
    var selectedDim1 = filterDim1.value;
    var selectedDim2 = filterDim2.value;
    var selectedDim3 = filterDim3.value;
    var selectedLength = filterLength.value;

    var dim1Values = new Set();
    var dim2Values = new Set();
    var dim3Values = new Set();
    var lengthValues = new Set();

    wrapper.querySelectorAll('.aa-main-row').forEach(function(row) {
      if (!rowMatchesFeature(row, featureVal)) return;

      var dim1 = normalizeNumericString(row.getAttribute('data-dim1'));
      var dim2 = normalizeNumericString(row.getAttribute('data-dim2'));
      var dim3 = normalizeNumericString(row.getAttribute('data-dim3'));
      var lengths = getRowLengths(row);

      if (dim1) dim1Values.add(dim1);

      if (selectedDim1 === 'all' || dim1 === selectedDim1) {
        if (dim2) dim2Values.add(dim2);
      }

      if ((selectedDim1 === 'all' || dim1 === selectedDim1) && (selectedDim2 === 'all' || dim2 === selectedDim2)) {
        if (dim3) dim3Values.add(dim3);
      }

      if (
        (selectedDim1 === 'all' || dim1 === selectedDim1) &&
        (selectedDim2 === 'all' || dim2 === selectedDim2) &&
        (selectedDim3 === 'all' || dim3 === selectedDim3)
      ) {
        lengths.forEach(function(length) {
          lengthValues.add(length);
        });
      }
    });

    rebuildNumericSelect(filterDim1, dim1Values, FILTER_DIM1_LABEL, selectedDim1);
    rebuildNumericSelect(filterDim2, dim2Values, FILTER_DIM2_LABEL, selectedDim2);
    rebuildNumericSelect(filterDim3, dim3Values, FILTER_DIM3_LABEL, selectedDim3);
    var internalValues = new Set();
    var radiusValues   = new Set();
    wrapper.querySelectorAll('.aa-main-row').forEach(function(r) {
      var ib = r.getAttribute('data-internal-base');
      var il = r.getAttribute('data-internal-leg');
      if (ib && ib !== '') internalValues.add(ib);
      if (il && il !== '') radiusValues.add(il);
    });
    var selectedInternal = filterInternal ? filterInternal.value : 'all';
    rebuildNumericSelect(filterInternal, internalValues, FILTER_INTERNAL_LABEL, selectedInternal);
    rebuildLengthSelect(filterLength, lengthValues, FILTER_LENGTH_LABEL, selectedLength);
    var finishValues = new Map();
    wrapper.querySelectorAll('.aa-main-row').forEach(function(row) {
      var hiddenSelect = row.querySelector('.aa-variant-hidden');
      if (!hiddenSelect) return;
      Array.from(hiddenSelect.options).forEach(function(opt) {
        var finish  = opt.getAttribute('data-finish') || '';
        var isPowder = opt.getAttribute('data-powder-coat-variant') === 'true';
        var isStock  = opt.getAttribute('data-finished-stock') === 'true';
        if (!finish) return;
        if (isPowder) {
          var pc = (opt.getAttribute('data-option2') || '').replace(/\s*powder[\s-]*coat\s*/i, '').trim();
          if (!pc) pc = finish;
          var pcLabel = pc.charAt(0).toUpperCase() + pc.slice(1);
          var key = 'custom|' + pc;
          if (!finishValues.has(key)) finishValues.set(key, pcLabel + ' Powder Coat — 2–3 weeks + fee');
        } else if (isStock) {
          var key = 'stock|' + finish;
          if (!finishValues.has(key)) {
            var lbl = finish === 'Anodised' ? 'Clear Anodised — 1–3 days' : finish + ' — 1–3 days';
            finishValues.set(key, lbl);
          }
        } else if (finish === 'Mill') {
          if (!finishValues.has('mill|Mill')) finishValues.set('mill|Mill', 'Mill Finish — 1–3 days');
        }
      });
    });
    var selectedFinish = filterFinish ? filterFinish.value : 'all';
    rebuildAlphaSelect(filterFinish, finishValues, FILTER_FINISH_LABEL, selectedFinish);
  }

  function updatePrice(row, price) {
    var priceCell = row.querySelector('.aa-table-price');
    if (!priceCell) return;

    priceCell.innerHTML =
      '<div style="font-weight:700; font-size:16px; color:#1f2937;">' + price + '</div>' +
      '<div style="font-size:12px; color:#64748b; margin-top:6px;">per length</div>';
  }

  function updateAvailability(row, isAvailable) {
    var badge = row.querySelector('.aa-availability-badge');
    if (!badge) return;

    if (isAvailable) {
      badge.textContent = 'In stock';
      badge.dataset.aaState = 'ready';
    } else {
      badge.textContent = '1–3 days';
      badge.dataset.aaState = 'ready';
    }
  }

  function setAvailabilityNote(row, text) {
    var note = row.querySelector('.aa-availability-note');
    if (!note) return;
    note.textContent = text || '';
  }

  function setAvailabilityMadeToOrder(row, leadTime) {
    var badge = row.querySelector('.aa-availability-badge');
    var note = row.querySelector('.aa-availability-note');
    if (!badge || !note) return;

    badge.textContent = 'Made to order';
    badge.dataset.aaState = 'slow';
    note.textContent = leadTime || FALLBACK_LEAD_TIME;
  }

function getFinishSwatchColour(finish) {
  var key = normalizeColour(finish);

  // Powder coat colours
  if (key.includes('surfmist')) return '#d9ddd6';
  if (key.includes('monument')) return '#5b5d60';
  if (key.includes('woodland')) return '#4b5751';

  // Whites
  if (key.includes('white')) return '#f5f5f5';
  if (key.includes('pearl')) return '#f8fafc';

  // Black (catch ALL black types)
  if (key.includes('black')) return '#2b2b2b';

  // Anodised
  if (key.includes('anodised') || key.includes('anodized')) return '#c0c7ce';

  // Default
  return '#d8dee4';
}

  function getCuttingVariantId(row, cutMethod, rate) {
  var serviceLabelMap = {
    'up-saw': 'Up-Saw Cut',
    'band-saw': 'Band Saw Cut',
    'panel-saw': 'Panel Saw Cut',
    'rip-cut': 'Rip Cut',
    'oversized-cut': 'Oversized Cut',
    'folding-prep-cut': 'Folding Prep Cut'
  };

  var serviceLabel = serviceLabelMap[cutMethod] || serviceLabelMap['up-saw'];
  var rateStr = String(Number(rate));
  var fallbackId = (CUTTING_VARIANTS[cutMethod] || CUTTING_VARIANTS['up-saw']).id;
  var source = document.getElementById('cutting-service-variants-' + SID + '');

  if (!source) return fallbackId;

  var options = source.querySelectorAll('option');
  for (var i = 0; i < options.length; i++) {
    var opt = options[i];
    var service = String(opt.getAttribute('data-service') || '').trim();
    var rateVal = String(opt.getAttribute('data-rate') || '').trim();
    if (service === serviceLabel && rateVal === rateStr) return Number(opt.value);
  }
  return fallbackId;
}

function getCuttingRateCents(cutMethod, rate) {
  var serviceLabelMap = {
    'up-saw': 'Up-Saw Cut',
    'band-saw': 'Band Saw Cut',
    'panel-saw': 'Panel Saw Cut',
    'rip-cut': 'Rip Cut',
    'oversized-cut': 'Oversized Cut',
    'folding-prep-cut': 'Folding Prep Cut'
  };

  var serviceLabel = serviceLabelMap[cutMethod] || serviceLabelMap['up-saw'];
  var rateStr = String(Number(rate));
  var source = document.getElementById('cutting-service-variants-' + SID + '');
  if (!source) return Math.round(Number(rate || 0) * 100);

  var options = source.querySelectorAll('option');
  for (var i = 0; i < options.length; i++) {
    var opt = options[i];
    var service = String(opt.getAttribute('data-service') || '').trim();
    var rateVal = String(opt.getAttribute('data-rate') || '').trim();
    if (service === serviceLabel && rateVal === rateStr) {
      var priceCents = Number(opt.getAttribute('data-price-cents') || 0);
      if (priceCents > 0) return priceCents;
    }
  }

  return Math.round(Number(rate || 0) * 100);
}

/* ---- PAIRING THE PANEL TO ITS PRODUCT -----------------------------------
   These two used to walk the DOM: the panel was "the row after" and the product
   was "the row before". That is the single reason this engine cannot run
   anywhere except inside this table - on a product page there is no sibling to
   walk to. Pairing on the product handle instead makes the relationship explicit
   and position-independent.

   The positional walk is kept as a FALLBACK, so a surface that has not been
   given data-aa-for yet behaves exactly as it does today rather than breaking.
   Remove the fallbacks only once every surface declares the attribute.
   -------------------------------------------------------------------------- */
  function getCutPanelRow(row) {
    if (!row) return null;
    var handle = row.getAttribute('data-handle') || '';
    if (handle) {
      var byHandle = (wrapper || document).querySelector('.aa-cut-panel-row[data-aa-for="' + handle + '"]');
      if (byHandle) return byHandle;
    }
    var next = row.nextElementSibling;
    if (next && next.classList.contains('aa-cut-panel-row')) return next;
    return null;
  }

  /* ---- OPEN STATE --------------------------------------------------------
     The panel's open-ness was stored as the literal string 'table-row' in an
     inline style and tested by string comparison in three places. That is the
     last thing tying this engine to being a table row - inside a div container
     the same panel reads as permanently closed.

     The state now lives in a CLASS. The inline display is still written, for two
     reasons that both still apply: the table needs a real display value, and the
     stylesheet has an attribute-substring selector keyed on it -
     tr.aa-cut-panel-row[style*="table-row"] - which dies silently if the inline
     style stops saying that.

     The open display value is derived from the element rather than hardcoded, so
     a TR gets table-row and any other container gets block.

     aaIsCutPanelOpen falls back to the old string test, so a panel rendered by a
     surface that has not been migrated still reads correctly.
     ---------------------------------------------------------------------- */
  function aaCutPanelOpenDisplay(panelRow) {
    return (panelRow && panelRow.tagName === 'TR') ? 'table-row' : 'block';
  }

  function aaSetCutPanelOpen(panelRow, open) {
    if (!panelRow) return;
    panelRow.style.display = open ? aaCutPanelOpenDisplay(panelRow) : 'none';
    panelRow.classList.toggle('aa-cut-open', !!open);
  }

  function aaIsCutPanelOpen(panelRow) {
    if (!panelRow) return false;
    if (panelRow.classList.contains('aa-cut-open')) return true;
    /* fallback for markup this build has not touched */
    var d = panelRow.style.display;
    return !!d && d !== 'none';
  }

  function getCutProductRow(panelRow) {
    if (!panelRow) return null;
    var handle = panelRow.getAttribute('data-aa-for') || '';
    if (handle) {
      var byHandle = (wrapper || document).querySelector('.aa-main-row[data-handle="' + handle + '"]');
      if (byHandle) return byHandle;
    }
    var prev = panelRow.previousElementSibling;   /* fallback - must NOT recurse */
    if (prev && prev.classList.contains('aa-main-row')) return prev;
    return prev;
  }

  function setMainAddDisabled(row, disabled) {
    var addBtn = row.querySelector('.aa-table-add');
    if (!addBtn) return;

    addBtn.disabled = !!disabled;
    addBtn.style.opacity = disabled ? '0.45' : '1';
    addBtn.style.cursor = disabled ? 'not-allowed' : 'pointer';
  }

  function setSelectionLocked(row, locked) {
    var lengthSelect = row.querySelector('.aa-length-select');
    var finishChoice = row.querySelector('.aa-finish-choice');
    var variantNote = row.querySelector('.aa-variant-note');

    if (lengthSelect) {
      lengthSelect.disabled = !!locked;
      lengthSelect.style.opacity = locked ? '0.55' : '1';
      lengthSelect.style.cursor = locked ? 'not-allowed' : 'pointer';
    }

    if (finishChoice) {
      finishChoice.disabled = !!locked;
      finishChoice.style.opacity = locked ? '0.55' : '1';
      finishChoice.style.cursor = locked ? 'not-allowed' : 'pointer';
    }

    if (variantNote) {
      /* Locked is not a restriction, it is the feature: AluCut is choosing the material mix.
         Say so - "Selection locked" reads like something went wrong. */
      /* Locked is not a fault - AluCut is doing the work. And do not say "lengths": this row
         may be sheets, 500mm pieces or 1m stock. */
      variantNote.textContent = locked
        ? 'AluCut is working out the material for you.'
        : 'Pick a stock size to order it as it comes — or let AluCut work out the material for your cut list.';
    }
  }

  function updateMaterialBadges(row, resolved) {
    var badge = row.querySelector('.aa-finish-service-badge');
    var badgeText = row.querySelector('.aa-finish-service-text');
    var badgeSwatch = row.querySelector('.aa-finish-service-swatch');
    if (!badge || !badgeText || !badgeSwatch || !resolved) return;

    if (resolved.type === 'custom') {
      badge.style.display = 'inline-flex';
      badge.style.background = '#eef5f7';
      badge.style.color = '#475569';
      badgeText.textContent = POWDER_BADGE_TEXT;
      badgeSwatch.style.display = 'inline-block';
      badgeSwatch.style.background = getFinishSwatchColour(resolved.customColour);
      badgeSwatch.style.borderColor = '#cbd5e1';
      return;
    }

    if (resolved.type === 'stock') {
      badge.style.display = 'inline-flex';
      badge.style.background = '#f8fafc';
      badge.style.color = '#334155';
      badgeText.textContent = STOCKED_BADGE_TEXT;
      badgeSwatch.style.display = 'inline-block';
      badgeSwatch.style.background = getFinishSwatchColour(resolved.finishLabel);
      badgeSwatch.style.borderColor = resolved.finishLabel === 'White' ? '#94a3b8' : '#cbd5e1';
      return;
    }

    if (resolved.type === 'mill' && row.getAttribute('data-powder-available') === 'true') {
      badge.style.display = 'inline-flex';
      badge.style.background = '#eef5f7';
      badge.style.color = '#475569';
      badgeText.textContent = POWDER_BADGE_TEXT;
      badgeSwatch.style.display = 'none';
      return;
    }

    badge.style.display = 'none';
    badgeText.textContent = '';
    badgeSwatch.style.display = 'none';
    badgeSwatch.style.background = 'transparent';
  }

  function updateFinishSwatch(row, resolved) {
    var swatch = row.querySelector('.aa-finish-swatch');
    if (!swatch || !resolved) return;

    swatch.style.display = 'inline-block';

    if (resolved.type === 'custom') {
      swatch.style.background = getFinishSwatchColour(resolved.customColour);
      swatch.style.borderColor = '#cbd5e1';
      return;
    }

    swatch.style.background = getFinishSwatchColour(resolved.finishLabel || 'Mill');
    swatch.style.borderColor = (resolved.finishLabel || '') === 'White' ? '#94a3b8' : '#cbd5e1';
  }

function getAllVariantOptions(row) {
  var select = row.querySelector('.aa-variant-hidden');
  if (!select) return [];

  return Array.prototype.map.call(select.options, function(option) {
    var rawTitle = option.getAttribute('data-title') || option.textContent || '';
    var title = String(rawTitle).trim();
    var titleLc = title.toLowerCase();

    var isHalf =
      option.getAttribute('data-half') === 'true' ||
      titleLc.indexOf('half') !== -1 ||
      titleLc.indexOf('3.25') !== -1 ||
      titleLc.indexOf('2.75') !== -1;

    var rawOpt2 = (option.getAttribute('data-option2') || '').toLowerCase().trim();
    var isPowderVariant = option.getAttribute('data-powder-coat-variant') === 'true';
    var isFinishedStock = option.getAttribute('data-finished-stock') === 'true';

    // ── Finish label + type from option2 slug ────────────────────────
    var finishLabel, type;

    var FINISH_MAP = {
      'mill-finish':                   { label: 'Mill Finish',               type: 'mill'   },
      'mill finish':                   { label: 'Mill Finish',               type: 'mill'   },
      'mill':                          { label: 'Mill Finish',               type: 'mill'   },
      'surfmist':                      { label: 'Surfmist',                  type: 'stock'  },
      'black':                         { label: 'Black',                     type: 'stock'  },
      'white-pearl':                   { label: 'White Pearl',               type: 'stock'  },
      'white pearl':                   { label: 'White Pearl',               type: 'stock'  },
      'clear-anodised':                { label: 'Clear Anodised',            type: 'stock'  },
      'clear anodised':                { label: 'Clear Anodised',            type: 'stock'  },
      'woodland-grey-powder-coat':     { label: 'Woodland Grey Powder Coat', type: 'custom' },
      'monument-powder-coat':          { label: 'Monument Powder Coat',      type: 'custom' },
      'surfmist-powder-coat':          { label: 'Surfmist Powder Coat',      type: 'custom' },
      'jasper-powder-coat':            { label: 'Jasper Powder Coat',        type: 'custom' },
      'wallaby-satin-powder-coat':     { label: 'Wallaby Satin Powder Coat', type: 'custom' },
    };

    if (rawOpt2 && FINISH_MAP[rawOpt2]) {
      finishLabel = FINISH_MAP[rawOpt2].label;
      type = FINISH_MAP[rawOpt2].type;
    } else if (rawOpt2.indexOf('powder-coat') !== -1 || rawOpt2.indexOf('powder coat') !== -1) {
      // Unknown powder coat slug — convert to readable
      finishLabel = rawOpt2.replace(/-/g, ' ').replace(/\bpowder coat\b/gi, 'Powder Coat')
        .split(' ').map(function(w){ return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ').trim();
      type = 'custom';
    } else if (!rawOpt2 || rawOpt2 === '') {
      // Single-option product (channel etc.) — mill finish only
      finishLabel = 'Mill Finish';
      type = 'mill';
    } else {
      // Fallback — use slugified value as label
      finishLabel = rawOpt2.replace(/-/g, ' ')
        .split(' ').map(function(w){ return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
      type = (isPowderVariant || isFinishedStock) ? (isPowderVariant ? 'custom' : 'stock') : 'mill';
    }

    return {
      id: Number(option.value),
      text: title,
      title: title,
      finish: finishLabel,
      finishLabel: finishLabel,
      type: type,
      isHalf: isHalf,
      isPrecut: option.getAttribute('data-precut') === 'true',
      isFull: !isHalf,
      isAvailable: option.getAttribute('data-available') === 'true',
      lengthMm: Number(option.getAttribute('data-length-mm') || 0),
      priceCents: Number(option.getAttribute('data-price-cents') || 0),
      priceText: option.getAttribute('data-price') || '',
      isPowderVariant: isPowderVariant,
      powderColour: isPowderVariant ? finishLabel.replace(/\s*powder coat\s*/i, '').trim() : '',
      isFinishedStock: type === 'stock'
    };
  });
}

  function getSelectedLengthData(row) {
    var select = row.querySelector('.aa-length-select');
    if (!select) return null;
    var option = select.options[select.selectedIndex];
    if (!option) return null;

    return {
      lengthMm: Number(option.getAttribute('data-length-mm') || option.value || 0),
      lengthLabel: option.getAttribute('data-length-label') || option.textContent || '',
      isHalf: option.getAttribute('data-half') === 'true',
      isPrecut: option.getAttribute('data-precut') === 'true'
    };
  }

function getSelectedFinishChoice(row) {
  var select = row.querySelector('.aa-finish-choice');
  if (!select) return { raw: '', type: 'mill', finishLabel: 'Mill Finish', customColour: '' };

  var option = select.options[select.selectedIndex];
  if (!option) return { raw: '', type: 'mill', finishLabel: 'Mill Finish', customColour: '' };

  return {
    raw: option.value || '',
    type: option.getAttribute('data-type') || 'mill',
    finishLabel: option.getAttribute('data-finish-label') || option.textContent || '',
    customColour: option.getAttribute('data-custom-colour') || ''
  };
}

function findMatchingVariantForLengthAndFinish(row, lengthData, finishChoice) {
  var allOptions = getAllVariantOptions(row);
  if (!lengthData || !lengthData.lengthMm) return null;

  return allOptions.find(function(opt) {
    return opt.lengthMm === lengthData.lengthMm &&
      normalizeColour(opt.finishLabel) === normalizeColour(finishChoice.finishLabel);
  }) || null;
}

function rebuildFinishChoiceOptions(row) {
  var finishSelect = row.querySelector('.aa-finish-choice');
  if (!finishSelect) return;

  var selectedBefore = finishSelect.getAttribute('data-selected-value') || '';
  var lengthData = getSelectedLengthData(row);
  var allOptions = getAllVariantOptions(row);

  finishSelect.innerHTML = '';

  if (!lengthData || !lengthData.lengthMm) {
    var emptyOpt = document.createElement('option');
    emptyOpt.value = '';
    emptyOpt.textContent = 'Select finish';
    finishSelect.appendChild(emptyOpt);
    return;
  }

  var matching = allOptions.filter(function(opt) {
    return opt.lengthMm === lengthData.lengthMm;
  });

  var seen = {};

  matching.forEach(function(opt) {
    var key = normalizeColour(opt.finishLabel);
    if (seen[key]) return;
    seen[key] = true;

    var option = document.createElement('option');
    option.value = opt.id;

    // Add lead time hint to finish label
    var finishHint = '';
    var slug = normalizeColour(opt.finishLabel);
    if (slug === 'mill finish' || slug === 'mill-finish' || slug === 'mill') {
      finishHint = ' — 1–3 days';
    } else if (slug === 'clear anodised' || slug === 'clear-anodised') {
      finishHint = ' — 1–3 days';
    } else if (slug === 'black' || slug === 'white pearl' || slug === 'surfmist') {
      finishHint = ' — 1–3 days';
    } else if (opt.type === 'custom' || slug.indexOf('powder') !== -1) {
      finishHint = ' — 2–3 weeks + fee';
    }

    option.textContent = opt.finishLabel + finishHint;
    option.setAttribute('data-finish-label', opt.finishLabel);
    option.setAttribute('data-type', opt.type);
    option.setAttribute('data-custom-colour', opt.type === 'custom' ? opt.powderColour : '');
    finishSelect.appendChild(option);
  });

  if (!finishSelect.options.length) {
    var noneOpt = document.createElement('option');
    noneOpt.value = '';
    noneOpt.textContent = 'No finishes available';
    finishSelect.appendChild(noneOpt);
  }

  var foundPrevious = Array.prototype.some.call(finishSelect.options, function(opt) {
    return opt.value === selectedBefore || normalizeColour(opt.getAttribute('data-finish-label')) === normalizeColour(selectedBefore);
  });

  if (foundPrevious) {
    Array.prototype.forEach.call(finishSelect.options, function(opt) {
      if (opt.value === selectedBefore || normalizeColour(opt.getAttribute('data-finish-label')) === normalizeColour(selectedBefore)) {
        finishSelect.value = opt.value;
      }
    });
  } else {
    finishSelect.selectedIndex = 0;
  }

  var selectedOpt = finishSelect.options[finishSelect.selectedIndex];
  if (selectedOpt) {
    finishSelect.setAttribute('data-selected-value', selectedOpt.getAttribute('data-finish-label') || selectedOpt.value || '');
  }

  // Update finish count hint on mobile
  if (window.innerWidth <= 767) {
    var hint = row.querySelector('.aa-finish-count-hint');
    if (hint) {
      var count = finishSelect.options.length;
      hint.textContent = count > 1 ? count + ' finishes available' : '';
    }

    // Show min sale note if set
    var minSale = Number(row.getAttribute('data-min-sale') || 0);
    var minSaleNote = row.querySelector('.aa-min-sale-note');
    if (minSaleNote && minSale > 0) {
      var minSaleM = minSale >= 1000 ? (minSale / 1000).toFixed(2).replace(/\.?0+$/, '') + 'm' : minSale + 'mm';
      minSaleNote.textContent = 'Min. sale: ' + minSaleM;
      minSaleNote.style.display = 'block';
    }
  }
}

/* ---- r-1dmerge 14 Sep 2026 - THE FULL-LENGTH-ONLY PATH -------------------
   Imported VERBATIM from the RHS page's engine (aaFlCandidates from
   assets/aa-rhs-table.js, aaFlSync from assets/aa-cut-table-rhs.js) so this file
   is a strict superset of it and those three collections can drop two scripts
   for one.

   IT FIRES ON NOTHING TODAY. Both are reachable only from a row carrying
   data-has-length="false", and a sweep of all six cut collections found ZERO
   such rows - 122 on the 1D side, 70 on the RHS side, and select.aa-fl-finish
   renders nowhere. It is ported anyway because
   sections/main-collection-rhs-table.liquid CAN emit it (L302 sets the
   attribute, L658 renders the selector), so dropping it would be a guess about
   what is reachable rather than a fact about what exists.
   -------------------------------------------------------------------------- */

function aaFlCandidates(row) {
  // Full-length-only (anodised / pre-finished) rows have no Length matrix. AluCut still
  // cuts them, from ONE stock length only: the product full length (minimum_sale_length_mm,
  // 6500 default), priced at the SELECTED finish variant. No half length is offered.
  var rowLen = Number(row.getAttribute('data-min-sale') || 0);
  var flSel = row.querySelector('select.aa-fl-finish');
  var id = null, priceCents = 0, finishLabel = '', lenMm = 0;
  if (flSel && flSel.options.length) {
    var o = flSel.options[flSel.selectedIndex] || flSel.options[0];
    id = Number(o.value);
    priceCents = Number(o.getAttribute('data-price-cents') || 0);
    lenMm = Number(o.getAttribute('data-length-mm') || 0);
    finishLabel = (o.textContent || '').trim();
  } else {
    var hidden = row.querySelector('.aa-variant-hidden');
    if (hidden && hidden.options.length) {
      var ho = hidden.options[hidden.selectedIndex] || hidden.options[0];
      id = Number(ho.value);
      priceCents = Number(ho.getAttribute('data-price-cents') || 0);
      finishLabel = (ho.getAttribute('data-title') || ho.textContent || '').trim();
    }
    var single = row.querySelector('.aa-fl-single-finish');
    if (single) finishLabel = single.textContent.trim();
  }
  if (!lenMm) lenMm = rowLen || 6500;
  if (!id || !lenMm) return [];
  return [{
    id: id, text: finishLabel, title: finishLabel, finish: finishLabel,
    finishLabel: finishLabel, type: 'stock', isHalf: false, isPrecut: false,
    isFull: true, isAvailable: true, lengthMm: lenMm, priceCents: priceCents,
    priceText: '', isPowderVariant: false, powderColour: '', isFinishedStock: true
  }];
}

function aaFlSync(row) {
  if (!row || row.getAttribute('data-has-length') !== 'false') return;
  var sel = row.querySelector('select.aa-fl-finish');
  var addBtn = row.querySelector('.aa-table-add');
  var fv = row.querySelector('.aa-finish-value');
  if (sel && sel.options.length) {
    var o = sel.options[sel.selectedIndex] || sel.options[0];
    var priceText = o.getAttribute('data-price') || '';
    var avail = o.getAttribute('data-available') !== 'false';
    if (priceText) updatePrice(row, priceText);
    if (addBtn) {
      addBtn.setAttribute('data-variant-id', o.value);
      addBtn.disabled = !avail;
      addBtn.style.opacity = avail ? '1' : '0.45';
      addBtn.style.cursor = avail ? 'pointer' : 'not-allowed';
    }
    if (fv) fv.textContent = (o.textContent || '').trim();
  } else {
    var single = row.querySelector('.aa-fl-single-finish');
    if (fv && single) fv.textContent = single.textContent.trim();
  }
}

function selectedVariantData(row) {
  if (row.getAttribute('data-has-length') === 'false') {
    var flSel = row.querySelector('select.aa-fl-finish');
    var addB = row.querySelector('.aa-table-add');
    var vId = '', flPriceText = '', flAvail = true;
    if (flSel && flSel.options.length) {
      var fo = flSel.options[flSel.selectedIndex] || flSel.options[0];
      vId = fo.value;
      flPriceText = fo.getAttribute('data-price') || '';
      flAvail = fo.getAttribute('data-available') !== 'false';
    } else if (addB) {
      vId = addB.getAttribute('data-variant-id') || '';
    }
    return {
      id: vId ? Number(vId) : null,
      type: 'mill',
      isAvailable: flAvail,
      isFinishedStock: false,
      isPowderVariant: false,
      powderColour: '',
      priceText: flPriceText,
      priceCents: 0,
      finish: '',
      isHalf: false,
      lengthMm: 0,
      matchedVariant: vId ? { id: Number(vId) } : null
    };
  }
  var lengthData = getSelectedLengthData(row);
  var finishChoice = getSelectedFinishChoice(row);
  var matchedVariant = findMatchingVariantForLengthAndFinish(row, lengthData, finishChoice);

  var rawFinish = matchedVariant ? matchedVariant.finishLabel : (finishChoice.finishLabel || '');
  var normalizedRaw = normalizeColour(rawFinish);
  var displayFinish = rawFinish;

  if (matchedVariant) {
    if (matchedVariant.type === 'custom') {
      displayFinish = rawFinish;
    } else if (normalizedRaw === 'black') {
      displayFinish = 'Black Powder Coat';
    } else if (normalizedRaw === 'white pearl' || normalizedRaw === 'white') {
      displayFinish = 'White Pearl Powder Coat';
    } else if (normalizedRaw === 'surfmist') {
      displayFinish = 'Surfmist Powder Coat';
    } else if (normalizedRaw === 'monument') {
      displayFinish = 'Monument Powder Coat';
    } else if (normalizedRaw === 'woodland grey') {
      displayFinish = 'Woodland Grey Powder Coat';
    } else if (normalizedRaw === 'clear anodised' || normalizedRaw === 'clear anodized') {
      displayFinish = 'Clear Anodised';
    } else if (normalizedRaw === 'anodised' || normalizedRaw === 'anodized') {
      displayFinish = 'Anodised';
    } else if (normalizedRaw === 'mill' || normalizedRaw === 'mill finish') {
      displayFinish = 'Mill Finish';
    }
  }

  if (row.getAttribute('data-has-finish') === 'false') {
    var aaSingleFin = row.getAttribute('data-single-finish');
    if (aaSingleFin) displayFinish = aaSingleFin;
  }
  return {
    lengthData: lengthData,
    finishChoice: finishChoice,
    matchedVariant: matchedVariant,
    id: matchedVariant ? matchedVariant.id : null,
    title: matchedVariant ? matchedVariant.title : '',
    priceText: matchedVariant ? matchedVariant.priceText : '',
    priceCents: matchedVariant ? matchedVariant.priceCents : 0,
    finish: displayFinish,
    rawFinish: rawFinish,
    isHalf: lengthData ? lengthData.isHalf : false,
    isFinishedStock: matchedVariant ? matchedVariant.type === 'stock' : false,
    isAvailable: matchedVariant ? matchedVariant.isAvailable : false,
    lengthMm: lengthData ? Number(lengthData.lengthMm || 0) : 0,
    isPowderVariant: matchedVariant ? matchedVariant.type === 'custom' : false,
    powderColour: matchedVariant && matchedVariant.type === 'custom'
      ? rawFinish.replace(/\s*powder coat\s*/i, '').trim()
      : '',
    type: matchedVariant ? matchedVariant.type : 'mill'
  };
}

/* ---- THE CUT JOB'S OWN FINISH -----------------------------------------
   The ROW picks the finish of the full length bought; the POPUP picks the finish
   of the cut job. Deliberately not synced. aaCutFinishLabel falls back to the row
   when no picker is rendered, so surfaces without the shell behave exactly as the
   shipped finish lock already does. */
function aaCutFinishLabel(row) {
  var panelRow = getCutPanelRow(row);
  var sel = panelRow ? panelRow.querySelector('.aa-cut-finish') : null;
  if (sel && sel.value) return sel.value;
  var choice = getSelectedFinishChoice(row);
  return (choice && choice.finishLabel) ? choice.finishLabel : '';
}

function aaCutFinishOptions(row) {
  var minSaleLength = Number(row.getAttribute('data-min-sale') || 0);
  var seen = {}, out = [];
  getAllVariantOptions(row).forEach(function (opt) {
    if (!opt.lengthMm || opt.isPrecut || !opt.isAvailable) return;
    if (opt.type === 'mill' && minSaleLength > 0 && opt.lengthMm < minSaleLength) return;
    if (opt.type !== 'mill' && opt.isHalf) return;
    var key = normalizeColour(opt.finishLabel || '');
    if (!key || seen[key]) return;
    seen[key] = true;
    out.push({ label: opt.finishLabel, type: opt.type, powderColour: opt.powderColour || '' });
  });
  return out;
}

function aaBuildCutFinishSelect(row) {
  var panelRow = getCutPanelRow(row);
  if (!panelRow) return;
  var sel  = panelRow.querySelector('.aa-cut-finish');
  var wrap = panelRow.querySelector('.aa-cut-finishwrap');
  if (!sel) return;
  var opts = aaCutFinishOptions(row);
  var keep = sel.getAttribute('data-aa-touched') === '1' ? sel.value : '';
  sel.innerHTML = '';
  opts.forEach(function (o) {
    var el = document.createElement('option');
    el.value = o.label; el.textContent = o.label;
    el.setAttribute('data-type', o.type);
    sel.appendChild(el);
  });
  var want = normalizeColour(keep || getSelectedFinishChoice(row).finishLabel || '');
  var match = opts.filter(function (o) { return normalizeColour(o.label) === want; })[0];
  if (match) sel.value = match.label;
  else if (opts.length) sel.value = opts[0].label;
  /* One cuttable finish is not a choice - hide the control. */
  if (wrap) wrap.style.display = opts.length > 1 ? 'block' : 'none';
}

/* r-bestlength 13 Sep 2026. Reveals ".aa-cut-autolen" only on rows that actually have
   more than one length to choose between, and only on a table carrying this JS - the
   shell is shared by all six bar tables and a tick box that changes nothing is worse
   than no tick box. Same shape as aaBuildCutFinishSelect above, on purpose. */
function aaBuildAutoLenToggle(row) {
  var panelRow = getCutPanelRow(row);
  if (!panelRow) return;
  var wrap = panelRow.querySelector('.aa-cut-autolenwrap');
  var cb = panelRow.querySelector('.aa-cut-autolen');
  if (!wrap || !cb) return;
  var lens = {}, n = 0;
  try {
    getAutoPickCandidates(row).forEach(function (c) {
      var L = Number(c.lengthMm);
      if (L > 0 && !lens[L]) { lens[L] = 1; n++; }
    });
  } catch (e) { n = 0; }
  wrap.style.display = n > 1 ? 'block' : 'none';
  if (cb.getAttribute('data-aa-bound') !== '1') {
    cb.addEventListener('change', function () { updateCutEstimate(row); });
    cb.setAttribute('data-aa-bound', '1');
  }
}

function getCandidateStockOptions(row) {
  /* r-1dmerge: full-length-only rows have no Length matrix - one stock length, priced
     at the selected finish variant. The RHS engine returned here and this one did not.
     Sits ABOVE the finish lock on purpose: aaFlCandidates returns a single candidate,
     so there is nothing for the lock to choose wrongly between. */
  if (row.getAttribute('data-has-length') === 'false') { return aaFlCandidates(row); }
  var selected = selectedVariantData(row);
  var allOptions = getAllVariantOptions(row);
  var minSaleLength = Number(row.getAttribute('data-min-sale') || 0);
  var powderFullLengthOnly = row.getAttribute('data-powder-full-length-only') === 'true';
  var seen = {};

  // When a pre-cut length is selected, candidates are locked to only that length.
  // The bin-packing algorithm can then suggest buying multiple pre-cut pieces if needed.
  var selectedLength = getSelectedLengthData(row);
  /* r207 - THE FINISH LOCK NOW COVERS PRE-CUT LENGTHS TOO.
     This branch returned on LENGTH ALONE, ~30 lines above the finish lock
     documented below - so for a pre-cut length the lock never ran. Every colour
     at that millimetre went into the candidate list, the optimiser (which is
     blind to colour) minimised cost, and add-to-cart used item.candidate.id.
     Customer selects Black pre-cut, the panel prints 'Finish: Black', and a Mill
     bar is carted at a lower price. Self-consistent dollar figure, wrong physical
     metal, non-returnable line.
     It is the SAME defect the lock below says was fixed - the fix simply sat
     underneath a return that skipped it. lockColour is hoisted above the branch
     so both paths answer the same question from the same value. */
  var lockColour = normalizeColour(aaCutFinishLabel(row) || '');
  if (selectedLength && selectedLength.isPrecut) {
    return allOptions.filter(function(opt) {
      if (opt.lengthMm !== selectedLength.lengthMm) return false;
      if (lockColour && normalizeColour(opt.finishLabel || '') !== lockColour) return false;
      return true;
    });
  }

  // When a standard length (FL/HL) is selected, exclude pre-cut variants from
  // candidates entirely. Pre-cut variants are fixed-price pieces — they are not
  // stock lengths for cut planning. Including them causes the bin-packing algorithm
  // to try exponentially many combinations (13+ candidates) and freezes the browser.
  /* ---- FINISH LOCK -------------------------------------------------------
     This filtered by opt.type alone. Type is only ever mill / stock / custom,
     so EVERY colour sharing a type stayed in the candidate list - and the sort
     at the bottom of this function puts the cheapest first. The optimiser then
     picked from that list and add-to-cart used item.candidate.id, so the
     cheapest colour in the category was bought, not the one the customer chose.

     Angle 12x12x1.6, 6.5m, ex-GST: Clear Anodised $13.10, Black $13.42,
     White Pearl $13.42 - all type 'stock'. Choosing Black built the plan on
     Clear Anodised. Wrong colour, out the door. 44 of the 56 angle rows carry
     2+ finishes. Mill-only products were never affected.

     Same defect collection-table-sheets was fixed for after the Black Satin
     order; the bar tables never got the equivalent lock.

     The lock is a CONDITION - "the candidate's colour is the chosen colour" -
     not a list of colours to special-case. effType exists because the type has
     to be read off the CHOSEN colour too, or the chosen colour gets filtered
     out by the type test one line later.
     ---------------------------------------------------------------------- */
  /* r207: lockColour is now computed above the pre-cut branch. */
  var lockedOpt = lockColour
    ? allOptions.filter(function(o) { return normalizeColour(o.finishLabel || '') === lockColour; })[0]
    : null;
  var effType = lockedOpt ? lockedOpt.type : selected.type;

  var candidates = allOptions.filter(function(opt) {
    return opt.lengthMm > 0 && opt.type === effType && !opt.isPrecut;
  }).filter(function(opt) {
    if (!lockColour) return true;
    return normalizeColour(opt.finishLabel || '') === lockColour;
  }).filter(function(opt) {
    if (effType === 'stock' || effType === 'custom') {
      return !opt.isHalf;
    }

    if (effType === 'custom' && powderFullLengthOnly) {
      return !opt.isHalf;
    }

    if (effType === 'mill' && minSaleLength > 0) {
      return Number(opt.lengthMm) >= minSaleLength;
    }

    return true;
  }).filter(function(opt) {
    var key = [opt.type, normalizeColour(opt.finishLabel || ''), Number(opt.lengthMm || 0), opt.isHalf ? 'half' : 'full'].join('|');
    if (seen[key]) return false;
    seen[key] = true;
    return true;
  });

  return candidates.sort(function(a, b) {
    if (a.priceCents !== b.priceCents) return a.priceCents - b.priceCents;
    return a.lengthMm - b.lengthMm;
  });
}

/* r31: AluFinish placeholder - a row only has a finish to choose when
   it carries finished-stock or powder variants, or powder is available.
   Rows that pre-compute this in liquid expose data-has-finish. */
function aaRowHasFinishChoices(row) {
  if (row._aaHasFinish !== undefined) return row._aaHasFinish;
  var has = row.getAttribute('data-powder-available') === 'true';
  if (!has) {
    var dhf = row.getAttribute('data-has-finish');
    if (dhf !== null) {
      has = dhf === 'true';
    } else {
      var opts = getAllVariantOptions(row);
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].type !== 'mill') { has = true; break; }
      }
    }
  }
  row._aaHasFinish = has;
  return has;
}

function updatePowderDisplay(row, resolved) {
  var finishSelect = row.querySelector('.aa-finish-choice');
  var powderStatusLine = row.querySelector('.aa-powder-status-line');
  var powderLeadLine = row.querySelector('.aa-powder-lead-line');
  var powderFeeLine = row.querySelector('.aa-powder-fee-line');
  var powderNote3 = row.querySelector('.aa-powder-note-3');
  var selectedWrap = row.querySelector('.aa-powder-selected-wrap');
  var selectedText = row.querySelector('.aa-powder-selected-text');
  var swatch = row.querySelector('.aa-powder-swatch');
  var orderNote = row.querySelector('.aa-order-note');
  var leadTime = row.getAttribute('data-default-lead-time') || FALLBACK_LEAD_TIME;

  if (!finishSelect || !resolved) return;

  if (powderFeeLine) powderFeeLine.style.display = 'none';
  if (powderNote3) powderNote3.style.display = 'none';
  if (selectedWrap) selectedWrap.style.display = 'none';
  var aaPeOld = row.querySelector('.aa-pe-ladder');
  if (aaPeOld) aaPeOld.style.display = 'none';

  if (resolved.type === 'custom') {
    if (powderStatusLine) powderStatusLine.textContent = 'Custom powder coat selected';
    if (powderLeadLine) powderLeadLine.textContent = 'Custom powder coated bar comes in full 6.5m lengths — no half lengths. We can still cut it to your sizes. Lead time: ' + leadTime;
    if (powderFeeLine) {
      /* Name the number. "a setup fee applies" with no amount is the worst of
         both - enough to hesitate over, not enough to decide on. */
      var feeAmtEl = powderFeeLine.querySelector('.aa-powder-fee-amount');
      var feeEntry = aaPowderFeeEntry(normalizeColour(resolved.powderColour || resolved.finish || ''));
      if (feeAmtEl) {
        feeAmtEl.textContent = (feeEntry && feeEntry.price > 0)
          ? 'Setup fee ' + moneyFromCents(feeEntry.price)
          : 'Setup fee';
      }
      /* r655 - and when it stops. Appended once, after the fixed sentence. */
      var aaFreeN1 = aaPcFreeFrom(row);
      var aaFreeEl = powderFeeLine.querySelector('.aa-powder-fee-free');
      if (!aaFreeEl && aaFreeN1) { aaFreeEl = document.createElement('span'); aaFreeEl.className = 'aa-powder-fee-free'; powderFeeLine.appendChild(aaFreeEl); }
      if (aaFreeEl) aaFreeEl.textContent = aaFreeN1 ? ' Free from ' + aaFreeN1 + ' lengths of this size. Mixed sizes in the same colour count too.' : '';
      powderFeeLine.style.display = 'block';
    }
    if (powderNote3) {
      powderNote3.textContent = CUT_WARNING_TEXT;
      powderNote3.style.display = 'block';
    }
    if (selectedWrap) selectedWrap.style.display = 'flex';
    if (selectedText) selectedText.textContent = resolved.finish;
    if (swatch) swatch.style.background = getFinishSwatchColour(resolved.powderColour || resolved.finish);
    if (orderNote) orderNote.textContent = 'Custom powder coat finish selected. Full bars only, no half lengths — cutting to size is available. Lead time ' + leadTime + '.';
    row.setAttribute('data-selected-powder-colour', resolved.powderColour || '');
    row.setAttribute('data-selected-finish-type', 'custom');
    return;
  }

  row.setAttribute('data-selected-powder-colour', '');
  row.setAttribute('data-selected-finish-type', resolved.type);

  if (resolved.type === 'stock') {
    if (powderStatusLine) powderStatusLine.textContent = 'Stocked pre-finished — full bars, no half lengths';
    if (powderLeadLine) powderLeadLine.textContent = 'Non mill finishes come in full bars only — no half lengths. We can still cut them to size.';
    if (selectedWrap) selectedWrap.style.display = 'flex';
    if (selectedText) selectedText.textContent = resolved.finish;
    if (swatch) swatch.style.background = getFinishSwatchColour(resolved.finishLabel || resolved.finish);
    if (powderNote3) {
      powderNote3.textContent = CUT_WARNING_TEXT;
      powderNote3.style.display = 'block';
    }
    if (orderNote) {
      orderNote.textContent = resolved.finish + ' selected. Full bars only, no half lengths. We can cut it to size — note that the first and last 50mm of a coated or anodised bar carry clamp marks or a hanging hole and are not usable, and any cut edge will expose raw aluminium.';
    }
    return;
  }

  if (resolved.isHalf) {
    if (powderStatusLine) powderStatusLine.textContent = 'Half length selected';
    if (powderLeadLine) powderLeadLine.textContent = 'Showing finishes available for this selected length';
    if (orderNote) orderNote.textContent = 'Half length selected.';
    return;
  }

  // Pre-cut piece selected
  if (resolved.lengthMm > 0 && resolved.lengthMm < 3250) {
    var selectedLen = getSelectedLengthData(row);
    if (selectedLen && selectedLen.isPrecut) {
      if (powderStatusLine) powderStatusLine.textContent = 'Pre-cut piece selected — ' + selectedLen.lengthLabel;
      if (powderLeadLine) powderLeadLine.textContent = 'Cut-to-size available within this length.';
      if (orderNote) orderNote.textContent = 'Pre-cut piece: ' + selectedLen.lengthLabel + '. Cut-to-size available.';
      return;
    }
  }

  if (powderStatusLine) {
    if (aaRowHasFinishChoices(row)) {
      powderStatusLine.textContent = 'Select the required finish';
    } else {
      powderStatusLine.textContent = 'AluFinish coming soon';
      powderStatusLine.style.color = '#94a3b8';
      powderStatusLine.style.fontWeight = '400';
    }
  }
  if (powderLeadLine) powderLeadLine.textContent = 'Finishes shown are based on the selected length.';
  if (orderNote) orderNote.textContent = 'Select your required length and finish.';
}

function updateCutWarnings(row) {
  var panelRow = getCutPanelRow(row);
  if (!panelRow) return;

  var warning = panelRow.querySelector('.aa-cut-warning');
  if (!warning) return;

  var variant = selectedVariantData(row);
  /* r-endtrim: ALSO honour the finish chosen in the cut popup. The row can still say Mill
     while the customer has picked Black in the popup - which is exactly when the raw-edges
     note matters. Additive: this can only show the note more often, never less. */
  var _popFin = String((typeof aaCutFinishLabel === 'function' ? (aaCutFinishLabel(row) || '') : '')).toLowerCase();
  var isFinishedSurface = variant.type === 'stock' || variant.type === 'custom' ||
    (!!_popFin && _popFin.indexOf('mill') < 0);

  /* r-endtrim (27 Aug 2026). The finish note used to stamp warningType='finish', and
     EVERY real cut error in updateCutEstimate was guarded against overwriting it - six
     guards, all of them `dataset.warningType !== 'finish'`. So on a coated or anodised
     row the customer never saw "this cut list cannot be produced", "exceeds the stock
     length" or "under the minimum": they saw the generic raw-edges note and nothing
     else. Both are shown now - the real error first, the finish note appended. The note
     is kept here so the error writes can re-attach it. */
  warning.dataset.finishNote = isFinishedSurface ? CUT_WARNING_TEXT : '';
  if (isFinishedSurface) {
    if (!warning.textContent.trim() || warning.dataset.warningType !== 'finish') {
      warning.textContent = CUT_WARNING_TEXT;
    }
    warning.style.display = 'block';
    warning.dataset.warningType = 'finish';
  } else if (warning.dataset.warningType === 'finish') {
    warning.textContent = '';
    warning.style.display = 'none';
    warning.dataset.warningType = '';
  }
}

// ── Simple availability badge (finish-type based) ───────────────────
function updateSimpleBadge(row, resolved) {
  var badge = row.querySelector('.aa-availability-badge');
  if (!badge) return;
  if (resolved.type === 'custom') {
    badge.textContent = 'Made to order';
    badge.dataset.aaState = 'slow';
  } else {
    badge.textContent = '1–3 days';
    badge.dataset.aaState = 'ready';
  }
  setAvailabilityNote(row, '');
}

// ── Dynamic min sale display ──────────────────────────────────────────
function updateMinSaleDisplay(row, resolved) {
  // Simplified — no longer shows per-finish min sale text
}

function updateVariantBehaviour(row) {
  /* r-1dmerge: a full-length-only row has no Length/finish matrix to rebuild - its
     price and cart variant come straight off the simple finish selector. */
  if (row.getAttribute('data-has-length') === 'false') { aaFlSync(row); return; }
  var finishSelect = row.querySelector('.aa-finish-choice');
  var lengthSelect = row.querySelector('.aa-length-select');
  if (finishSelect) {
    var currentlySelected = finishSelect.options[finishSelect.selectedIndex];
    if (currentlySelected) {
      finishSelect.setAttribute('data-selected-value', currentlySelected.getAttribute('data-finish-label') || currentlySelected.value || '');
    }
  }

  rebuildFinishChoiceOptions(row);

  var resolved = selectedVariantData(row);

  if (resolved.type !== 'mill' && lengthSelect) {
    var selectedLength = getSelectedLengthData(row);
    if (selectedLength && selectedLength.isHalf) {
      for (var i = 0; i < lengthSelect.options.length; i++) {
        if (lengthSelect.options[i].getAttribute('data-half') !== 'true') {
          lengthSelect.selectedIndex = i;
          break;
        }
      }
      updateVariantBehaviour(row);
      return;
    }
  }

  var finishValue = row.querySelector('.aa-finish-value');
  var finishNote = row.querySelector('.aa-finish-note');
  var serviceNote = row.querySelector('.aa-service-note');
  var addBtn = row.querySelector('.aa-table-add');

  updateFinishSwatch(row, resolved);
  updateMaterialBadges(row, resolved);
  updatePowderDisplay(row, resolved);

  if (finishValue) {
    finishValue.textContent = resolved.finish || 'Mill Finish';
  }

  if (!resolved.matchedVariant) {
    if (finishNote) finishNote.textContent = 'This finish is not available for the selected length';
    updatePrice(row, '$0.00');
    updateSimpleBadge(row, resolved || {type: 'mill'});
    setAvailabilityNote(row, 'Please choose another finish or length');
    if (serviceNote) serviceNote.textContent = 'Cutting can be added to this item.';
    if (addBtn) {
      addBtn.setAttribute('data-variant-id', '');
      addBtn.disabled = true;
      addBtn.style.opacity = '0.45';
      addBtn.style.cursor = 'not-allowed';
    }
    updateCutWarnings(row);
    updateCutEstimate(row);
    return;
  }

  row.querySelector('.aa-table-add').setAttribute('data-variant-id', resolved.id);
  updatePrice(row, resolved.priceText);

  if (resolved.type === 'custom') {
    if (finishNote) finishNote.textContent = 'Custom powder coat variant selected';
    setAvailabilityMadeToOrder(row, row.getAttribute('data-default-lead-time') || FALLBACK_LEAD_TIME);
    if (serviceNote) serviceNote.textContent = 'Cutting after coating will leave exposed raw edges.';
    try { aaPeRow(row, resolved, row.getAttribute('data-default-lead-time') || FALLBACK_LEAD_TIME); } catch (aaPeErr) { /* display only */ }
  } else {
    updateSimpleBadge(row, resolved);
    if (finishNote) {
      if (resolved.type === 'stock') {
        finishNote.textContent = 'Stocked pre-finished — full bars, no half lengths';
      } else if (resolved.isHalf) {
        finishNote.textContent = 'Half length selected';
      } else if (row.getAttribute('data-has-finish') === 'false') {
        /* r-1dmerge: a single-finish product names its finish instead of claiming
           "Mill finish selected", which would be wrong on an anodised or pre-finished
           line. LIVE ON 69 OF THE 70 RHS / round tube / square tube rows - this is the
           branch that made an engine swap unsafe and a merge necessary. */
        finishNote.textContent = row.getAttribute('data-single-finish') || '';
      } else {
        finishNote.textContent = 'Mill finish selected';
      }
    }
    if (serviceNote) {
      serviceNote.textContent = resolved.type === 'stock'
        ? 'Cutting after finishing will leave exposed raw edges.'
        : 'Cutting can be added to this item.';
    }
  }
  updateMinSaleDisplay(row, resolved);

  if (addBtn) {
    addBtn.disabled = resolved.type !== 'custom' && !resolved.isAvailable;
    addBtn.style.opacity = addBtn.disabled ? '0.45' : '1';
    addBtn.style.cursor = addBtn.disabled ? 'not-allowed' : 'pointer';
  }

  updateCutWarnings(row);
  updateCutEstimate(row);
}

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    });

    if (!response.ok) throw new Error('Could not load cart.');
    return await response.json();
  }

  function cartHasVariant(cart, variantId) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function(item) {
      return Number(item.id) === Number(variantId);
    });
  }

  async function addItemsToCart(items) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    });

    if (!response.ok) {
      let err;
      try {
        err = await response.json();
      } catch (e) {
        throw new Error('Could not add items to cart.');
      }
      throw err;
    }

    return await response.json();
  }

  async function refreshCartUi() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated'));

      var cartJson = await fetchCart();
      var selectors = [
        '[data-cart-count]',
        '.cart-count',
        '.header__cart-count',
        '.site-header__cart-count',
        '.cart-link__count'
      ];
      document.querySelectorAll(selectors.join(',')).forEach(function(el) {
        el.textContent = cartJson.item_count;
      });
    } catch (e) {
      console.log('Cart UI refresh skipped', e);
    }
  }

  function getCutRowsData(panelRow) {
    var items = [];
    panelRow.querySelectorAll('.aa-cut-row').forEach(function(rowEl) {
      var qty = Math.max(parseInt(rowEl.querySelector('.aa-cut-qty').value, 10) || 0, 0);
      var len = Math.max(parseInt(rowEl.querySelector('.aa-cut-length').value, 10) || 0, 0);

      if (qty > 0 && len > 0) {
        for (var i = 0; i < qty; i++) {
          items.push(len);
        }
      }
    });
    return items;
  }

  // ---------------------------------------------------------------------------
  // AluCut server. The cut optimiser NO LONGER RUNS IN THE BROWSER.
  //
  // What used to be here: packPiecesIntoBins(), enumerateCounts() and
  // buildMaterialPlanFromCandidates() — the exhaustive search over how many of
  // each stock length to buy, the kerf packing, the one-half-length rule and the
  // cost/waste/bar-count scoring. That is the AluCut engine and it now runs on
  // our own server. This file only sends the cut list and draws the answer.
  //
  // Candidate selection (finish, pre-cut, min sale length) stays here — it needs
  // the row's state and it is catalogue logic, not the optimiser.
  //
  // Behaviour is identical: fuzz-tested over 600 random cut lists against the
  // old in-browser code — 600/600 the same plan, same price, same layout.
  // ---------------------------------------------------------------------------
  /* Saw clamp grip (r27): every stock length the saw CUTS keeps >= 50mm of
  /* r27, superseded r191. THE CLAMP RESERVE IS NOW 0.
     r27 reserved 50mm on every bar on the theory that the saw always needs that
     much left to hold. Patryk confirmed 30 Jul that this is wrong for the up-saw:
     cutting a 6500 bar in half is ONE cut with 3250mm held either side - there is
     nothing short to clamp and nothing flying away. The old rule quietly told
     customers that 2 x 3247 needed TWO 6500 bars, and shortened every split pill
     by 25mm.
     What actually keeps it safe is AA_MIN_PIECE_MM (the smallest piece we will
     cut at all), not a blanket tax on every bar.
     Editable: Customize -> this section -> Cutting limits -> "Clamp reserve".
     Put 50 back there if the shop floor ever disagrees - no code change. The
     worker has the same default (PT_GRIP_MM). If this is set HIGHER than the
     worker the storefront is simply stricter, which is the safe direction. */
  var AA_GRIP_MM = Number(AA_CT_CFG.aa_clamp_reserve_mm) || 0;
  /* r191: what counts as an offcut worth keeping. Was AA_GRIP_MM + 10 (60mm),
     which only made sense while a 50mm clamp remnant existed. Patryk 30 Jul:
     a 40mm drop goes in the showroom and sells; below that it is binned. So
     this is a SALEABILITY threshold now, not a machine one, and it is set
     where the other limits are - Customize -> Cutting limits. */
  var AA_MIN_OFFCUT_MM = Number(AA_CT_CFG.aa_min_offcut_mm) || 40;

  /* r189: the two short-piece rules, one constant each.
     AA_MIN_PIECE_MM is a HARD limit and deliberately the SAME 50mm as the clamp
     grip - one number for the whole up-saw, nothing new to remember. Under it the
     vice cannot hold the work: unsafe and slow, so the cut list is refused rather
     than quoted.
     AA_SHORT_PIECE_MM is ADVISORY. Above the minimum but under 100mm the cut is
     fine, but the piece can bow or twist depending on the alloy, the wall
     thickness and the profile - more so on narrow strips. The customer is told,
     never stopped.
     Before r189 NOTHING enforced either: the length input was min="1", so a 5mm
     piece priced, planned and sold. */
  /* r190: both numbers are now EDITABLE, no code change needed.
     Theme customizer -> this section -> "Cutting limits" sets the default for
     the whole collection. A single product overrides it with the metafield
     custom.minimum_cut_length_mm (read off data-min-piece on the row).
     Blank or zero falls back to the literal here. This is NOT the clamp
     reserve - see AA_GRIP_MM above, which r191 took to 0. */
  var AA_MIN_PIECE_MM = Number(AA_CT_CFG.aa_min_cut_mm) || 40;
  var AA_SHORT_PIECE_MM = Number(AA_CT_CFG.aa_short_piece_mm) || 100;
  /* r188, revised r191: a remainder too short to be worth anything is saw waste,
     not an offcut, and the customer must not be told they are getting one.
     r191 DECOUPLED this from the clamp reserve. It used to read AA_GRIP_MM + 10,
     which was fine while the reserve was 50 - but the reserve is now 0 and that
     would have called a 10mm sliver an offcut. Usable-offcut is its own idea and
     now its own number.
     NOTE: the Cut Map keeps the raw physical remainder. Its format is parsed
     (the OS regex requires the literal [offcut Nmm]) and the material really is
     on the bar - the production sheet SHOULD draw it. Only the human-facing
     places change here. */
  function aaOffcutMm(rem) {
    var n = Math.round(Number(rem) || 0);
    return n >= AA_MIN_OFFCUT_MM ? n : 0;
  }
  var AA_PLAN_ENDPOINT = 'https://alucut.allaluminium.workers.dev/quote';
  // Route the worker call through the shared session gate when present (attaches the
  // Turnstile session when the gate is on; plain fetch when off). Returns a
  // Response-like object so the existing .then(r=>r.json()) chain keeps working.
  function aaFetch(url, opts){
    /* r-one-gate-2 22 Aug 2026: was AACut.quote first - its own full session cycle -
       and the theme.liquid wrapper then gated the SAME request again. Plain fetch:
       the wrapper is the single gate (visible challenge, shared stored pass,
       fail-fast). One security check covers the whole store for its lifetime. */
    return fetch(url, opts);
  }
  var AA_PLAN_CACHE = {};

  function aaPlanKey(candidates, pieceLengths) {
    return JSON.stringify([
      candidates.map(function (c) { return [c.lengthMm, c.priceCents, c.isHalf ? 1 : 0]; }),
      pieceLengths.slice().sort(function (a, b) { return a - b; })
    ]);
  }

  function aaBlankPlan(candidates, possible, label) {
    return {
      possible: possible,
      bars: [],
      combo: [],
      candidates: candidates,
      totalCost: 0,
      totalWaste: 0,
      planLabel: label
    };
  }

  // Re-attach our own candidate objects to the server's answer (it returns indexes,
  // never our variant data) and rebuild the exact shape the rest of this file expects.
  function aaHydratePlan(res, candidates) {
    if (!res || res.ok === false) {
      /* 14 Aug: NOT the same thing as "does not fit". Flagged so the panel
         stops telling the customer their measurements are impossible when
         the planner simply did not answer. */
      var aaBp = aaBlankPlan(candidates, false, 'Could not reach the cut planner. Please try again.');
      aaBp.unreachable = true;
      return aaBp;
    }
    if (!res.possible) {
      return aaBlankPlan(candidates, false, res.planLabel || 'Cut list exceeds available stock options');
    }
    var combo = (res.combo || []).map(function (item) {
      return { candidate: candidates[item.index], quantity: item.quantity };
    });
    var bars = (res.bars || []).map(function (b) {
      return { length: b.length, remaining: b.remaining, pieces: b.pieces || [], kerfs: b.kerfs || [] };
    });
    return {
      possible: true,
      bars: bars,
      combo: combo,
      candidates: candidates,
      totalCost: res.totalCost || 0,
      totalWaste: res.totalWaste || 0,
      planLabel: combo.map(function (i) { return i.quantity + ' × ' + i.candidate.lengthMm + 'mm'; }).join(' + ')
    };
  }

  /* r-bestlength 13 Sep 2026 -------------------------------------------------------------
     THE OPTIMISER WAS ONLY EVER SHOWN ONE STOCK LENGTH. getCandidateStockOptions ends with
     `&& !opt.isPrecut`, so with a full length selected the pre-cut lengths never reached the
     planner. Angle 100x100x6, one 50mm cut: 1 x 6500mm $369.82, when 1 x 1000mm is $71.12.
     27 active products are affected; worst is Channel 177.8x76.2 at $802.79 over, and the
     worst multiple is Angle 80x80x10 at 10.4x.

     THE OBVIOUS FIX - delete that condition and send all seven at once - DOES NOT WORK, and
     I measured it against the live worker before writing this:
         3 x 2162mm, 1 candidate  -> 200 in 0.49s
         3 x 2162mm, 4 candidates -> 200 in 0.21s
         3 x 2162mm, 7 candidates -> 503 AFTER 36 SECONDS, body 'exceeded'
     buildMaterialPlan enumerates the FULL cartesian product of "how many of each length",
     and calls ptPack on every combination. Seven lengths x ~10 bars each is ~10^7 packs.
     The old comment blamed the browser; the packing moved to the worker and the blow-up
     moved with it. A single 50mm piece with 7 candidates DOES answer in 0.64s - testing
     only the easy case is exactly how a one-line "fix" would have shipped.

     SO: THE BROWSER CHOOSES THE LIST, THE SERVER STILL PRICES IT. ptPack/ptEnumerate are
     ported below, byte-for-behaviour, and used ONLY to decide which candidate list to send.
     The server then re-plans that list and its answer is the number shown and charged, as
     it always has been. THE SAFETY PROPERTY THIS BUYS: if the port below is ever wrong, the
     customer gets a SUBOPTIMAL length - never a wrong price. Nothing about how money is
     computed moves into the browser.

     Two searches, both exact, both local, both instant:
       A  cheapest plan on ONE length, over every length including pre-cuts
       B  cheapest MIXED plan over today's legacy list (2-3 lengths - a tiny space)
     Whichever is cheaper is the list that gets sent, so this can never price worse than
     today. Still exactly ONE /quote per cut list, so the quotes log does not gain a row
     and nothing new hits the rate limiter.

     WHY THE VARIANT CANNOT COME BACK WRONG. aaHydratePlan maps combo[].index into the
     candidate array THAT WAS SENT. When A wins, the array has one element, so index can
     only be 0. add-to-cart uses item.candidate.id, so the variant is right by construction.

     ONE SOURCE OF TRUTH FOR THE LIST: aaEffectiveCandidates() is used by the estimate AND
     by aaCutPdfPlan(), which re-plans server-side. Before this they called
     getCandidateStockOptions separately, so the printed plan and the quoted plan would
     have come from different lists the moment these diverged.

     THE FINISH LOCK IS UNTOUCHED - getAutoPickCandidates reuses getCandidateStockOptions'
     filters exactly, minus only the pre-cut exclusion. r207 is explicit about the
     alternative: "Customer selects Black pre-cut, the panel prints Finish: Black, and a
     Mill bar is carted at a lower price."
     ------------------------------------------------------------------------------------ */

  /* Mirrors of the worker's constants. If these ever disagree the browser merely picks a
     worse list - the server still prices what it is sent. */
  var AA_PT_GRIP_MM = 0;         /* worker PT_GRIP_MM */
  var AA_PT_END_TRIM_MM = 50;    /* worker END_TRIM_MM, per end */

  /* worker endTrimFor(): coated loses 50mm at BOTH ends, mill loses nothing, and an
     unknown finish is NOT guessed at - it reserves nothing, same as the worker. */
  function aaPtTrimFor(finish) {
    var t = String(finish == null ? '' : finish).trim().toLowerCase();
    if (!t) return 0;
    return t.indexOf('mill') < 0 ? 2 * AA_PT_END_TRIM_MM : 0;
  }

  /* Port of the worker's ptPack. First-fit decreasing, bins longest first, and the KERF IS
     RESERVED INSIDE THE FIT TEST (`remaining >= piece + extraKerf`) - never subtracted
     afterwards, which is how a bar gets planned to [drop 0mm] and cannot be cut. */
  function aaPtPack(pieceLengths, binLengths, kerf, TRIM) {
    TRIM = TRIM || 0;
    var pieces = pieceLengths.slice().sort(function (a, b) { return b - a; });
    var bins = binLengths.map(function (length, idx) {
      return { index: idx, length: length, remaining: length, pieces: [], kerfs: [], whole: false };
    }).sort(function (a, b) { return b.length - a.length; });
    for (var p = 0; p < pieces.length; p++) {
      var piece = pieces[p];
      var placed = false;
      for (var b = 0; b < bins.length; b++) {
        var bin = bins[b];
        /* an UNCUT whole bar is sold full length, so the coating end trim does not apply */
        if (bin.pieces.length === 0 && (piece === bin.length || piece === bin.length + TRIM)) {
          bin.pieces.push(piece); bin.remaining = 0; bin.whole = true; placed = true; break;
        }
        var extraKerf = bin.pieces.length > 0 ? kerf : 0;
        if (bin.remaining >= piece + extraKerf + AA_PT_GRIP_MM) {
          if (extraKerf > 0) bin.kerfs.push(kerf);
          bin.pieces.push(piece);
          bin.remaining -= piece + extraKerf;
          placed = true; break;
        }
      }
      if (!placed) return { possible: false, bars: [] };
    }
    return { possible: true, bars: bins };
  }

  /* Port of the worker's maxBars bound. Same formula, same +3. */
  function aaPtMaxBars(caps, pieceLengths) {
    var total = pieceLengths.reduce(function (s, l) { return s + l; }, 0);
    var smallest = caps.reduce(function (m, c) { return Math.min(m, c); }, caps[0]);
    return Math.ceil(total / Math.max(1, smallest - AA_PT_GRIP_MM)) + 3;
  }

  /* Port of buildMaterialPlan's scoring: cheapest cost, then least waste, then fewest bars. */
  function aaPtBetter(score, best) {
    if (!best) return true;
    if (score.totalCost !== best.totalCost) return score.totalCost < best.totalCost;
    if (score.totalWaste !== best.totalWaste) return score.totalWaste < best.totalWaste;
    return score.barCount < best.barCount;
  }

  /* SEARCH A - the cheapest plan that uses a SINGLE length, over every candidate.
     One length means the count is the only variable, so this is a short linear scan per
     candidate, not an enumeration. Returns null when nothing fits. */
  function aaBestSingleCandidate(list, pieceLengths, kerf, TRIM) {
    var best = null;
    for (var i = 0; i < list.length; i++) {
      var c = list[i];
      var len = Number(c.lengthMm);
      if (!(len > 0)) continue;
      var cap = len - TRIM;
      var limit = c.isHalf ? 1 : aaPtMaxBars([cap], pieceLengths);
      for (var n = 1; n <= limit; n++) {
        var bins = [];
        for (var k = 0; k < n; k++) bins.push(cap);
        var packed = aaPtPack(pieceLengths, bins, kerf, TRIM);
        if (!packed.possible) continue;
        var score = {
          totalCost: Number(c.priceCents) * n,
          totalWaste: packed.bars.reduce(function (s, b) { return s + b.remaining; }, 0),
          barCount: n
        };
        /* cost only grows with n, so the first n that fits is this candidate's best */
        if (aaPtBetter(score, best)) best = { candidate: c, totalCost: score.totalCost, totalWaste: score.totalWaste, barCount: n };
        break;
      }
    }
    return best;
  }

  /* SEARCH B - today's behaviour, reproduced locally: the full mixed enumeration over the
     LEGACY list. That list is the non-pre-cut lengths, normally two (full and half), so the
     space is a few dozen packs. This exists ONLY so search A can never be chosen when the
     mixed plan it replaces was cheaper. Bails out rather than grinding if the space is big. */
  function aaBestMixedPlan(list, pieceLengths, kerf, TRIM) {
    if (!list.length) return null;
    var caps = list.map(function (c) { return Number(c.lengthMm) - TRIM; });
    var maxBars = aaPtMaxBars(caps, pieceLengths);
    var maxCounts = list.map(function (c) { return c.isHalf ? 1 : maxBars; });
    var space = maxCounts.reduce(function (s, m) { return s * (m + 1); }, 1);
    if (space > 20000) return null;            /* never freeze the browser - see above */
    var best = null;
    var counts = new Array(list.length).fill(0);
    (function walk(index) {
      if (index >= list.length) {
        var half = 0, barCount = 0, bins = [], cost = 0;
        for (var i = 0; i < list.length; i++) {
          if (list[i].isHalf) half += counts[i];
          barCount += counts[i];
          cost += Number(list[i].priceCents) * counts[i];
          for (var k = 0; k < counts[i]; k++) bins.push(caps[i]);
        }
        if (half > 1 || barCount === 0) return;
        var packed = aaPtPack(pieceLengths, bins, kerf, TRIM);
        if (!packed.possible) return;
        var score = {
          totalCost: cost,
          totalWaste: packed.bars.reduce(function (s, b) { return s + b.remaining; }, 0),
          barCount: barCount
        };
        if (aaPtBetter(score, best)) best = { totalCost: score.totalCost, totalWaste: score.totalWaste, barCount: barCount };
        return;
      }
      for (var n = 0; n <= maxCounts[index]; n++) { counts[index] = n; walk(index + 1); }
      counts[index] = 0;
    })(0);
    return best;
  }

  /* Same filters as getCandidateStockOptions - INCLUDING the half-length and minimum-sale
     rules, which is the whole reason this is a copy rather than a call with a flag - minus
     only `!opt.isPrecut`, and minus the early return that locks the list to a selected
     pre-cut length. */
  function getAutoPickCandidates(row) {
    /* r-1dmerge: ported from the RHS engine, whose own note called this "the reason
       this file could not be patched blind". A row with no length to choose between
       has nothing for the best-length picker to pick. Returning [] makes
       aaEffectiveCandidates fall through to the legacy list, and aaBuildAutoLenToggle
       then counts 0 lengths and keeps the tick box hidden - so the row never shows a
       control it cannot use. WITHOUT THIS LINE the picker would run on a shape it was
       never built for. */
    if (row.getAttribute('data-has-length') === 'false') return [];
    var selected = selectedVariantData(row);
    var allOptions = getAllVariantOptions(row);
    var minSaleLength = Number(row.getAttribute('data-min-sale') || 0);
    var powderFullLengthOnly = row.getAttribute('data-powder-full-length-only') === 'true';
    var seen = {};
    var lockColour = normalizeColour(aaCutFinishLabel(row) || '');
    var lockedOpt = lockColour
      ? allOptions.filter(function (o) { return normalizeColour(o.finishLabel || '') === lockColour; })[0]
      : null;
    var effType = lockedOpt ? lockedOpt.type : selected.type;

    return allOptions.filter(function (opt) {
      return opt.lengthMm > 0 && opt.type === effType;          /* pre-cuts ALLOWED here */
    }).filter(function (opt) {
      if (!lockColour) return true;
      return normalizeColour(opt.finishLabel || '') === lockColour;
    }).filter(function (opt) {
      /* A PRE-CUT IS NEVER A HALF LENGTH, so this rule is carried over unchanged and still
         only ever removes half bars. Copying it matters anyway: if it is dropped, a half
         bar that today cannot be bought becomes buyable through the optimiser. */
      if (effType === 'stock' || effType === 'custom') return !opt.isHalf;
      if (effType === 'custom' && powderFullLengthOnly) return !opt.isHalf;
      if (effType === 'mill' && minSaleLength > 0) return Number(opt.lengthMm) >= minSaleLength;
      return true;
    }).filter(function (opt) {
      var key = [opt.type, normalizeColour(opt.finishLabel || ''), Number(opt.lengthMm || 0), opt.isHalf ? 'half' : 'full'].join('|');
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    }).sort(function (a, b) {
      if (a.priceCents !== b.priceCents) return a.priceCents - b.priceCents;
      return a.lengthMm - b.lengthMm;
    });
  }

  /* The toggle. Default ON for the bar tables - and that is the ONE place this deliberately
     differs from collection-table-sheets, which defaults to "use selected". On sheets the
     customer PICKED a sheet size; here the length dropdown defaults to the full length with
     no choice made at all, so honouring "what you selected" honours a choice nobody made. */
  function aaAutoPickOn(panelRow) {
    if (!panelRow) return true;
    var cb = panelRow.querySelector('.aa-cut-autolen');
    return cb ? !!cb.checked : true;
  }

  /* THE ONE PLACE THAT DECIDES WHICH LENGTHS GET PRICED. Used by the estimate and by the
     cut-plan PDF, which re-plans on the server - they must never ask different questions. */
  function aaEffectiveCandidates(row, panelRow, pieceLengths) {
    var legacy = getCandidateStockOptions(row);
    /* CAUGHT IN THE BROWSER ON STAGING, 13 Sep: these two early returns used to leave
       row._aaBestLen holding the LAST auto-picked length, so unticking the box showed
       "Using 1 x 500mm" sitting directly under a price for 1 x 2000mm. The number was
       right and the sentence beside it was not, which is the one shape this panel must
       never have. EVERY path out of this function now sets _aaBestLen, including the
       failure paths. */
    if (!aaAutoPickOn(panelRow)) { row._aaBestLen = null; return legacy; }
    if (!pieceLengths || !pieceLengths.length) { row._aaBestLen = null; return legacy; }
    try {
      var list = getAutoPickCandidates(row);
      if (!list || list.length < 2) { row._aaBestLen = null; return legacy; }
      var fin = (typeof aaCutFinishLabel === 'function' ? (aaCutFinishLabel(row) || '') : '');
      var TRIM = aaPtTrimFor(fin);
      var single = aaBestSingleCandidate(list, pieceLengths, 6, TRIM);
      if (!single) { row._aaBestLen = null; return legacy; }
      var mixed = aaBestMixedPlan(legacy, pieceLengths, 6, TRIM);
      /* Only move off today's list when the single length is STRICTLY cheaper. A tie keeps
         the customer on the length they selected. */
      if (mixed && mixed.totalCost <= single.totalCost) { row._aaBestLen = null; return legacy; }
      /* Stashed for the note only. THE NOTE PRINTS A SAVING ONLY IF THE SERVER LATER AGREES
         WITH predictedCents FOR THIS EXACT LIST - see the note writer in updateCutEstimate.
         Two numbers from two sources beside each other is how a page ends up contradicting
         itself; this one refuses to print rather than guess. */
      row._aaBestLen = {
        chosenLen: Number(single.candidate.lengthMm),
        bars: single.barCount,
        predictedCents: single.totalCost,
        legacyCents: mixed ? mixed.totalCost : null
      };
      return [single.candidate];
    } catch (e) {
      row._aaBestLen = null;
      return legacy;
    }
  }

  function buildMaterialPlanFromCandidates(candidates, pieceLengths, row) {
    if (!pieceLengths.length || !candidates.length) {
      return aaBlankPlan(candidates, pieceLengths.length === 0, 'Not calculated');
    }

    /* r-endtrim: the finish is now part of the plan, so it MUST be part of the cache
       key. Without it a mill plan and a black plan for the same cut list would share
       one cached answer and the second one asked would get the first one's bar count. */
    var _fin = (typeof aaCutFinishLabel === 'function' ? (aaCutFinishLabel(row) || '') : '');
    var key = aaPlanKey(candidates, pieceLengths) + '|fin:' + _fin;
    var hit = AA_PLAN_CACHE[key];

    // already answered — return it synchronously, exactly like the old code did
    if (hit && hit.done) return aaHydratePlan(hit.res, candidates);

    // not asked yet — ask, and re-render this row when the answer lands
    if (!hit) {
      AA_PLAN_CACHE[key] = { done: false };
      aaFetch(AA_PLAN_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          mode: 'plan-table',
          kerfMm: 6,
          candidates: candidates.map(function (c) {
            return { lengthMm: c.lengthMm, priceCents: c.priceCents, isHalf: !!c.isHalf };
          }),
          /* r-endtrim: the optimiser was blind to colour. It has to know, or it plans a
             coated bar as 6500mm of good material when only 6400mm of it is usable. */
          finish: _fin,
          pieces: pieceLengths,
          // r32: name the product so the quote log can rebuild links
          pHandle: row ? (row.getAttribute('data-handle') || '') : '',
          pTitle: row ? (row.getAttribute('data-quick-title') || '') : '',
          pPath: location.pathname,
          /* r41: signed-in customer identity. The keys are undefined when the
             customer is logged out, so JSON.stringify drops them and the
             request body stays byte-identical to the legacy shape. */
          custEmail: (window.AA_CUT_CFG || {}).custEmail,
          custName: (window.AA_CUT_CFG || {}).custName,
          custStaff: (window.AA_CUT_CFG || {}).custStaff
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          AA_PLAN_CACHE[key] = { done: true, res: j };
          if (row) updateCutEstimate(row);
        })
        .catch(function () {
          AA_PLAN_CACHE[key] = { done: true, res: { ok: false } };
          if (row) updateCutEstimate(row);
        });
    }

    // in flight — show the row as "working" for the ~100ms round trip
    return aaBlankPlan(candidates, true, 'Working out the best plan…');
  }

  function barSignature(bar) {
    var parts = [];
    var first = true;
    bar.pieces.forEach(function(piece) {
      if (!first) parts.push('kerf6');
      parts.push('piece' + piece);
      first = false;
    });
    if (bar.remaining > 0) {
      parts.push('offcut' + Math.round(bar.remaining));
    }
    return parts.join('|');
  }

  function renderCutVisual(panelRow, bars) {
    var wrap = panelRow.querySelector('.aa-cut-visual-wrap');
    var visual = panelRow.querySelector('.aa-cut-visual');
    var toggleBtn = panelRow.querySelector('.aa-cut-toggle-full-visual');
    var summaryWrap = panelRow.querySelector('.aa-cut-visual-summary');
    var summaryText = panelRow.querySelector('.aa-cut-visual-summary-text');

    if (!wrap || !visual || !toggleBtn || !summaryWrap || !summaryText) return;

    if (!bars || !bars.length) {
      wrap.style.display = 'none';
      summaryWrap.style.display = 'none';
      visual.innerHTML = '';
      toggleBtn.style.display = 'none';
      return;
    }

    var grouped = {};
    bars.forEach(function(bar) {
      var sig = barSignature(bar);
      if (!grouped[sig]) grouped[sig] = { count: 0, bar: bar };
      grouped[sig].count += 1;
    });

    var groupedArray = Object.keys(grouped).map(function(key) {
      return grouped[key];
    });

    var groupedLines = groupedArray.map(function(group) {
      var bar = group.bar;
      var count = group.count;
      var parts = [];
      var first = true;

      bar.pieces.forEach(function(piece) {
        if (!first) parts.push('kerf 6');
        parts.push(piece);
        first = false;
      });

      if (bar.remaining > 0 && aaOffcutMm(bar.remaining) > 0) {
        parts.push('offcut ' + Math.round(bar.remaining));
      }

      return count + ' × ' + bar.length + 'mm: ' + parts.join(' + ');
    });

    summaryWrap.style.display = 'none';
summaryText.innerHTML = '';

    // Build colour map: each unique cut length gets its own colour, consistent across all bars
    var PIECE_COLOURS = ['#14b8a6','#6366f1','#f97316','#ec4899','#8b5cf6','#0ea5e9','#22c55e','#f59e0b'];
    var PIECE_TEXT_COLOURS = ['#fff','#fff','#fff','#fff','#fff','#fff','#fff','#fff'];
    var allPieceLengths = {};
    bars.forEach(function(b) {
      b.pieces.forEach(function(p) { allPieceLengths[p] = true; });
    });
    var colourMap = {};
    Object.keys(allPieceLengths).sort(function(a,b){return Number(a)-Number(b);}).forEach(function(len, i) {
      colourMap[len] = {
        bg: PIECE_COLOURS[i % PIECE_COLOURS.length],
        text: PIECE_TEXT_COLOURS[i % PIECE_TEXT_COLOURS.length]
      };
    });

    // Build legend if more than one unique size
    var uniqueSizes = Object.keys(colourMap);
    if (uniqueSizes.length > 1) {
      var legend = document.createElement('div');
      legend.style.display = 'flex';
      legend.style.flexWrap = 'wrap';
      legend.style.gap = '8px';
      legend.style.marginBottom = '10px';
      uniqueSizes.forEach(function(len) {
        var item = document.createElement('div');
        item.style.display = 'flex';
        item.style.alignItems = 'center';
        item.style.gap = '5px';
        item.style.fontSize = '11px';
        item.style.color = '#475569';
        var dot = document.createElement('span');
        dot.style.width = '10px';
        dot.style.height = '10px';
        dot.style.borderRadius = '2px';
        dot.style.background = colourMap[len].bg;
        dot.style.flexShrink = '0';
        item.appendChild(dot);
        item.appendChild(document.createTextNode(len + 'mm'));
        legend.appendChild(item);
      });
      visual.appendChild(legend);
    }

    wrap.style.display = 'block';
    visual.innerHTML = '';
    if (uniqueSizes.length > 1) visual.appendChild(legend);

    var expanded = panelRow.dataset.fullVisual === 'true';
    var groupsToShow = expanded ? groupedArray : groupedArray.slice(0, MAX_VISUAL_GROUPS);

    if (groupedArray.length > MAX_VISUAL_GROUPS) {
      toggleBtn.style.display = 'inline-block';
      toggleBtn.textContent = expanded ? 'Show compact layout' : 'Show full layout';
    } else {
      toggleBtn.style.display = 'none';
    }

    if (!expanded && groupedArray.length > MAX_VISUAL_GROUPS) {
      var helper = document.createElement('div');
      helper.style.fontSize = '12px';
      helper.style.color = '#64748b';
      helper.style.marginBottom = '8px';
      helper.textContent = 'Showing first ' + MAX_VISUAL_GROUPS + ' grouped layouts of ' + groupedArray.length + ' total';
      visual.appendChild(helper);
    }

    groupsToShow.forEach(function(group) {
      var bar = group.bar;
      var count = group.count;

      var barContainer = document.createElement('div');
      barContainer.style.marginBottom = '12px';

      var title = document.createElement('div');
      title.style.fontSize = '11px';
      title.style.color = '#94a3b8';
      title.style.marginBottom = '4px';
      // Summarise what's being cut from this bar
      var totalPieces = bar.pieces.length * count;
      var uniqueLengths = {};
      bar.pieces.forEach(function(p) { uniqueLengths[p] = (uniqueLengths[p] || 0) + 1; });
      var pieceSummary = Object.keys(uniqueLengths).map(function(len) {
        return (uniqueLengths[len] * count) + ' × ' + len + 'mm';
      }).join(', ');
      var stockLabel = count > 1 ? count + ' × ' + bar.length + 'mm' : bar.length + 'mm';
      title.innerHTML = '<span style="font-weight:600;color:#475569;">Stock used: ' + stockLabel + '</span>'
        + '<span style="margin-left:8px;color:#64748b;">→ cutting ' + pieceSummary + '</span>';
      barContainer.appendChild(title);

      var track = document.createElement('div');
      track.style.height = '20px';
      track.style.width = '100%';
      track.style.background = '#e5e7eb';
      track.style.borderRadius = '999px';
      track.style.overflow = 'hidden';
      track.style.display = 'flex';

      /* r31: always draw the 6mm kerf separator between pieces -
         thin dark sliver, consistent with the print view bars. */
      var first = true;
      bar.pieces.forEach(function(piece) {
        if (!first) {
          var kerfEl = document.createElement('div');
          var kerfPct = (6 / bar.length) * 100;
          kerfEl.className = 'aa-kerf-sep';
          kerfEl.style.width = kerfPct + '%';
          kerfEl.style.minWidth = '2px';
          kerfEl.style.flexShrink = '0';
          kerfEl.style.background = '#334155';
          track.appendChild(kerfEl);
        }

        var pieceEl = document.createElement('div');
        var piecePct = (piece / bar.length) * 100;
        var pieceColour = colourMap[piece] || { bg: '#14b8a6', text: '#fff' };
        pieceEl.style.width = piecePct + '%';
        pieceEl.style.background = pieceColour.bg;
        pieceEl.style.display = 'flex';
        pieceEl.style.alignItems = 'center';
        pieceEl.style.justifyContent = 'center';
        pieceEl.style.fontSize = '10px';
        pieceEl.style.color = pieceColour.text;
        pieceEl.style.whiteSpace = 'nowrap';
        pieceEl.style.overflow = 'hidden';
        if (piecePct >= 6) pieceEl.textContent = piece;
        track.appendChild(pieceEl);
        first = false;
      });

      if (bar.remaining > 0) {
        var offcut = document.createElement('div');
        offcut.style.width = ((bar.remaining / bar.length) * 100) + '%';
        offcut.style.background = '#cbd5e1';
        offcut.style.display = 'flex';
        offcut.style.alignItems = 'center';
        offcut.style.justifyContent = 'center';
        offcut.style.fontSize = '10px';
        offcut.style.color = '#334155';
        offcut.style.whiteSpace = 'nowrap';
        /* r27: under 60mm the remainder is clamp-grip / saw-waste territory,
           not a usable offcut - plain grey bar, no label. */
        if (aaOffcutMm(bar.remaining) > 0) {
          offcut.textContent = 'Offcut ' + Math.round(bar.remaining);
        }
        track.appendChild(offcut);
      }

      barContainer.appendChild(track);
      visual.appendChild(barContainer);
    });
  }
function updateCutEstimate(row) {
  var panelRow = getCutPanelRow(row);
  if (!panelRow) return;

  var warningEl = panelRow.querySelector('.aa-cut-warning');
  var pieceLengths = getCutRowsData(panelRow);
  var cutMethod = row.getAttribute('data-cut-method') || 'up-saw';
  var family = (row.getAttribute('data-product-family') || '').toLowerCase();

  if (family !== 'sheet') {
    cutMethod = 'up-saw';
  }

  var cuttingFeePerCut = Number(row.getAttribute('data-fee-per-cut') || 3);
  var cuttingVariantIdPreview = getCuttingVariantId(row, cutMethod, cuttingFeePerCut);
  var cuttingRateCents = getCuttingRateCents(cutMethod, cuttingFeePerCut);

  var estimatedCuts = pieceLengths.length;
  var noCutCharge = row.getAttribute('data-no-charge') === 'true';
  var cuttingCapRaw = row.getAttribute('data-cut-cap');
  var cuttingCap = Number(cuttingCapRaw || 0);
  var hasCuttingCap = cuttingCap > 0;
  var cuttingCapCents = hasCuttingCap ? Math.round(cuttingCap * 100) : 0;
  var includedCutsPerProduct = Number(row.getAttribute('data-included') || 3);
  /* r-bestlength: was getCandidateStockOptions(row). Same list whenever auto-pick is off
     or there is nothing to plan; otherwise the cheapest single length, chosen locally and
     still priced by the server. The guards below (longest stock, end trim, grip) read
     `candidates`, so they now describe the list that is actually being priced. */
  var candidates = aaEffectiveCandidates(row, panelRow, pieceLengths);
  var plan;
  var includedCuts = 0;
  var chargeableCuts = 0;
  var billedCutUnits = 0;
  var rawFeeCents = 0;
  var feeCents = 0;

  var addBtn = panelRow.querySelector('.aa-cut-add-cart');
  if (addBtn) {
    /* r39: editing a cart line -> this row's button means update */
    var _aaEd = window.__aaCutEdit;
    addBtn.textContent = (_aaEd && _aaEd.key &&
      (row.getAttribute('data-handle') || '') === _aaEd.handle)
      ? 'Update cart' : 'Add cut job to cart';
    addBtn.style.background = '#12b8e5';
  }

  if (warningEl) {
    /* r-endtrim: recompute the finish note HERE, not just in updateCutWarnings. That one
       does not run on every keystroke, and when it does run the popup selection has not
       always reached aaCutFinishLabel yet - measured on staging, the note read back empty
       on a row whose popup finish was Black. This is the same source the coated ceiling
       below uses, so the two can never disagree. */
    var _fnFin = String((typeof aaCutFinishLabel === 'function' ? (aaCutFinishLabel(row) || '') : '')).toLowerCase();
    if (_fnFin) {
      warningEl.dataset.finishNote =
        (_fnFin.indexOf('mill') < 0 && typeof CUT_WARNING_TEXT === 'string' && CUT_WARNING_TEXT)
          ? CUT_WARNING_TEXT : '';
    }
    warningEl.textContent = warningEl.dataset.finishNote || '';
    warningEl.style.display = warningEl.dataset.finishNote ? 'block' : 'none';
    warningEl.dataset.warningType = warningEl.dataset.finishNote ? 'finish' : '';
  }

  if (!pieceLengths.length) {
    plan = { possible: true, bars: [], combo: [], totalCost: 0, totalWaste: 0, planLabel: 'Not calculated' };
  } else if (!candidates.length) {
    plan = { possible: false, bars: [], combo: [], totalCost: 0, totalWaste: 0, planLabel: 'No valid stock lengths available' };
    if (warningEl) {
      warningEl.textContent = 'No valid stock lengths are available for the current finish selection.';
      warningEl.textContent += (warningEl.dataset.finishNote ? '  ' + warningEl.dataset.finishNote : ''); warningEl.style.display = 'block';
      warningEl.dataset.warningType = 'nostock';
    }
  } else {
    var longestRequested = Math.max.apply(null, pieceLengths);
    var longestStock = Math.max.apply(null, candidates.map(function(c) { return c.lengthMm; }));
    /* r27: the saw needs AA_GRIP_MM (50mm) of clamped stock on every bar it
       cuts, so the longest cuttable piece is stock length minus the grip. A
       piece EXACTLY equal to a stock length is still fine - it ships uncut.
       The worker packer applies the identical rule; this is the friendlier
       message for a plan the server would reject anyway. */
    var exactLens = {};
    candidates.forEach(function(c) { exactLens[c.lengthMm] = true; });
    /* r-endtrim. Powder-coated lengths are hung by a punched hole near each end and
       anodised lengths are gripped by clamps, so the first and last 50mm of a coated
       bar cannot be sold as a finished piece: a 6500 bar yields 6400 of cuttable
       material. Mill is untouched. This mirrors the worker's END_TRIM_MM exactly; if
       the two ever disagree the storefront is merely stricter, which is the safe
       direction. A piece EXACTLY equal to a stock length is an uncut bar and is exempt
       - exactLens below already carries that.
       NOTE this is NOT AA_GRIP_MM. That one is the saw's vice, it is 0, and it stays 0. */
    var _etFin = String((typeof aaCutFinishLabel === 'function' ? (aaCutFinishLabel(row) || '') : '')).toLowerCase();
    var AA_END_TRIM_MM = (_etFin && _etFin.indexOf('mill') < 0) ? 50 : 0;
    var maxCutPiece = longestStock - AA_GRIP_MM - 2 * AA_END_TRIM_MM;
    /* r189: hard floor - see AA_MIN_PIECE_MM. */
    var rowMinPiece = Number(row.getAttribute('data-min-piece')) || AA_MIN_PIECE_MM;
    var tooShort = pieceLengths.filter(function(p) { return p < rowMinPiece; });
    var gripBlocked = pieceLengths.filter(function(p) {
      return p > maxCutPiece && !exactLens[p];
    });
    if (longestRequested > longestStock) {
      plan = { possible: false, bars: [], combo: [], totalCost: 0, totalWaste: 0, planLabel: 'Requested cut exceeds stock length' };
      if (warningEl) {
        warningEl.textContent = 'One or more requested cut lengths exceed the available stock length for this selection. Maximum available stock length: ' + longestStock + 'mm. Longest requested cut: ' + longestRequested + 'mm.';
        warningEl.textContent += (warningEl.dataset.finishNote ? '  ' + warningEl.dataset.finishNote : ''); warningEl.style.display = 'block';
        warningEl.dataset.warningType = 'overlength';
      }
    } else if (tooShort.length) {
      plan = { possible: false, bars: [], combo: [], totalCost: 0, totalWaste: 0, planLabel: 'Cut piece under the ' + rowMinPiece + 'mm minimum' };
      if (warningEl) {
        warningEl.textContent = 'The shortest piece we can cut is ' +
          rowMinPiece + 'mm - anything shorter cannot be held safely on the saw. ' +
          'Shortest length entered: ' +
          Math.min.apply(null, tooShort) + 'mm. Get in touch and we will quote ' +
          'anything shorter by hand.';
        warningEl.textContent += (warningEl.dataset.finishNote ? '  ' + warningEl.dataset.finishNote : ''); warningEl.style.display = 'block';
        warningEl.dataset.warningType = 'undersize';
      }
    } else if (gripBlocked.length) {
      plan = { possible: false, bars: [], combo: [], totalCost: 0, totalWaste: 0, planLabel: AA_END_TRIM_MM ? ('Cut exceeds usable stock length (' + AA_END_TRIM_MM + 'mm unusable at each end of a coated bar)') : 'Cut exceeds usable stock length' };
      if (warningEl) {
        warningEl.textContent = AA_END_TRIM_MM
          ? ('This finish is applied to the full length, and the first and last ' +
             AA_END_TRIM_MM + 'mm of every bar carry clamp marks or a hanging hole. ' +
             'The longest piece we can cut clean from ' + longestStock + 'mm stock is ' +
             maxCutPiece + 'mm. A piece exactly equal to a stock length is supplied ' +
             'uncut, full length.')
          : ('The saw needs ' + AA_GRIP_MM + 'mm of clamped material on ' +
             'each stock length it cuts, so the longest cut piece from ' +
             longestStock + 'mm stock is ' + maxCutPiece + 'mm. A piece ' +
             'exactly equal to a stock length is supplied uncut.');
        warningEl.textContent += (warningEl.dataset.finishNote ? '  ' + warningEl.dataset.finishNote : ''); warningEl.style.display = 'block';
        warningEl.dataset.warningType = 'overlength';
      }
    } else {
      plan = buildMaterialPlanFromCandidates(candidates, pieceLengths, row);
      if (!plan.possible && warningEl) {
        warningEl.textContent = plan.unreachable
          ? 'We could not reach the cut planner just now - your sizes are fine. Check your connection and try again in a moment.'
          : 'This cut list cannot be produced from the available stock lengths for the current selection.';
        warningEl.textContent += (warningEl.dataset.finishNote ? '  ' + warningEl.dataset.finishNote : ''); warningEl.style.display = 'block';
        warningEl.dataset.warningType = 'packing';
      }
    }
  }

  var planLabelEl = panelRow.querySelector('.aa-summary-plan-label');
  var cutsEl = panelRow.querySelector('.aa-summary-cuts');
  var feeEls = panelRow.querySelectorAll('.aa-summary-fee');
  var materialEl = panelRow.querySelector('.aa-summary-material');
  var materialNameEl = panelRow.querySelector('.aa-summary-material-name');
  var finishEl = panelRow.querySelector('.aa-summary-finish');
  var materialPriceEls = panelRow.querySelectorAll('.aa-summary-material-price');
  var totalPriceEls = panelRow.querySelectorAll('.aa-summary-total-price');
  var pricingNoteEl = panelRow.querySelector('.aa-summary-pricing-note');
  var selected = selectedVariantData(row);

  if (plan.possible && plan.combo && plan.combo.length) {
    var totalLengths = plan.combo.reduce(function(sum, item) { return sum + item.quantity; }, 0);
    includedCuts = Math.min(includedCutsPerProduct * totalLengths, MAX_FREE_CUTS);
    chargeableCuts = Math.max(0, estimatedCuts - includedCuts);
    rawFeeCents = chargeableCuts * cuttingRateCents;

    if (noCutCharge) {
      feeCents = 0;
      billedCutUnits = 0;
    } else {
      feeCents = hasCuttingCap ? Math.min(rawFeeCents, cuttingCapCents) : rawFeeCents;
      billedCutUnits = cuttingRateCents > 0 ? Math.round(feeCents / cuttingRateCents) : 0;
    }
  }

  if (planLabelEl) planLabelEl.textContent = plan.planLabel || 'Not calculated';
  if (cutsEl) cutsEl.textContent = estimatedCuts;

  // Update cuts-used display in new estimate table
  var cutsDisplayEl = panelRow.querySelector('.aa-summary-cuts-display');
  if (cutsDisplayEl) {
    if (!pieceLengths.length) {
      cutsDisplayEl.textContent = '—';
    } else if (plan.possible && includedCuts > 0) {
      var extra = Math.max(0, estimatedCuts - includedCuts);
      cutsDisplayEl.textContent = extra > 0 ? (estimatedCuts + ' cuts \u2014 ' + includedCuts + ' free, ' + extra + ' charged') : (estimatedCuts + (estimatedCuts === 1 ? ' cut' : ' cuts') + ' \u2014 free (' + includedCuts + ' included)');
    } else {
      cutsDisplayEl.textContent = estimatedCuts + (estimatedCuts === 1 ? ' cut' : ' cuts');
    }
  }

  // Show/hide visual layout placeholder in col 3
  var noVisualEl = panelRow.querySelector('.aa-cut-no-visual');
  if (noVisualEl) noVisualEl.style.display = pieceLengths.length ? 'none' : 'block';

  /* r-bestlength 13 Sep 2026 - tell the customer which length was chosen and why.
     THE SAVING IS ONLY PRINTED WHEN THE SERVER HAS CONFIRMED THE NUMBER IT IS DERIVED
     FROM. row._aaBestLen.predictedCents is what the browser's own port expected for this
     exact single-length list; plan.totalCost is what the worker actually returned for it.
     If those two ever disagree the port has drifted, and the honest thing is to name the
     length and say nothing about money rather than put a second, unproven figure on the
     screen next to a real price. A saving is also only claimed against legacyCents, which
     is what TODAY'S list would have cost for the SAME cut list - never against a different
     question. */
  var autoNoteEl = panelRow.querySelector('.aa-cut-autolen-note');
  if (autoNoteEl) {
    var bl = row._aaBestLen;
    var proven = !!(bl && plan && plan.possible && typeof plan.totalCost === 'number'
                    && plan.totalCost === bl.predictedCents);
    if (!bl || !plan || !plan.possible || !pieceLengths.length) {
      autoNoteEl.textContent = '';
      autoNoteEl.style.display = 'none';
    } else {
      var msg = 'Using ' + bl.bars + ' \u00d7 ' + bl.chosenLen + 'mm \u2014 the cheapest stock length that fits this cut list.';
      if (proven && bl.legacyCents != null && bl.legacyCents > bl.predictedCents) {
        msg += ' That is ' + moneyFromCents(bl.legacyCents - bl.predictedCents) +
               ' less than the length selected on the product row.';
      }
      autoNoteEl.textContent = msg;
      autoNoteEl.style.display = 'block';
    }
  }

  // Compact info note below estimate table
  var infoNoteEl = panelRow.querySelector('.aa-cut-info-note');
  if (infoNoteEl) {
    infoNoteEl.textContent = noCutCharge
      ? 'Cutting included at no extra charge'
      : includedCutsPerProduct + ' cuts included per length (max ' + MAX_FREE_CUTS + ' free per order) · ' + moneyFromCents(cuttingRateCents) + ' per cut after · ±2mm tolerance';
    /* r189: advisory only - the plan stays valid, the customer is just told. */
    if (pieceLengths.some(function (p) { return p < AA_SHORT_PIECE_MM; })) {
      infoNoteEl.textContent += ' · pieces under ' + AA_SHORT_PIECE_MM + 'mm may bow or twist';
    }
    /* r-endtrim NEAR MISS. Losing a piece per bar to the 50mm end trim costs a whole bar, and at
       quantity it can double the material - 8 x 3200mm is 4 bars in mill and 8 in black, because
       2 x 3200 + 6mm kerf is 6406mm and a coated bar yields 6400mm. Six millimetres. A customer
       who is told can shave 3mm off each piece and halve the bill; one who is not just pays.
       ONLY stated for a cut list of a single repeated length, where the arithmetic is exact.
       A mixed list gets NO claim rather than a guess. */
    try {
      var _nmTrim = (typeof AA_END_TRIM_MM === 'number') ? AA_END_TRIM_MM : 0;
      if (_nmTrim > 0 && pieceLengths.length > 1) {
        var _nmL = pieceLengths[0], _nmUniform = pieceLengths.every(function (p) { return p === _nmL; });
        var _nmStock = 0, _i;
        for (_i = 0; _i < candidates.length; _i++) if (candidates[_i].lengthMm > _nmStock) _nmStock = candidates[_i].lengthMm;
        var _nmKerf = 6;
        if (_nmUniform && _nmL > 0 && _nmStock > 0) {
          var _nmUse = _nmStock - 2 * _nmTrim;
          var _perFull = Math.floor((_nmStock + _nmKerf) / (_nmL + _nmKerf));
          var _perCoat = Math.floor((_nmUse + _nmKerf) / (_nmL + _nmKerf));
          if (_perCoat < _perFull && _perFull > 0) {
            var _over = (_perFull * _nmL + (_perFull - 1) * _nmKerf) - _nmUse;
            var _shave = Math.ceil(_over / _perFull);
            if (_over > 0 && _shave > 0 && _shave < _nmL) {
              infoNoteEl.textContent += ' · ' + _perFull + ' x ' + _nmL + 'mm would fit one bar, but this finish loses ' +
                _nmTrim + 'mm at each end — you are ' + _over + 'mm over, so only ' + _perCoat +
                ' fit per bar. ' + _shave + 'mm off each piece (' + (_nmL - _shave) + 'mm) would get ' + _perFull + ' back.';
            }
          }
        }
      }
    } catch (_nmE) { /* a hint must never break the estimate */ }
  }

  feeEls.forEach(function(feeEl) {
    if (noCutCharge) {
      feeEl.textContent = moneyFromCents(rawFeeCents) + ' (Free)';
    } else if (hasCuttingCap && rawFeeCents > cuttingCapCents) {
      feeEl.textContent = moneyFromCents(rawFeeCents) + ' → capped at ' + moneyFromCents(feeCents);
    } else {
      feeEl.textContent = moneyFromCents(feeCents);
    }
  });

  if (pricingNoteEl) {
    pricingNoteEl.textContent = noCutCharge
      ? 'Cutting currently included at no extra charge.'
      : 'Includes ' + includedCutsPerProduct + ' cuts per length. Extra cuts charged at ' + moneyFromCents(cuttingRateCents) + ' each' + (hasCuttingCap ? ' and capped at ' + moneyFromCents(cuttingCapCents) + ' per row.' : '.');
  }

  if (materialNameEl) materialNameEl.textContent = row.getAttribute('data-quick-title') || 'Selected material';
  /* r-1dmerge: the full-length-only shape again. Its finish comes off the simple
     selector, not the cut panel's finish control, and it shows the bare-edge note.
     Both gated on data-has-length="false", which no 1D collection row carries. */
  var aaIsFlOnly = row.getAttribute('data-has-length') === 'false';
  var aaBareEdgeNote = panelRow.querySelector('.aa-fl-bare-edge-note');
  if (aaBareEdgeNote) aaBareEdgeNote.style.display = aaIsFlOnly ? 'block' : 'none';
  if (finishEl) {
    var aaFlFinishLabel = '';
    if (aaIsFlOnly) {
      var aaFlS = row.querySelector('select.aa-fl-finish');
      if (aaFlS && aaFlS.options.length) { aaFlFinishLabel = (aaFlS.options[aaFlS.selectedIndex] || aaFlS.options[0]).textContent.trim(); }
      else { var aaSf = row.querySelector('.aa-fl-single-finish'); if (aaSf) aaFlFinishLabel = aaSf.textContent.trim(); }
    }
    finishEl.textContent = aaFlFinishLabel || aaCutFinishLabel(row) || ((selected && selected.finish) ? selected.finish : 'Mill Finish');
  }

  // Update lead time text based on whether a powder coat finish is selected
  var leadTimeEl = panelRow.querySelector('.aa-cut-leadtime-text');
  if (leadTimeEl) {
    var selectedFinish = (aaCutFinishLabel(row) || (selected && selected.finish) || '').toLowerCase();
    /* selectedFinish already comes from the popup. The row's variant type must
       NOT get a vote or a mill row would force the powder-coat lead time onto a
       mill cut job. */
    var isPowderCoat = selectedFinish.indexOf('powder coat') > -1;
    if (isPowderCoat) {
      var pcLeadTime = row.getAttribute('data-default-lead-time') || '2–3 weeks';
      leadTimeEl.textContent = pcLeadTime + ' (powder coat) + 1–3 business days (cutting)';
    } else {
      leadTimeEl.textContent = 'Ready in 1–3 business days';
    }
  }

  /* End-of-length note. It read the ROW's finish, so choosing a powder coat in
     the popup while the row showed Mill hid it - exactly when it is needed. Reads
     the popup now, and the wording follows the finish actually chosen: a
     powder-coat customer is not told about anodising clamp marks.
     Why 50mm: coated lengths hang by a hole punched near each end, anodised
     lengths are gripped by clamps. Both leave the last ~50mm unreliable. */
  var coatedNoteEl = panelRow.querySelector('.aa-cut-note-coated');
  if (coatedNoteEl) {
    var coatedTextEl = coatedNoteEl.querySelector('.aa-cut-note-coated-text');
    var finLower = String(aaCutFinishLabel(row) || '').toLowerCase();
    if (!finLower || finLower.indexOf('mill') > -1) {
      coatedNoteEl.style.display = 'none';
    } else {
      if (coatedTextEl) {
        coatedTextEl.textContent = finLower.indexOf('anodis') > -1
          ? 'Anodised lengths are clamped at both ends - that contact spot is the one place the finish cannot form, so it is bare there and outdoors it will weather differently. Allow up to 50mm from each end of the full length when planning your cuts.'
          : 'Powder-coated lengths are hung for coating on a punched hole of about 10mm - usually one end, sometimes both. Allow up to 50mm from each end of the full length when planning your cuts.';
        /* the "Why 50mm?" link. The panel is built once per page by aaEndtrimPanel();
           this runs per ROW, so it only ever adds the button. Idempotent - these tables
           re-render a row on every finish change. */
        if (!coatedTextEl.parentNode.querySelector('.aa-endtrim-why')) {
          try { aaEndtrimPanel(); } catch (e) {}
          var aaWhy = document.createElement('button');
          aaWhy.type = 'button';
          aaWhy.className = 'aa-endtrim-why';
          aaWhy.setAttribute('data-aa-endtrim', '1');
          aaWhy.textContent = 'Why 50mm?';
          coatedTextEl.parentNode.insertBefore(aaWhy, coatedTextEl.nextSibling);
        }
      }
      coatedNoteEl.style.display = 'flex';
    }
  }

  /* Powder coat setup fee. Charged once per colour per order by the add-to-cart
     path below; it was invisible here, so a made-to-order colour quoted $50 light.
     Only custom colours carry it - stocked Black and Clear Anodised do not. */
  var pcSetupCents = 0;
  var pcSetupRow  = panelRow.querySelector('.aa-summary-pcsetup-row');
  var pcSetupEl   = panelRow.querySelector('.aa-summary-pcsetup');
  var pcSetupNote = panelRow.querySelector('.aa-summary-pcsetup-note');
  if (pcSetupRow) {
    var pcLabel = aaCutFinishLabel(row);
    var pcOpt = aaCutFinishOptions(row).filter(function (o) {
      return normalizeColour(o.label) === normalizeColour(pcLabel || '');
    })[0];
    var pcEligible =
      pcOpt && pcOpt.type === 'custom' &&
      row.getAttribute('data-powder-fee-enabled') === 'true' &&
      row.getAttribute('data-powder-available') === 'true';
    var pcEntry = pcEligible ? aaPowderFeeEntry(normalizeColour(pcOpt.powderColour || pcOpt.label)) : null;

    if (pcEntry && pcEntry.price > 0) {
      var alreadyInCart = !!(AA_CART_CACHE && cartHasVariant(AA_CART_CACHE, pcEntry.id));
      /* r655 - free once this colour reaches the coater's minimum: the cart's own lines of this colour plus the
         bars this plan buys. Asked of aa-cart-guard.js, the same rule the cart applies. */
      var aaPlanM2 = (plan && plan.combo) ? plan.combo.reduce(function (s, it) {
        return s + aaPcAreaFor(row, it.candidate && it.candidate.lengthMm, it.quantity);
      }, 0) : 0;
      var aaFree = aaPcWaived(aaPcCartForFee(AA_CART_CACHE, row) || { items: [] }, pcEntry.id, aaPlanM2);
      var aaFreeN = aaPcFreeFrom(row);
      var aaNoFee = alreadyInCart || aaFree;
      pcSetupCents = aaNoFee ? 0 : pcEntry.price;
      if (pcSetupEl) pcSetupEl.textContent = moneyFromCents(aaNoFee ? 0 : pcEntry.price);
      if (pcSetupNote) {
        pcSetupNote.textContent = aaFree
          ? 'Free - your order has enough of this colour.'
          : (alreadyInCart
            ? 'Already in your order - not charged again.'
            : ('Once per colour, per order' + (aaFreeN ? ' - free from ' + aaFreeN + ' lengths of this size. Mixed sizes in the same colour count too.' : '.')));
        pcSetupNote.style.display = 'block';
      }
      pcSetupRow.style.display = 'flex';
      /* r776c (8 Oct 2026) - the free-setup bar in the cut popup too (Patryk: "we need it to be for the whole website").
         Under the row: how close this colour is to a free setup - what the cart already holds of it (less the job being
         edited, aaPcCartForFee) plus the bars this plan buys - the very numbers the row above uses (aaPcWaived, r655), so the
         bar and the row agree. Only once the cart has been read. The setup sentence once: the bar says free / how far, the
         note keeps what explains the row's amount. DISPLAY ONLY. */
      var aaPbBox = panelRow.querySelector('.aa-summary-pcbar'), aaPbOutC = '';
      if (!aaPbBox && pcSetupNote && pcSetupNote.parentNode) {
        aaPbBox = document.createElement('div');
        aaPbBox.className = 'aa-summary-pcbar';
        aaPbBox.style.cssText = 'padding:0 0 4px;';
        pcSetupNote.parentNode.insertBefore(aaPbBox, pcSetupNote.nextSibling);
      }
      try {
        var aaPbG = window.AACartGuard, aaPbCartC = AA_CART_CACHE ? aaPcCartForFee(AA_CART_CACHE, row) : null;
        if (aaPbG && aaPbCartC && aaPbCartC.items) {
          var aaPbStC = aaPbState(aaPbG, aaPbCartC, pcEntry.id, aaPlanM2, aaPcAreaFor(row, 6500, 1), 0);
          var aaPbColC = String(pcOpt.powderColour || pcOpt.label || '').replace(/\s*powder[\s-]*coat(ed)?\s*/i, ' ').trim();
          if (aaPbStC && aaPbColC) aaPbOutC = aaPbHtml(aaPbColC, aaPbStC, pcEntry.price, 'this job', 12, '');
        }
      } catch (aaPbErrC) { aaPbOutC = ''; }
      if (aaPbBox) { aaPbBox.innerHTML = aaPbOutC; aaPbBox.style.display = aaPbOutC ? 'block' : 'none'; }
      if (aaPbOutC && pcSetupNote) {
        if (aaFree) pcSetupNote.style.display = 'none';
        else pcSetupNote.textContent = alreadyInCart ? 'Already in your order - not charged again.' : 'Once per colour, per order.';
      }
    } else {
      pcSetupRow.style.display = 'none';
      if (pcSetupNote) pcSetupNote.style.display = 'none';
      var aaPbBoxOff = panelRow.querySelector('.aa-summary-pcbar');
      if (aaPbBoxOff) { aaPbBoxOff.innerHTML = ''; aaPbBoxOff.style.display = 'none'; }
    }
  }

  materialPriceEls.forEach(function(el) {
    el.textContent = moneyFromCents(plan.totalCost || 0);
  });

  totalPriceEls.forEach(function(el) {
    el.textContent = moneyFromCents((plan.totalCost || 0) + feeCents + pcSetupCents);
  });

  /* r-pdphost 14 Sep 2026 - the inc-GST mirror of the line above.
     Same three components, so the two lines can never disagree; x1.1 is AU GST.
     FAILS CLOSED: nothing priced yet means the row stays hidden, because an empty
     money line reads as free. Display is set here, not in the markup, so a surface
     whose engine predates this shows no row rather than a blank one. */
  try {
    var aaGstCents = (plan.totalCost || 0) + feeCents + pcSetupCents;
    var aaGstRow = panelRow.querySelector('.aa-summary-incgst-row');
    var aaGstEls = panelRow.querySelectorAll('.aa-summary-total-incgst');
    for (var aaGi = 0; aaGi < aaGstEls.length; aaGi++) {
      aaGstEls[aaGi].textContent = aaGstCents > 0 ? (moneyFromCents(Math.round(aaGstCents * 1.1)) + ' inc GST') : '';
    }
    if (aaGstRow) aaGstRow.style.display = aaGstCents > 0 ? 'flex' : 'none';
  } catch (aaGstErr) {}

  if (materialEl) {
    /* NEVER "0 length(s)". The unit belongs to the product, not to this line of code - this
       file sells 4.0m flat bar, the sheets file sells 1200x2400 sheets, and other stock comes
       in 500mm and 1m. A dash says "nothing yet" in every unit. */
    if (!pieceLengths.length) materialEl.textContent = '\u2014';
    else if (plan.unreachable) materialEl.textContent = 'Waiting for the cut planner';
    else if (!plan.possible) materialEl.textContent = 'Not possible with current stock lengths';
    else materialEl.textContent = plan.combo.map(function(item) {
      return item.quantity + ' × ' + item.candidate.lengthMm + 'mm';
    }).join(' + ');

    /* MOQ applied: only worth a row when the minimum order actually CHANGES the answer - i.e.
       the customer is buying more material than their cuts asked for because of it. Showing it
       always would be noise. */
    try {
      var moqRow = panelRow.querySelector('.aa-summary-moq-row');
      var moqVal = panelRow.querySelector('.aa-summary-moq');
      var minSale = parseFloat(row.getAttribute('data-min-sale') || '0');
      if (moqRow && moqVal) {
        var askedMm = 0;
        for (var mi = 0; mi < pieceLengths.length; mi++) askedMm += pieceLengths[mi];
        if (minSale > 0 && askedMm > 0 && askedMm < minSale) {
          moqVal.textContent = (minSale / 1000) + ' m minimum';
          moqRow.style.display = 'flex';
        } else {
          moqRow.style.display = 'none';
        }
      }
    } catch (e) { /* the estimate must never die on a display nicety */ }
  }

  renderCutVisual(panelRow, plan.bars);

  panelRow.dataset.cuttingVariantId = cuttingVariantIdPreview;
  panelRow.dataset.cuttingRateCents = cuttingRateCents;
  panelRow.dataset.estimatedCuts = estimatedCuts;
  panelRow.dataset.includedCuts = includedCuts;
  panelRow.dataset.chargeableCuts = chargeableCuts;
  panelRow.dataset.chargedCuts = billedCutUnits;
  panelRow.dataset.rawFeeCents = rawFeeCents;
  panelRow.dataset.estimatedFeeCents = feeCents;
  panelRow.dataset.planPossible = plan.possible ? 'true' : 'false';
  panelRow._materialPlan = plan;
}

  /* One row template for ALL cut rows (r27). The add-row and Clear handlers
     used to carry their own copy with different input styles (padding 10px,
     no width:100%) - the number inputs then sat at intrinsic width and the
     second row's Length box drifted out of line with the first row's. Every
     row now comes from this one string, matching the Liquid-rendered first
     row exactly. Literals stay short on purpose (paste-wrap trap). */
  function aaCutRowHtml() {
    var inp = 'padding:6px 8px; border:1px solid #e5e7eb; ' +
      'border-radius:7px; font-size:12px; width:100%;';
    var h = '<div class="aa-cut-row" style="display:grid; ' +
      'grid-template-columns:70px 1fr 32px; gap:6px; margin-bottom:0;">';
    h += '<input type="number" min="1" value="1" class="aa-cut-qty"' +
      ' placeholder="Qty" style="' + inp + '">';
    h += '<input type="number" min="' + AA_MIN_PIECE_MM + '" class="aa-cut-length"' +
      ' placeholder="Length in mm" style="' + inp + '">';
    h += '<button type="button" class="aa-cut-remove" ' +
      'style="background:#f8fafc; color:#64748b; ' +
      'border:1px solid #e5e7eb; border-radius:7px; cursor:pointer; ' +
      'font-size:14px; width:30px; height:30px; display:flex; ' +
      'align-items:center; justify-content:center;">\u00d7</button>';
    h += '<div class="aa-cut-row-split">' +
      '<span class="aa-cut-split-label">Split:</span>';
    h += '<button type="button" class="aa-cut-split-btn" ' +
      'data-split="2">Half</button>';
    h += '<button type="button" class="aa-cut-split-btn" ' +
      'data-split="3">Thirds</button>';
    h += '<button type="button" class="aa-cut-split-btn" ' +
      'data-split="4">Quarters</button></div></div>';
    return h;
  }

  /* Equal-split helper: a PURE INPUT PREFILL. r27: the pills live inside
     EACH cut row and act on THAT row only - re-clicking a pill overwrites
     the same row, never stacks. Reads the length the customer has selected
     on the product row (selectedVariantData) and computes n equal pieces
     with the same maths the planner bills - kerf 6mm BETWEEN pieces, PLUS
     the 50mm saw clamp grip the packer reserves on every cut bar
     (AA_GRIP_MM, same constant the worker uses) - so n pieces always fit
     one selected length: n * piece + 6 * (n - 1) + 50 never exceeds the
     length. It writes qty and length into this row and dispatches the
     tool's own input events, exactly as manual typing would. NO engine,
     pricing or cart logic here. */
  /* ------------------------------------------------------------------
     r-split-guard  20 Aug 2026
     The Half / Thirds / Quarters chips sit ~44px directly under the row's
     own Qty and Length boxes. Pressing one used to replace that row
     instantly - no warning, no undo. Reaching for the row below turned
     4 x 1700 into 2 x 3247 with nothing on screen to say so.

     Now: an EMPTY row still fills on one click, exactly as before. A row
     that already holds a typed length (or a qty someone changed off 1)
     has to be confirmed - the chip arms for 4 seconds showing "Replace?",
     and only the second click writes. Any other click in the table, or
     the timeout, disarms it.

     The armed label is a bare text node on purpose. The delegated handler
     tests e.target.classList.contains(...), not closest(), so these chips
     must never gain a child element or the click lands on the child and
     does nothing. Do not wrap the label in a span.
     ------------------------------------------------------------------ */
  var AA_SPLIT_ARMED = null, AA_SPLIT_TIMER = null;

  function aaSplitDisarm() {
    if (!AA_SPLIT_ARMED) return;
    var b = AA_SPLIT_ARMED;
    AA_SPLIT_ARMED = null;
    if (AA_SPLIT_TIMER) { clearTimeout(AA_SPLIT_TIMER); AA_SPLIT_TIMER = null; }
    var lab = b.getAttribute('data-aa-split-label');
    if (lab !== null) { b.textContent = lab; b.removeAttribute('data-aa-split-label'); }
    b.removeAttribute('data-aa-armed');
    b.removeAttribute('title');
  }

  /* An empty row is qty blank or 1 AND length blank or 0. Anything else is
     something the customer typed and is not ours to overwrite unasked. */
  function aaSplitRowHasEntry(target) {
    var q = target.querySelector('.aa-cut-qty');
    var l = target.querySelector('.aa-cut-length');
    var lv = l ? String(l.value == null ? '' : l.value).trim() : '';
    var qv = q ? String(q.value == null ? '' : q.value).trim() : '';
    if (lv !== '' && Number(lv) > 0) return true;
    if (qv !== '' && Number(qv) > 1) return true;
    return false;
  }

  function aaSplitEqual(btn) {
    var panelRow = btn.closest('.aa-cut-panel-row');
    var row = getCutProductRow(panelRow);
    var target = btn.closest('.aa-cut-row');
    if (!panelRow || !row || !target) return;
    var n = parseInt(btn.getAttribute('data-split'), 10) || 2;
    var lenMm = 0;
    try {
      var sel = selectedVariantData(row);
      lenMm = Number(sel && sel.lengthMm) || 0;
    } catch (err) { lenMm = 0; }
    if (!lenMm) {
      /* No resolvable selection - fall back to the longest stock option. */
      getRowLengths(row).forEach(function (v) {
        var num = Number(v);
        if (num > lenMm) lenMm = num;
      });
    }
    if (!lenMm) return;
    var piece = Math.floor((lenMm - AA_GRIP_MM - 6 * (n - 1)) / n);
    if (piece < AA_MIN_PIECE_MM) return;
    var qtyEl = target.querySelector('.aa-cut-qty');
    var lenEl = target.querySelector('.aa-cut-length');
    if (!qtyEl || !lenEl) return;
    /* r-split-guard: confirm before overwriting something already typed. */
    if (AA_SPLIT_ARMED !== btn && aaSplitRowHasEntry(target)) {
      aaSplitDisarm();
      AA_SPLIT_ARMED = btn;
      btn.setAttribute('data-aa-armed', '1');
      btn.setAttribute('data-aa-split-label', btn.textContent);
      btn.setAttribute('title', 'This replaces the sizes already in this row. Press again to confirm.');
      btn.textContent = 'Replace?';
      AA_SPLIT_TIMER = setTimeout(aaSplitDisarm, 4000);
      return;
    }
    aaSplitDisarm();
    qtyEl.value = n;
    lenEl.value = piece;
    qtyEl.dispatchEvent(new Event('input', { bubbles: true }));
    lenEl.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* ------------------------------------------------------------------
     r25: Copy link / Print cut plan / Cut plan PDF for the 1D cut tool.
     Mirrors the AluPlate tool (aa-plate.min.js): the share URL is this
     page URL + p=(row handle) + cuts=QTYxLEN_QTYxLEN + job=(name); the
     print view is a client-side window; the PDF posts this tool's OWN
     plan-table quote body to the AluCut worker, which recomputes the
     bar plan server-side (a client layout is never trusted) and draws
     it. NO pricing or engine logic here - display and transport only. */
  function aaCutRowPairs(panelRow) {
    var out = [];
    panelRow.querySelectorAll('.aa-cut-row').forEach(function (rowEl) {
      var q = Math.max(parseInt(rowEl.querySelector('.aa-cut-qty').value, 10) || 0, 0);
      var l = Math.max(parseInt(rowEl.querySelector('.aa-cut-length').value, 10) || 0, 0);
      if (q > 0 && l > 0) out.push({ qty: q, len: l });
    });
    return out;
  }

  function aaCutProjectName(panelRow) {
    var el = panelRow.querySelector('.aa-cut-project');
    return el && el.value ? el.value.trim() : '';
  }

  function aaCutShareURL(panelRow, row) {
    var handle = row.getAttribute('data-handle') || '';
    var cuts = aaCutRowPairs(panelRow).map(function (p) {
      return p.qty + 'x' + p.len;
    }).join('_');
    /* finish-restore (9 Aug): carry the finish, or a reopened link
       defaults to Mill and a coloured job re-adds as the wrong metal. */
    var aaFinV = null;
    try { aaFinV = selectedVariantData(row); } catch (aaFe) { aaFinV = null; }
    /* ----------------------------------------------------------------
       r-sharelink-finish  20 Aug 2026
       This used to write the ROW's finish - the finish of the full length
       being BOUGHT. But the cut job prices off the POPUP's own select
       (.aa-cut-finish) and that is what goes on the cart line. The two are
       deliberately not synced (see aaCutFinishLabel).

       Seen live by Patryk on angle 12x12x1.6: popup set to Monument Powder
       Coat, estimate $71.64 including the $50 powder coat setup. Copy link
       produced fin=Mill%20Finish, and reopening that link quoted $11.41 -
       $60.23 less, with the setup fee gone. A quote link that changes the
       price is the same class of fault as a display/charge divergence.

       The RESTORE side was always right: it applies `fin` to BOTH the row
       select and .aa-cut-finish. Only the WRITE was wrong.

       Read the popup select directly rather than via aaCutFinishLabel, so
       this is byte-identical in all four tables - the RHS fork has no
       aaCutFinishLabel and renders no popup finish picker, where the
       fallback below leaves its behaviour exactly as it was.
       ---------------------------------------------------------------- */
    var aaFin = '';
    try {
      var aaCutFinSel = panelRow.querySelector('.aa-cut-finish');
      if (aaCutFinSel && aaCutFinSel.value) aaFin = String(aaCutFinSel.value);
    } catch (aaFe2) { aaFin = ''; }
    if (!aaFin) aaFin = (aaFinV && aaFinV.rawFinish) ? String(aaFinV.rawFinish) : '';
    /* length-restore (10 Aug): carry the selected stock length, or a
       reopened link re-quotes on the row's default length at a different
       price (proven on orders #261060 / #261059). */
    var aaLen = (aaFinV && aaFinV.lengthMm) ? String(aaFinV.lengthMm) : '';
    /* r-designlink-offcut 23 Sep 2026: carry the offcut choice. #D81's line said
       "Keep with order ... (approx. 1970mm)" and its link reopened on "No offcuts
       needed" - so a cart Edit, or re-adding from the link, quietly turned the
       offcut down. off=1 keep, off=0 not required. KEEP IS THE FIRST
       .aa-cut-offcut-checkbox (aa-cut-shell.liquid says why) - the same read the
       cart line's Offcut property makes, so the link and the line cannot disagree.
       No radios on the panel = no off, and the reader leaves the default. */
    var aaOff = '';
    try {
      var aaOffEl = panelRow.querySelector('.aa-cut-offcut-checkbox');
      if (aaOffEl) aaOff = aaOffEl.checked ? '1' : '0';
    } catch (aaOe) { aaOff = ''; }
    /* r-designlink-length 23 Sep 2026: carry "Pick the best length for my cuts"
       (.aa-cut-autolen). A job made with it UNTICKED says "Use selected length only" on
       its cart line, but its link reopened it ticked - so a job the best-length picker
       can do cheaper came back as a different length at a different price. al=1 ticked,
       al=0 unticked, read off the same box aaAutoPickOn and the line's Length mode read.
       No box on the panel = no al, and the reader leaves the default. */
    var aaAl = '';
    try {
      var aaAlEl = panelRow.querySelector('.aa-cut-autolen');
      if (aaAlEl) aaAl = aaAlEl.checked ? '1' : '0';
    } catch (aaAe) { aaAl = ''; }
    return location.origin + location.pathname +
      '?p=' + encodeURIComponent(handle) +
      '&cuts=' + cuts +
      '&job=' + encodeURIComponent(aaCutProjectName(panelRow)) +
      (aaFin ? '&fin=' + encodeURIComponent(aaFin) : '') +
      (aaLen ? '&len=' + aaLen : '') +
      (aaOff ? '&off=' + aaOff : '') +
      (aaAl ? '&al=' + aaAl : '');
  }

  function aaCutFlash(panelRow, msg, isErr) {
    var m = panelRow.querySelector('.aa-cut-message');
    if (!m) return;
    m.textContent = msg;
    m.style.color = isErr ? '#b45309' : '#12b8e5';
    m.style.display = 'block';
    setTimeout(function () {
      if (m.textContent === msg) {
        m.textContent = '';
        m.style.display = 'none';
      }
    }, 2500);
  }

  /* r55: confirmation on the button itself. aaCutFlash writes into
     .aa-cut-message, which is a silent no-op if that div is missing,
     restyled or off-screen when the panel paints as a modal - a live
     sweep saw the copy succeed with zero visible feedback. Swapping
     the button's own text cannot miss: it is the element the customer
     just clicked, wherever the panel markup lives. aaCutFlash is kept
     as a bonus, not relied on. */
  function aaCutBtnFlash(btn, txt) {
    if (!btn || btn.__aaFlash) return;
    var old = btn.textContent;
    btn.__aaFlash = true;
    btn.textContent = txt;
    setTimeout(function () {
      btn.textContent = old;
      btn.__aaFlash = false;
    }, 2000);
  }

  function aaCutCopyLink(btn) {
    var panelRow = btn.closest('.aa-cut-panel-row');
    var row = getCutProductRow(panelRow);
    if (!panelRow || !row) return;
    var u = aaCutShareURL(panelRow, row);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(u).then(function () {
        aaCutBtnFlash(btn, 'Link copied');
        aaCutFlash(panelRow, 'Link copied');
      }, function () {
        window.prompt('Copy this link:', u);
      });
    } else {
      window.prompt('Copy this link:', u);
    }
  }

  function aaCutEsc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* One horizontal scaled bar per stock length; identical bars grouped
     with an "x N" tag exactly like the on-screen visual. Tiny segments
     drop their in-segment label; the caption line under each bar always
     lists every cut, so nothing is lost. */
  function aaCutBarsHtml(bars) {
    var groups = {}, order = [];
    bars.forEach(function (bar) {
      var sig = barSignature(bar);
      if (!groups[sig]) {
        groups[sig] = { bar: bar, count: 0 };
        order.push(sig);
      }
      groups[sig].count += 1;
    });
    var html = '';
    order.forEach(function (sig, gi) {
      var g = groups[sig], bar = g.bar, L = bar.length || 1;
      var segBase = 'box-sizing:border-box;overflow:hidden;' +
        'display:flex;align-items:center;justify-content:center;' +
        'font-size:9px;white-space:nowrap;';
      var segs = '', pT = 0;
      bar.pieces.forEach(function (p, i) {
        if (i > 0) {
          segs += '<div style="flex:0 0 ' + (6 / L * 100).toFixed(3) +
            '%;background:#334155;"></div>';
        }
        var w = p / L * 100; pT += p;
        segs += '<div style="flex:0 0 ' + w.toFixed(3) + '%;' + segBase +
          'background:#f5ecd7;border:1px solid #c9b98a;">' +
          (w > 5 ? p : '') + '</div>';
      });
      if (bar.remaining > 0) {
        var rw = bar.remaining / L * 100;
        var rMm = Math.round(bar.remaining);
        /* r27: remainders under 60mm are grip / saw-waste - plain grey,
           no offcut label in the bar or in the caption line. */
        if (aaOffcutMm(rMm) > 0) {
          segs += '<div style="flex:1 1 auto;' + segBase +
            'background:#e6edf8;border:1px solid #94a8cc;color:#5a6c8c;">' +
            (rw > 8 ? 'offcut ' + rMm : '') + '</div>';
        } else {
          segs += '<div style="flex:1 1 auto;' + segBase +
            'background:#cbd5e1;"></div>';
        }
      }
      var k = Math.round(L - pT - (bar.remaining||0)), cap = bar.pieces.join(' + ') + (k>=1?' + kerf '+k:'');
      if (bar.remaining > 0 && aaOffcutMm(bar.remaining) > 0) {
        cap += ' + offcut ' + Math.round(bar.remaining);
      }
      html += '<div style="margin:0 0 4px;font-size:12px;font-weight:600;">' +
        'Stock length ' + (gi + 1) + ' - ' + L + ' mm' +
        (g.count > 1 ? ' (x ' + g.count + ')' : '') + '</div>' +
        '<div style="display:flex;height:30px;border:1px solid #334155;' +
        'border-radius:3px;overflow:hidden;margin:0 0 3px;">' +
        segs + '</div>' +
        '<div style="font-size:10px;color:#64748b;margin:0 0 14px;">' +
        'Cuts (mm): ' + aaCutEsc(cap) + '</div>';
    });
    return html;
  }

  function aaCutPrintPlan(btn) {
    var panelRow = btn.closest('.aa-cut-panel-row');
    var row = getCutProductRow(panelRow);
    if (!panelRow || !row) return;
    var plan = panelRow._materialPlan;
    var pairs = aaCutRowPairs(panelRow);
    if (!plan || !plan.possible || !plan.bars || !plan.bars.length || !pairs.length) {
      aaCutFlash(panelRow, 'Enter cut sizes first, then print.', true);
      return;
    }
    var title = row.getAttribute('data-quick-title') || 'Selected material';
    var finEl = panelRow.querySelector('.aa-summary-finish');
    var finish = finEl ? finEl.textContent : 'Mill Finish';
    var job = aaCutProjectName(panelRow);
    var feeCents = Number(panelRow.dataset.estimatedFeeCents || 0);
    var matCents = Number(plan.totalCost || 0);
    var cutsDispEl = panelRow.querySelector('.aa-summary-cuts-display');
    var cutsTxt = cutsDispEl ? cutsDispEl.textContent : String(pairs.length);
    var rowsHtml = pairs.map(function (p) {
      return '<tr><td>' + p.qty + '</td><td>' + p.len + ' mm</td></tr>';
    }).join('');
    var sum = '';
    function sRow(k, v) {
      sum += '<tr><th>' + aaCutEsc(k) + '</th><td>' +
        aaCutEsc(v) + '</td></tr>';
    }
    sRow('Product', title);
    sRow('Finish', finish);
    if (job) sRow('Project / job', job);
    sRow('Stock lengths', plan.planLabel || '-');
    sRow('Cuts', cutsTxt);
    sRow('Cutting charge', moneyFromCents(feeCents));
    sRow('Material cost', moneyFromCents(matCents));
    sRow('Estimated total', moneyFromCents(matCents + feeCents));
    var css = 'body{font-family:Arial,Helvetica,sans-serif;' +
      'color:#1e293b;margin:24px;}' +
      'h1{font-size:20px;margin:0 0 4px;}' +
      'h2{font-size:14px;margin:20px 0 8px;color:#334155;}' +
      '.sub{color:#64748b;font-size:12px;margin:0 0 12px;}' +
      'table{border-collapse:collapse;width:100%;font-size:13px;' +
      'margin:0 0 8px;}' +
      'th,td{border:1px solid #cbd5e1;padding:6px 9px;' +
      'text-align:left;vertical-align:top;}' +
      'th{background:#f1f5f9;font-weight:600;white-space:nowrap;}' +
      '.foot{margin-top:20px;font-size:11px;color:#94a3b8;}';
    var html = '<!doctype html><html><head>' +
      '<meta charset="utf-8"><title>Cut plan - ' + aaCutEsc(title) +
      '</title><sty' + 'le>' + css + '</sty' + 'le></he' + 'ad><bo' + 'dy>' +
      '<h1>AluCut cut plan</h1>' +
      '<p class="sub">' + aaCutEsc(title) + ' - ' + aaCutEsc(finish) +
      (job ? ' - ' + aaCutEsc(job) : '') + '</p>' +
      '<h2>Cut list</h2>' +
      '<table><thead><tr><th>Qty</th><th>Length</th></tr></thead>' +
      '<tbody>' + rowsHtml + '</tbody></table>' +
      '<h2>Stock lengths</h2>' + aaCutBarsHtml(plan.bars) +
      '<h2>Summary</h2><table><tbody>' + sum + '</tbody></table>' +
      '<p class="foot">Printed ' + new Date().toLocaleString() +
      ' - Plan by AluCut. Cuts +/-2mm tolerance, ~6mm kerf.</p>' +
      '</bo' + 'dy></ht' + 'ml>';
    var w = window.open('', '_blank');
    if (w && w.document) {
      w.document.open();
      w.document.write(html);
      w.document.close();
      w.focus();
      setTimeout(function () {
        try { w.print(); } catch (e) { /* blocked print is fine */ }
      }, 250);
      return;
    }
    var d = document.createElement('div');
    d.className = 'aa-print-only';
    d.innerHTML = html
      .replace(/^[\s\S]*<body>/, '')
      .replace(/<\/body>[\s\S]*$/, '');
    var st = document.createElement('style');
    st.setAttribute('data-aa-print', '1');
    st.textContent = '@media print{body>*{display:none !important;}' +
      'body>.aa-print-only{display:block !important;}}' +
      '@media screen{.aa-print-only{display:none;}}';
    document.body.appendChild(st);
    document.body.appendChild(d);
    window.print();
    setTimeout(function () { d.remove(); st.remove(); }, 500);
  }

  function aaCutPdfPlan(btn) {
    var panelRow = btn.closest('.aa-cut-panel-row');
    var row = getCutProductRow(panelRow);
    if (!panelRow || !row) return;
    var pieces = getCutRowsData(panelRow);
    /* r-bestlength: this endpoint RE-PLANS server-side, so it must be handed the SAME list
       the estimate was priced from. It called getCandidateStockOptions separately, so the
       printed plan and the quoted plan would diverge the moment the two lists differed. */
    var candidates = aaEffectiveCandidates(row, panelRow, pieces);
    if (!pieces.length || !candidates.length) {
      aaCutFlash(panelRow, 'Enter cut sizes first.', true);
      return;
    }
    var finEl = panelRow.querySelector('.aa-summary-finish');
    var finish = finEl ? finEl.textContent : 'Mill Finish';
    var cutsDispEl = panelRow.querySelector('.aa-summary-cuts-display');
    var body = {
      mode: 'plan-table',
      kerfMm: 6,
      candidates: candidates.map(function (c) {
        return {
          lengthMm: c.lengthMm,
          priceCents: c.priceCents,
          isHalf: !!c.isHalf
        };
      }),
      pieces: pieces,
      /* r-endtrim: this endpoint RE-PLANS on the server, so it must be told the finish
         too. Without it the printed cut plan the cutter works from would use the whole
         6500mm bar while the customer was quoted 6400mm of usable material - two
         different plans for one job, which is exactly the failure being fixed. */
      finish: finish,
      material: (row.getAttribute('data-quick-title') || 'Aluminium') +
        ' - ' + finish,
      jobName: aaCutProjectName(panelRow),
      feeCents: Number(panelRow.dataset.estimatedFeeCents || 0),
      cutsNote: cutsDispEl ? cutsDispEl.textContent : ''
    };
    var endpoint = AA_PLAN_ENDPOINT.replace(/\/quote(\?.*)?$/, '/cutplan.pdf');
    function done(b) {
      if (b) {
        var u = URL.createObjectURL(b);
        if (!window.open(u, '_blank')) {
          var a = document.createElement('a');
          a.href = u;
          a.download = 'cut-plan.pdf';
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
        setTimeout(function () { URL.revokeObjectURL(u); }, 60000);
      } else {
        aaCutFlash(panelRow, 'Could not generate the cut plan PDF.', true);
      }
    }
    if (window.AACut && typeof window.AACut.fetchBlob === 'function') {
      window.AACut.fetchBlob(endpoint, body).then(done);
    } else {
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.ok ? r.blob() : null; })
        .then(done)
        .catch(function () { done(null); });
    }
  }

  function serializeCutRows(panelRow) {
    var lines = [];
    panelRow.querySelectorAll('.aa-cut-row').forEach(function(rowEl) {
      var qty = Math.max(parseInt(rowEl.querySelector('.aa-cut-qty').value, 10) || 0, 0);
      var len = Math.max(parseInt(rowEl.querySelector('.aa-cut-length').value, 10) || 0, 0);
      if (qty > 0 && len > 0) {
        lines.push(qty + ' x ' + len + 'mm');
      }
    });
    return lines.join(', ');
  }

  /* r-cutdefer 13 Sep 2026 - THE FOUR BINDINGS THAT USED TO BE MADE AT PAGE LOAD.
     The panel's markup is now cloned in on first open (assets/aa-cut-defer.js + the
     <template> in the section), so at page load there is nothing inside the panel to bind
     to. The comment beside the finish select below still says the markup 'is rendered in
     Liquid at page load so it exists now' - that stopped being true for this table today.
     Found by taking every class in snippets/aa-cut-shell.liquid and searching for every
     binding whose target names one, TWO different ways - a selector-first scan and an
     origin-first walk back from each addEventListener. Neither alone was complete: the
     first missed .aa-cut-finish (its origin is a ternary), the second missed the three
     bound on loop parameters. Together: FOUR.
       bindCutRowEvents  -> .aa-cut-remove onclick, and .aa-cut-qty/.aa-cut-length oninput
                            which is what drives the estimate. Without it the total is $0.00.
       .aa-cut-finish    -> change; without it picking a finish does not re-price.
       .aa-cut-add-cart  -> click; without it the big blue button does NOTHING when pressed,
                            the exact failure sections/aa-cut-consent.liquid exists to stop.
     Runs ONCE per panel. The page-load calls below are left exactly as they are: they no-op
     on an empty panel and still bind if the template is ever removed. */
  function aaBindDeferredPanel(panelRow, row) {
    if (!panelRow || !row) return;
    if (panelRow.getAttribute('data-aa-bound') === '1') return;
    if (!panelRow.querySelector('.aa-cut-row')) return;
    bindCutRowEvents(panelRow);
    var sel = panelRow.querySelector('.aa-cut-finish');
    if (sel) {
      sel.addEventListener('change', function() {
        sel.setAttribute('data-aa-touched', '1');
        updateCutEstimate(row);
      });
    }
    var addBtn = panelRow.querySelector('.aa-cut-add-cart');
    if (addBtn) addBtn.addEventListener('click', aaCutAddCartHandler);
    panelRow.setAttribute('data-aa-bound', '1');
  }

  function bindCutRowEvents(panelRow) {
    panelRow.querySelectorAll('.aa-cut-remove').forEach(function(btn) {
      btn.onclick = function() {
        var rows = panelRow.querySelectorAll('.aa-cut-row');
        if (rows.length === 1) {
          rows[0].querySelector('.aa-cut-qty').value = 1;
          rows[0].querySelector('.aa-cut-length').value = '';
        } else {
          this.closest('.aa-cut-row').remove();
        }
        updateCutEstimate(getCutProductRow(panelRow));
      };
    });

    panelRow.querySelectorAll('.aa-cut-qty, .aa-cut-length').forEach(function(input) {
      input.addEventListener('input', function() {
        /* Keep the row's button honest about whether the service is active. */
        var r = getCutProductRow(panelRow);
        var t = r ? r.querySelector('.aa-cut-toggle') : null;
        if (t && !t.classList.contains('aa-cut-toggle--open')) aaSetCutLabel(t);
      });
      input.oninput = function() {
        updateCutEstimate(getCutProductRow(panelRow));
      };
    });
  }

  function applyFilter() {
    var featureVal = filterFeature ? filterFeature.value : 'all';
    var dim1Val = filterDim1 ? filterDim1.value : 'all';
    var dim2Val = filterDim2 ? filterDim2.value : 'all';
    var dim3Val = filterDim3 ? filterDim3.value : 'all';
    var lengthVal = filterLength ? filterLength.value : 'all';
    var internalVal = filterInternal ? filterInternal.value : 'all';
    var radiusVal   = filterRadius   ? filterRadius.value   : 'all';
    var finishVal   = filterFinish   ? filterFinish.value   : 'all';

    wrapper.querySelectorAll('.aa-main-row').forEach(function(row) {
      var show = true;

      var dim1 = normalizeNumericString(row.getAttribute('data-dim1'));
      var dim2 = normalizeNumericString(row.getAttribute('data-dim2'));
      var dim3 = normalizeNumericString(row.getAttribute('data-dim3'));
      var lengths = getRowLengths(row);

      show = show && rowMatchesFeature(row, featureVal);

      if (dim1Val !== 'all') {
        show = show && dim1 === dim1Val;
      }

      if (dim2Val !== 'all') {
        show = show && dim2 === dim2Val;
      }

      if (dim3Val !== 'all') {
        show = show && dim3 === dim3Val;
      }

      if (lengthVal !== 'all') {
        show = show && lengths.indexOf(lengthVal) !== -1;
      }

      if (internalVal !== 'all') {
        show = show && (row.getAttribute('data-internal-base') || '') === internalVal;
      }
      if (radiusVal !== 'all') {
        show = show && (row.getAttribute('data-corner-type') || 'square') === radiusVal;
      }
      if (finishVal !== 'all') {
        var fParts  = finishVal.split('|');
        var fType   = fParts[0];
        var fName   = fParts[1] || '';
        var hiddenSel = row.querySelector('.aa-variant-hidden');
        var hasFinish = hiddenSel && Array.from(hiddenSel.options).some(function(opt) {
          var fin      = opt.getAttribute('data-finish') || '';
          var isPowder = opt.getAttribute('data-powder-coat-variant') === 'true';
          var isStock  = opt.getAttribute('data-finished-stock') === 'true';
          if (fType === 'mill')   return fin === 'Mill' && !isPowder && !isStock;
          if (fType === 'stock')  return fin === fName && isStock;
          if (fType === 'custom') {
            var optPc = (opt.getAttribute('data-option2') || '').replace(/\s*powder[\s-]*coat\s*/i, '').trim();
            return isPowder && (optPc === fName || fin === fName);
          }
          return false;
        });
        show = show && hasFinish;
      }

      if (!show) { row.style.setProperty('display', 'none', 'important'); }
      else { row.style.removeProperty('display'); }
      row.classList.toggle('aa-hidden-row', !show);

      var panel = getCutPanelRow(row);
      if (panel && panel.classList.contains('aa-cut-panel-row')) {
        if (!show) {
          panel.style.setProperty('display', 'none', 'important');
          var toggle = row.querySelector('.aa-cut-toggle');
          aaSetCutLabel(toggle);
        }
      }
    });

    aaStripeRows();
  }

  /* Excel-style banding. Counted over the rows that are actually VISIBLE, so the stripes stay
     alternating after a filter hides some. A plain CSS :nth-child() cannot do this - the tbody
     alternates main-row / cut-panel-row, and filtered rows are still in the DOM. */
  function aaStripeRows() {
    var rows = wrapper.querySelectorAll('.aa-main-row');
    var n = 0;
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      if (r.classList.contains('aa-hidden-row')) { r.classList.remove('aa-row-odd'); continue; }
      r.classList.toggle('aa-row-odd', n % 2 === 1);
      n++;
    }
  }

  function openQuickModal(row) {
    if (!quickModal || !row) return;

    var title = row.getAttribute('data-quick-title') || '';
    var image = row.getAttribute('data-quick-image') || '';
    var shortSpec = row.getAttribute('data-quick-short-spec') || '';
    var description = row.getAttribute('data-quick-description') || '';
    var dim1 = row.getAttribute('data-dim1') || '';
    var dim2 = row.getAttribute('data-dim2') || '';
    var dim3 = row.getAttribute('data-dim3') || '';
    var radius = row.getAttribute('data-quick-internal-radius') || '';
    var finish = row.getAttribute('data-quick-finish') || 'Mill finish';
    var cutAvailable = row.getAttribute('data-quick-cut-available') || 'No';
    var powderAvailable = row.getAttribute('data-quick-powder-available') || 'No';
    var showDim2 = row.getAttribute('data-quick-show-dim2') === 'true';
    var showDim3 = row.getAttribute('data-quick-show-dim3') === 'true';
    var showRadius = row.getAttribute('data-quick-show-radius') === 'true';

    quickModalTitle.textContent = title;
    quickModalDescription.innerHTML = formatQuickDescription(description);
    quickModalDim1Value.textContent = safeValue(dim1, ' mm');
    quickModalFinish.textContent = finish;
    quickModalCut.textContent = cutAvailable;
    quickModalPowder.textContent = powderAvailable;

    if (shortSpec) {
      quickModalShortSpec.textContent = shortSpec;
      quickModalShortSpec.style.display = 'block';
    } else {
      quickModalShortSpec.textContent = '';
      quickModalShortSpec.style.display = 'none';
    }

    if (showDim2) {
      quickModalDim2Value.textContent = safeValue(dim2, ' mm');
      quickModalDim2Card.style.display = 'block';
    } else {
      quickModalDim2Card.style.display = 'none';
    }

    if (showDim3) {
      quickModalDim3Value.textContent = safeValue(dim3, ' mm');
      quickModalDim3Card.style.display = 'block';
    } else {
      quickModalDim3Card.style.display = 'none';
    }

    if (showRadius && radius) {
      quickModalRadius.textContent = safeValue(radius, ' mm');
      quickModalRadiusCard.style.display = 'block';
    } else {
      quickModalRadius.textContent = '';
      quickModalRadiusCard.style.display = 'none';
    }

    if (image) {
      quickModalImage.src = image;
      quickModalImage.alt = title;
      quickModalImage.style.display = 'block';
    } else {
      quickModalImage.removeAttribute('src');
      quickModalImage.setAttribute('alt', '');
      quickModalImage.style.display = 'none';
    }

    quickModal.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  function closeQuickModal() {
    if (!quickModal) return;
    quickModal.style.display = 'none';
    document.body.style.overflow = '';
  }

  wrapper.querySelectorAll('.aa-main-row').forEach(function(row) {
    var lengthSelect = row.querySelector('.aa-length-select');
    var finishChoice = row.querySelector('.aa-finish-choice');
    var qtyInput    = row.querySelector('.aa-table-qty');

    if (lengthSelect) {
      lengthSelect.addEventListener('change', function() {
        updateVariantBehaviour(row);
      });
    }

    if (finishChoice) {
      finishChoice.addEventListener('change', function() {
        updateVariantBehaviour(row);
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', function() { updateVariantBehaviour(row); });
      qtyInput.addEventListener('change', function() { updateVariantBehaviour(row); });
    }

    /* The popup's own finish. Bound directly rather than delegated: the panel
       markup is rendered in Liquid at page load so it exists now, and the
       wrapper's delegated handler only listens for 'click'. */
    var cutPanelRow = getCutPanelRow(row);
    var cutFinishSel = cutPanelRow ? cutPanelRow.querySelector('.aa-cut-finish') : null;
    if (cutFinishSel) {
      cutFinishSel.addEventListener('change', function() {
        cutFinishSel.setAttribute('data-aa-touched', '1');
        updateCutEstimate(row);
      });
    }
    aaBuildCutFinishSelect(row);
    aaBuildAutoLenToggle(row);

    /* r-1dmerge: the full-length-only row's simple finish selector. The RHS engine
       bound this in its own init loop. Guarded on the attribute, so it is a no-op on
       every row that has a Length matrix - which is all 122 of them on the 1D
       collections today.
       ONE DELIBERATE CHANGE FROM THE RHS ORIGINAL: that copy tested
       `aaPr.style.display === 'table-row'` to decide whether the panel was open. This
       file has aaIsCutPanelOpen, which checks the .aa-cut-open CLASS and falls back to
       the inline style - the same answer inside a table row, and the right answer
       inside a div. The literal string test is what tied the old engine to being a
       table; do not put it back. */
    if (row.getAttribute('data-has-length') === 'false') {
      var aaFlSel = row.querySelector('select.aa-fl-finish');
      if (aaFlSel) {
        aaFlSel.addEventListener('change', function () {
          aaFlSync(row);
          var aaPr = getCutPanelRow(row);
          if (aaPr && aaIsCutPanelOpen(aaPr)) { updateCutWarnings(row); updateCutEstimate(row); }
        });
      }
      aaFlSync(row);
    }

    updateVariantBehaviour(row);
  });

  if (filterFeature) {
    filterFeature.addEventListener('change', function() {
      refreshCascadingFilters();
      applyFilter();
    });
  }

  if (filterDim1) {
    filterDim1.addEventListener('change', function() {
      refreshCascadingFilters();
      applyFilter();
    });
  }

  if (filterDim2) {
    filterDim2.addEventListener('change', function() {
      refreshCascadingFilters();
      applyFilter();
    });
  }

  if (filterDim3) {
    filterDim3.addEventListener('change', function() {
      refreshCascadingFilters();
      applyFilter();
    });
  }

  if (filterLength) {
    filterLength.addEventListener('change', function() {
      applyFilter();
    });
  }

  if (filterInternal) {
    filterInternal.addEventListener('change', function() {
      applyFilter();
      if (window.aaUpdateFilterCount) window.aaUpdateFilterCount('' + SID + '');
    });
  }

  if (filterRadius) {
    filterRadius.addEventListener('change', function() {
      applyFilter();
      if (window.aaUpdateFilterCount) window.aaUpdateFilterCount('' + SID + '');
    });
  }

  if (filterFinish) {
    filterFinish.addEventListener('change', function() {
      applyFilter();
      if (window.aaUpdateFilterCount) window.aaUpdateFilterCount('' + SID + '');
    });
  }

  if (clearFiltersBtn) {
    clearFiltersBtn.addEventListener('click', function() {
      if (filterFeature) filterFeature.value = 'all';
      if (filterDim1) filterDim1.value = 'all';
      if (filterDim2) filterDim2.value = 'all';
      if (filterDim3) filterDim3.value = 'all';
      if (filterInternal) filterInternal.value = 'all';
    if (filterRadius)   filterRadius.value   = 'all';
    if (filterLength)   filterLength.value   = 'all';
    if (filterFinish)   filterFinish.value   = 'all';
      refreshCascadingFilters();
      applyFilter();
    });
  }

  if (quickCloseBtn) {
    quickCloseBtn.addEventListener('click', closeQuickModal);
  }

  if (quickModal) {
    quickModal.addEventListener('click', function(e) {
      if (e.target === quickModal) {
        closeQuickModal();
      }
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && quickModal && quickModal.style.display === 'block') {
      closeQuickModal();
    }
  });

  // Shared helper: restore scroll + briefly highlight row after panel close
  function aaClosePanel(panelRow, row) {
    aaSetCutPanelOpen(panelRow, false);
    var toggleBtn = row.querySelector('.aa-cut-toggle');
    if (toggleBtn) {
      aaSetCutLabel(toggleBtn);   /* <- was textContent, which destroyed the icon on Cancel */
    }
    setMainAddDisabled(row, false);
    setSelectionLocked(row, false);
    updateVariantBehaviour(row);
    if (typeof row._aaScrollY === 'number') {
      window.scrollTo({ top: row._aaScrollY, behavior: 'smooth' });
      row._aaScrollY = undefined;
    }
    row.style.transition = 'outline 0.15s ease, box-shadow 0.15s ease';
    row.style.outline = '2px solid #12b8e5';
    row.style.boxShadow = '0 0 0 4px rgba(18,184,229,0.15)';
    setTimeout(function() {
      row.style.outline = '';
      row.style.boxShadow = '';
      setTimeout(function() { row.style.transition = ''; }, 300);
    }, 1400);
  }

  wrapper.addEventListener('click', function(e) {
    /* r-split-guard: any click that is not a split chip cancels an armed chip. */
    if (!(e.target.classList && e.target.classList.contains('aa-cut-split-btn'))) aaSplitDisarm();
    if (e.target.classList.contains('aa-cut-detail-toggle')) {
      var panelRowDetail = e.target.closest('.aa-cut-panel-row');
      var detailPanel = panelRowDetail ? panelRowDetail.querySelector('.aa-cut-detail-panel') : null;
      if (!detailPanel) return;
      var isOpenDetail = detailPanel.style.display === 'block';
      detailPanel.style.display = isOpenDetail ? 'none' : 'block';
      e.target.textContent = isOpenDetail ? 'Show full estimate' : 'Hide full estimate';
      e.target.setAttribute('aria-expanded', isOpenDetail ? 'false' : 'true');
      return;
    }

    var quickTrigger = e.target.closest('.aa-quick-open');
    if (quickTrigger) {
      var quickRow = quickTrigger.closest('.aa-main-row');
      if (quickRow) {
        openQuickModal(quickRow);
        return;
      }
    }

    if (e.target.classList.contains('aa-cut-toggle')) {
      var row = e.target.closest('tr');
      var panelRow = getCutPanelRow(row);
      if (!panelRow) return;

      var isOpen = aaIsCutPanelOpen(panelRow);
      aaSetCutPanelOpen(panelRow, !isOpen);
      if (isOpen) {
        aaSetCutLabel(e.target);
      } else {
        e.target.innerHTML = '<span>Hide cut &amp; fold</span>';
      }
      e.target.classList.toggle('aa-cut-toggle--open', !isOpen);
      setMainAddDisabled(row, !isOpen);
      setSelectionLocked(row, !isOpen);
      if (!isOpen) { aaBindDeferredPanel(panelRow, row); aaBuildCutFinishSelect(row); aaBuildAutoLenToggle(row); aaRefreshCartCache(row); }

      // Save scroll position before opening so we can restore it on close
      if (!isOpen) { row._aaScrollY = window.scrollY; }

      // Scroll: on open bring panel/row to top below sticky header;
      // on close restore the saved position
      setTimeout(function() {
        if (!isOpen) {
          var sticky = 0;
          ['[data-section-type="header"] header', 'header.header', '.nav-bar', '.zapiet-pickupdelivery--bar', '.announcement-bar'].forEach(function(sel) {
            var el = document.querySelector(sel);
            if (el) sticky = Math.max(sticky, el.getBoundingClientRect().bottom);
          });
          // On mobile scroll to the cut panel itself so inputs are immediately visible
          var scrollTarget = window.innerWidth <= 767 ? panelRow : row;
          var top = scrollTarget.getBoundingClientRect().top + window.scrollY - sticky - 12;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          // Desktop only: nudge further if panel extends below viewport
          if (window.innerWidth > 767) {
            setTimeout(function() {
              var panelBottom = panelRow.getBoundingClientRect().bottom;
              if (panelBottom > window.innerHeight - 20) {
                window.scrollBy({ top: panelBottom - window.innerHeight + 20, behavior: 'smooth' });
              }
            }, 350);
          }
        } else {
          aaClosePanel(panelRow, row);
        }
      }, 100);

      if (!isOpen) {
        var note = row.querySelector('.aa-order-note');
        if (note) note.textContent = 'AluCut is working out the material for you \u2014 see the plan below.';
      } else {
        updateVariantBehaviour(row);
      }

      updateCutWarnings(row);
      updateCutEstimate(row);
      return;
    }

    if (e.target.classList.contains('aa-cut-split-btn')) {
      aaSplitEqual(e.target);
      return;
    }

    if (e.target.classList.contains('aa-cut-link-btn')) {
      var linkAct = e.target.getAttribute('data-aa-act') || '';
      if (linkAct === 'copylink') aaCutCopyLink(e.target);
      else if (linkAct === 'printplan') aaCutPrintPlan(e.target);
      else if (linkAct === 'pdfplan') aaCutPdfPlan(e.target);
      return;
    }

    if (e.target.classList.contains('aa-cut-add-row')) {
      var panelRowAdd = e.target.closest('.aa-cut-panel-row');
      var rowsWrap = panelRowAdd.querySelector('.aa-cut-rows');
      rowsWrap.insertAdjacentHTML('beforeend', aaCutRowHtml());
      bindCutRowEvents(panelRowAdd);
      return;
    }

    if (e.target.classList.contains('aa-cut-clear')) {
      var panelRowClear = e.target.closest('.aa-cut-panel-row');
      var rowsWrapClear = panelRowClear.querySelector('.aa-cut-rows');
      rowsWrapClear.innerHTML = aaCutRowHtml();
      bindCutRowEvents(panelRowClear);
      updateCutEstimate(getCutProductRow(panelRowClear));
      return;
    }

    if (e.target.classList.contains('aa-cut-cancel')) {
      var panelRowCancel = e.target.closest('.aa-cut-panel-row');
      var rowCancel = getCutProductRow(panelRowCancel);
      if (!panelRowCancel || !rowCancel) return;
      aaClosePanel(panelRowCancel, rowCancel);
      return;
    }

    if (e.target.classList.contains('aa-cut-toggle-full-visual')) {
      var panelRowToggle = e.target.closest('.aa-cut-panel-row');
      panelRowToggle.dataset.fullVisual = panelRowToggle.dataset.fullVisual === 'true' ? 'false' : 'true';
      updateCutEstimate(getCutProductRow(panelRowToggle));
      return;
    }
  });

  wrapper.querySelectorAll('.aa-cut-panel-row').forEach(function(panelRow) {
    bindCutRowEvents(panelRow);
  });

  wrapper.querySelectorAll('.aa-table-add').forEach(function(button) {
    button.addEventListener('click', async function() {
      var btn = this;
      var row = btn.closest('tr');
      if (!row) return;

      var message = row.querySelector('.aa-table-message');
      var originalText = btn.textContent;
      var variant = selectedVariantData(row);
      var qtyInput = row.querySelector('.aa-table-qty');
      var quantity = Math.max(parseInt(qtyInput.value, 10) || 1, 1);

      if (!variant || !variant.id) return;
      if (btn.disabled) return;

      if (variant.type !== 'custom' && !variant.isAvailable) {
        if (message) {
          message.textContent = 'This selection is currently out of stock.';
          message.style.display = 'block';
          message.style.color = '#b42318';
        }
        return;
      }

      btn.disabled = true;
      btn.textContent = 'Adding...';

      if (message) {
        message.style.display = 'none';
        message.textContent = '';
        message.style.color = '#12b8e5';
      }

      try {
        var itemsToAdd = [];
        var lineItemProperties = {};
        var selectedPowderColour = '';

        if (variant.type === 'custom' && variant.powderColour) {
          selectedPowderColour = variant.powderColour.trim();
          lineItemProperties['Powder Coat'] = selectedPowderColour;
        }

        itemsToAdd.push({
          id: variant.id,
          quantity: quantity,
          properties: lineItemProperties
        });

        var shouldCheckFee =
          row.getAttribute('data-powder-fee-enabled') === 'true' &&
          row.getAttribute('data-powder-available') === 'true' &&
          variant.type === 'custom' &&
          !!selectedPowderColour;

        if (shouldCheckFee) {
          var normalizedColour = normalizeColour(selectedPowderColour);
          var feeVariantId = aaPowderFeeId(normalizedColour);

          if (feeVariantId) {
            /* The MATERIAL line declares which setup-fee variant covers it. Same two keys
               and the same String() coercion as assets/custom.js:192-193 - this is that
               dialect, not a third one. aa-cart-guard.js setupFeeSteps() builds its owed-fee
               map EXCLUSIVELY from _setup_fee_variant on a material line, and the
               colour -> variant map is rendered only inside the product form, never on
               /cart. Without this declaration a customer can delete the $50 line on the
               cart page and it can never come back. Stamped whenever the fee is OWED, not
               only when a fee line is pushed: if the cart already holds this colour's fee
               no new line is added, but this material line still owes it, and deleting the
               line that did declare would otherwise take the declaration with it. The
               guard is presence-capped (once per colour) so declaring twice cannot
               double-charge. */
            itemsToAdd[0].properties = Object.assign({}, itemsToAdd[0].properties, {
              '_setup_fee_variant': String(feeVariantId),
              '_setup_fee_colour': normalizedColour
            });
            var cart = await fetchCart();
            /* r655: no fee line when this colour reaches the coater's minimum with these lengths. */
            if (!cartHasVariant(cart, feeVariantId) && !aaPcWaived(cart, feeVariantId, aaPcAreaFor(row, variant.lengthMm || 6500, quantity))) {
              itemsToAdd.push({
                id: Number(feeVariantId),
                quantity: 1,
                properties: {
                  '_powder_fee_for_colour': selectedPowderColour
                }
              });
            }
          } else {
            console.warn('No powder fee variant mapped for colour:', selectedPowderColour);
          }
        }

        await addItemsToCart(itemsToAdd);
        /* r776b: what this row just added (variant | quantity) - its bar and the other rows' bars count it once, in the cart,
           while the row still shows it. */
        try { row.__aaPbAdded = String(variant.id) + '|' + quantity; } catch (aaPbE) { /* display only */ }
        await refreshCartUi();
        if (window.aaPulseCartIcon) window.aaPulseCartIcon();

        if (message) {
          message.textContent = itemsToAdd.length > 1 ? 'Added to cart with powder coat setup fee' : 'Added to cart';
          message.style.display = 'block';
        }

        btn.textContent = 'Added';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
          updateVariantBehaviour(row);
        }, 1000);

      } catch (error) {
        console.error('Cart error:', error);
        alert(error.description || error.message || 'Could not add items to cart.');
        btn.textContent = originalText;
        btn.disabled = false;
        updateVariantBehaviour(row);
      }
    });
  });

  /* r-cutdefer: EXTRACTED, NOT COPIED - one body, two attach sites (page load below, and
     aaBindDeferredPanel on first open). `this` still resolves to the button: function
     declaration, not an arrow. */
  async function aaCutAddCartHandler() {
    var panelRow = this.closest('.aa-cut-panel-row');
    var row = getCutProductRow(panelRow);
    var btn = this;
    var msg = panelRow.querySelector('.aa-cut-message');
    var originalText = btn.textContent;
    var variant = selectedVariantData(row);
    var projectName = (panelRow.querySelector('.aa-cut-project').value || '').trim();
    var cutListText = serializeCutRows(panelRow);
    var estimatedCuts = Number(panelRow.dataset.estimatedCuts || 0);
var chargedCuts = Number(panelRow.dataset.chargedCuts || 0);
var cuttingVariantId = Number(panelRow.dataset.cuttingVariantId || 0);
var cutMethod = row.getAttribute('data-cut-method') || '';
var noCutCharge = row.getAttribute('data-no-charge') === 'true';
var plan = panelRow._materialPlan;
/* r39: edit-from-cart (edit_key in the URL) -> update semantics */
var aaEdit = window.__aaCutEdit || null;
if (aaEdit && (row.getAttribute('data-handle') || '') !== aaEdit.handle) aaEdit = null;
var aaEditRev = aaEdit ? ('r' + Date.now().toString(36)) : '';

    if (msg) {
      msg.style.display = 'none';
      msg.textContent = '';
      msg.style.color = '#12b8e5';
    }

    if (!variant || !variant.id) return;

    if (!cutListText) {
      if (msg) {
        msg.textContent = 'Please enter at least one cut size.';
        msg.style.display = 'block';
        msg.style.color = '#b42318';
      }
      return;
    }

    if (!plan || !plan.possible || !plan.combo || !plan.combo.length) {
      if (msg) {
        msg.textContent = 'Could not calculate a material plan. Please review your cuts.';
        msg.style.display = 'block';
        msg.style.color = '#b42318';
      }
      return;
    }

    if (!cuttingVariantId || !estimatedCuts) {
      if (msg) {
        msg.textContent = 'Could not calculate the cutting charge.';
        msg.style.display = 'block';
        msg.style.color = '#b42318';
      }
      return;
    }

    btn.disabled = true;
    btn.textContent = aaEdit ? 'Updating...' : 'Adding...';

    try {
      var itemsToAdd = [];
      /* Read the finish off the popup, not the row - candidates are locked to it,
         so this is the colour actually being bought. */
      var aaCutFinishLbl = aaCutFinishLabel(row);
      var aaCutFinishOpt = aaCutFinishOptions(row).filter(function (o) {
        return normalizeColour(o.label) === normalizeColour(aaCutFinishLbl || '');
      })[0];
      var selectedPowderColour = aaCutFinishOpt
        ? (aaCutFinishOpt.type === 'custom' ? (aaCutFinishOpt.powderColour || '').trim() : '')
        : (variant.type === 'custom' ? (variant.powderColour || '').trim() : '');

      /* r655 - a cut job in a custom colour now DECLARES its setup fee on each material line, as a full length
         always has: the cart guard can put a deleted fee back, and the bars count toward the coater's
         minimum, after which the fee is not owed. Same keys and values as the full-length path. */
      var aaCutFeeVid = (selectedPowderColour &&
        row.getAttribute('data-powder-fee-enabled') === 'true' &&
        row.getAttribute('data-powder-available') === 'true') ? aaPowderFeeId(normalizeColour(selectedPowderColour)) : null;

      var offcutCheckbox = panelRow.querySelector('.aa-cut-offcut-checkbox');
      var keepOffcut = offcutCheckbox ? offcutCheckbox.checked : true;
      var materialPlanText = plan.combo.map(function(item) {
        return item.quantity + ' x ' + item.candidate.lengthMm + 'mm';
      }).join(', ');
      /* r31: shareable design link recorded on the material line */
      var designLink = aaCutShareURL(panelRow, row);

      /* r186: one short reference for the whole cut job, on the material lines
         AND the charge line. _cutting_fee_for_product only links by product, so
         two different cut jobs on the same product in one cart were
         indistinguishable. This gives the workshop, the customer on the phone and
         the OS the same handle. */
      var aaJobRef = (function(){ var s = 'ACDEFGHJKLMNPQRSTUVWXYZ23456789', o = '';
        for (var i = 0; i < 5; i++) { o += s.charAt(Math.floor(Math.random() * s.length)); }
        return 'AC-' + o; })();
      /* r186: say WHY the charge is what it is, on the charge line itself. */
      var aaCutRate = (Number(panelRow.dataset.cuttingRateCents || 0) / 100).toFixed(2);
      var aaIncluded = Number(panelRow.dataset.includedCuts || 0);
      var aaBreak;
      if (noCutCharge) { aaBreak = estimatedCuts + ' cuts - no cutting charge on this product'; }
      else if (chargedCuts > 0) { aaBreak = estimatedCuts + ' cuts - ' + aaIncluded + ' included, ' + chargedCuts + ' charged at $' + aaCutRate; }
      else { aaBreak = estimatedCuts + ' cuts - all included, no cutting charge'; }
      /* r185: DECLARE THE CUTTING CHARGE ON THE MATERIAL LINE.
         aa-cart-guard.js v3 builds its guarded set FROM THESE DECLARATIONS
         instead of a hardcoded list of two variant ids - which is why every bar
         product could check out carrying cut instructions and no charge.
         Spread across every material line, so deleting one line reduces the
         requirement rather than cancelling it. The shares always sum to exactly
         chargedCuts. plan.combo.length is guaranteed > 0 by the guard above. */
      var aaHasOffcut = (plan.bars || []).some(function(b){ return aaOffcutMm(b.remaining) > 0; });
      /* r-offcut-default: the actual size, so the cart line names what is being kept
         or given up instead of just saying yes/no. */
      var aaOffcutList = (plan.bars || []).map(function(b){ return aaOffcutMm(b.remaining); })
        .filter(function(v){ return v > 0; });
      var aaOffcutTot = aaOffcutList.reduce(function(a, b){ return a + b; }, 0);
      /* r768-offcut-words (7 Oct 2026, Patryk's tick on the Desk walk sheet, question 8 - his 2 Oct "you dont have to
         add the mm for offcuts, it makes it look bad" / "75600mm is just terrible and not needed"): several offcuts say
         HOW MANY, never a total in mm - "(6 offcuts)". One offcut keeps its length, "(approx. 754mm)" - one number is
         useful. Nothing reads these words back: the OS asks only "Keep with order" / "comes with your" (offcutIntent,
         aaOffWhere720), the Order Printer cut sheet only "keep". aaOffcutTot is kept for nothing else to break. */
      var aaOffcutTxt = aaOffcutList.length === 1
        ? ('approx. ' + Math.round(aaOffcutList[0]) + 'mm')
        : (aaOffcutList.length + ' offcuts');
      var aaFeeUnits = (!noCutCharge && cuttingVariantId && chargedCuts > 0) ? chargedCuts : 0;
      var aaFeeBase  = Math.floor(aaFeeUnits / plan.combo.length);
      var aaFeeRem   = aaFeeUnits - (aaFeeBase * plan.combo.length);
      plan.combo.forEach(function(item, aaIdx) {
        var materialProps = {
          'Job ref': aaJobRef,
          'Cutting Required': 'Yes',
          'Cut Method': cutMethod || 'up-saw',
          'Project / Job Name': projectName || 'Not provided',
          'Cut List': cutListText,
          /* r186: the charge, in words, on the MATERIAL line too. The material
             line is the one that survives if the charge line is ever deleted, so
             this is the human-readable twin of _cut_fee_qty - a staff member or
             the workshop can see what should have been charged even when the
             charge line has gone missing. */
          'Cutting': aaBreak,
          'Estimated Cuts': String(estimatedCuts),
          'Material Plan': materialPlanText, 'Cut Map': (plan.bars || []).map(function(b, i){ return 'Bar ' + (i+1) + ' (' + b.length + 'mm): ' + b.pieces.join(' + ') + ' [offcut ' + Math.round(b.remaining) + 'mm]'; }).join(' | '),
          'Design link': designLink,
          /* r188: do not promise an offcut that is only clamp waste. This is the
             line the packer acts on, and it sat right next to a Cut Map reading
             "[offcut 50mm]". The Cut Map format is unchanged - parsers depend on
             it - but what the human is told is now true. */
          /* r-offcut-default 20 Aug 2026. This property has NO leading underscore, so
             Shopify prints it at checkout, on the confirmation email and on the order
             status page - it is the customer's own record of what they chose, and the
             reason a default of "no offcuts" is safe to ship.
             IT IS ALSO READ BY THE ORDER PRINTER PRODUCTION CUT SHEET, which badges
             with `aa_off_l contains "keep"`. So the DECLINE and NO-OFFCUT wordings
             must never contain the word keep. The old 'remainder too short to keep'
             did, and printed a green KEEP badge for an offcut that did not exist. */
          'Offcut': aaHasOffcut
            ? (keepOffcut ? 'Keep with order - the remainder comes with your cut pieces (' + aaOffcutTxt + ')'
                          : 'Not required - the remainder stays with All Aluminium')
            : 'No usable offcut - the remainder is too short to be worth returning',
          'Terms': 'Confirmed sizes; made-to-order cut-to-size; no return/refund for incorrect sizes entered'
        };

        if (selectedPowderColour) {
          materialProps['Powder Coat'] = selectedPowderColour;
        }
        if (aaCutFeeVid) {
          materialProps['_setup_fee_variant'] = String(aaCutFeeVid);
          materialProps['_setup_fee_colour'] = normalizeColour(selectedPowderColour);
        }

        /* r-bestlength 13 Sep 2026. Mirrors the sheets table's 'Sheet mode'. No leading
           underscore, so Shopify prints it at checkout, on the confirmation email and on
           the order status page: the customer's own record that the length on the line is
           the one AluCut chose, not the one showing in the product-row dropdown. Without
           it a customer who selected "6.5m - Full Length" receives an order for 1000mm
           pieces and has nothing on paper explaining why. */
        materialProps['Length mode'] = aaAutoPickOn(panelRow)
          ? 'Best length picked for this cut list'
          : 'Use selected length only';

        /* r39: stamp the replacement lines. An unchanged design would
           otherwise merge into the old line and the old-line removal
           below would take the new job with it. */
        if (aaEditRev) {
          materialProps['_aa_edit_rev'] = aaEditRev;
        }

        var aaFeeShare = aaFeeBase + (aaIdx < aaFeeRem ? 1 : 0);
        if (aaFeeShare > 0) {
          materialProps['_cut_fee_qty'] = String(aaFeeShare);
          materialProps['_cut_fee_variant'] = String(cuttingVariantId);
          materialProps['_cut_method'] = cutMethod || 'up-saw';
        }

        itemsToAdd.push({
          id: item.candidate.id,
          quantity: item.quantity,
          properties: materialProps
        });
      });

      if (!noCutCharge && cuttingVariantId && chargedCuts > 0) {
  itemsToAdd.push({
    id: cuttingVariantId,
    quantity: chargedCuts,
    properties: {
      'Job ref': aaJobRef,
      'Cutting': aaBreak,
      '_cutting_fee_for_product': row.getAttribute('data-product-id'),
      '_cut_method': cutMethod || 'up-saw',
      '_project_name': projectName || 'Not provided'
    }
  });
  if (aaEditRev) {
    itemsToAdd[itemsToAdd.length - 1].properties['_aa_edit_rev'] = aaEditRev;
  }
}

      var shouldCheckFee =
        row.getAttribute('data-powder-fee-enabled') === 'true' &&
        row.getAttribute('data-powder-available') === 'true' &&
        !!selectedPowderColour;

      if (shouldCheckFee) {
        var normalizedColour = normalizeColour(selectedPowderColour);
        var feeVariantId = aaPowderFeeId(normalizedColour);

        if (feeVariantId) {
          var cart = await fetchCart();
          /* r655: no fee line when this colour reaches the coater's minimum with the bars this plan buys. */
          var aaCutM2 = plan.combo.reduce(function (s, it) { return s + aaPcAreaFor(row, it.candidate && it.candidate.lengthMm, it.quantity); }, 0);
          if (!cartHasVariant(cart, feeVariantId) && !aaPcWaived(aaPcCartForFee(cart, row), feeVariantId, aaCutM2)) {
            itemsToAdd.push({
              id: Number(feeVariantId),
              quantity: 1,
              properties: {
                '_powder_fee_for_colour': selectedPowderColour
              }
            });
          }
        } else {
          console.warn('No powder fee variant mapped for colour:', selectedPowderColour);
        }
      }

      /* r43: EDIT replaces remove-first. r39 added the new lines and
         then retired the old ones; Shopify coalesces a new line into
         an existing same-variant line when the properties match, and
         the coalesced line keeps the OLD line's key - so the old-line
         sweep could take the new job (or its cutting charge) with it.
         Removing the old job BEFORE adding leaves nothing to merge
         into. Old keys are zeroed in ONE /cart/update.js call; if the
         removal fails we abort and the original job stays intact. */
      if (aaEdit) {
        window.__aaCutEdit = null;
        try {
          var cartNow = await fetchCart();
          var oldIt = null;
          (cartNow.items || []).forEach(function (it) {
            if (it.key === aaEdit.key) oldIt = it;
          });
          var updMap = {};
          var updN = 0;
          if (oldIt) {
            var oldPr = oldIt.properties || {};
            var oldD = oldPr['Design link'] || '';
            var oldPid = String(oldIt.product_id || '');
            var oldPj = String(oldPr['Project / Job Name'] || '');
            (cartNow.items || []).forEach(function (it) {
              var pr = it.properties || {};
              var isMat = !!oldD && pr['Design link'] === oldD;
              var isFee = !!oldPid &&
                String(pr['_cutting_fee_for_product'] || '') === oldPid &&
                (!oldPj || String(pr['_project_name'] || '') === oldPj);
              if (it.key === aaEdit.key || isMat || isFee) {
                updMap[it.key] = 0;
                updN++;
              }
            });
          }
          if (updN) {
            var rmRes = await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ updates: updMap })
            });
            if (!rmRes.ok) throw new Error('cart update failed');
          }
        } catch (e) {
          btn.textContent = originalText;
          btn.disabled = false;
          if (msg) {
            msg.textContent = 'Could not update the cart. Your job is unchanged - try again.';
            msg.style.display = 'block';
            msg.style.color = '#b42318';
          }
          return;
        }
        await addItemsToCart(itemsToAdd);
        window.location = '/cart';
        return;
      }

      await addItemsToCart(itemsToAdd);

      await refreshCartUi();
      if (window.aaPulseCartIcon) window.aaPulseCartIcon();

      if (msg) {
        msg.textContent = 'Cut job and material added to cart';
        msg.style.display = 'block';
      }

      btn.textContent = 'Added';
      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
        updateVariantBehaviour(row);
      }, 1200);

    } catch (error) {
      console.error('Cart error:', error);
      if (msg) {
        msg.textContent = error.description || error.message || 'Could not add cut job to cart.';
        msg.style.display = 'block';
        msg.style.color = '#b42318';
      }
      btn.textContent = originalText;
      btn.disabled = false;
      updateVariantBehaviour(row);
    }
  }
  wrapper.querySelectorAll('.aa-cut-add-cart').forEach(function(button) {
    button.addEventListener('click', aaCutAddCartHandler);
  });;

  refreshCascadingFilters();
  applyFilter();

  /* Paint the AluCut button on EVERY row at load. Without this the markup default ("Cut to
     size") sits there until the customer interacts, so the branded label and the "cuts
     entered" state only appeared after a click - which is exactly when they are least useful.
     aaSetCutLabel is idempotent. */
  wrapper.querySelectorAll('button.aa-cut-toggle').forEach(function(btn){
    if (!btn.classList.contains('aa-cut-toggle--open')) aaSetCutLabel(btn);
  });

  /* Lock the page behind the modal, and let Escape close it. Driven by a POLL rather than
     hooked into each open/close path, so a path I have not found cannot leave the body stuck
     at overflow:hidden with the page frozen. Idempotent, so re-running is free. */
  function aaModalSync() {
    var open = false;
    var panels = wrapper.querySelectorAll('tr.aa-cut-panel-row');
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].offsetHeight > 0) { open = true; break; }
    }
    document.body.classList.toggle('aa-cut-modal-open', open);
    aaScrollLockSync();
  }
  /* r29: the body class alone left the page scrollable behind the modal
     (when the theme styles the root element, overflow on body does not
     propagate to the viewport - body just grows and the page scrolls).
     Same pattern as the AluPlate tool: lock the root element directly.
     Checked DOCUMENT-wide so two table sections on one page cannot
     fight over the lock, and guarded by one window global so re-running
     is free (idempotent). Scroll position is saved on lock and put
     back on unlock for browsers that clamp it while locked. */
  function aaScrollLockSync() {
    var anyOpen = false;
    var all = document.querySelectorAll('tr.aa-cut-panel-row');
    for (var i = 0; i < all.length; i++) {
      if (all[i].offsetHeight > 0) { anyOpen = true; break; }
    }
    var st = window.__aaCutScrollLock || null;
    var root = document.documentElement;
    if (anyOpen && !st) {
      var y = window.pageYOffset || root.scrollTop || 0;
      window.__aaCutScrollLock = { y: y };
      root.classList.add('aa-cut-modal-lock');
      root.style.overflow = 'hidden';
    } else if (!anyOpen && st) {
      window.__aaCutScrollLock = null;
      root.classList.remove('aa-cut-modal-lock');
      root.style.overflow = '';
      window.scrollTo(0, st.y);
    }
  }
  setInterval(aaModalSync, 250);
  aaModalSync();

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    var panels = wrapper.querySelectorAll('tr.aa-cut-panel-row');
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].offsetHeight > 0) {
        var x = panels[i].querySelector('.aa-cut-x');
        if (x) x.click();
        return;
      }
    }
  });

  // r25: shared-link loader. Mirrors AluPlate's plateLoadFromURL: with
  // p=(row handle) and cuts=QTYxLEN_QTYxLEN in the URL, open that row's
  // cut tool through its own toggle and type the cut list in through the
  // normal input path (real input events, so the tool's own recalc and
  // label logic run). Runs once per page; a section that does not own
  // the handle simply does nothing.
  /* r-designlink (23 Sep 2026): a design link opened an EMPTY cut box on
     every bar table and every product page (found on #D81). This reader
     ran 400 ms after this file - mid-parse - and kept the row it found
     then. Two things happen after that on the live store:
       - theme.js rewrites every ".rte table" through outerHTML at boot
         (the responsive-table wrapper). Since r-pdphost the product page's
         cut table sits inside .rte, so its row, toggle and panel are
         REPLACED by copies, and the reader clicked the dead original;
       - aa-cut-defer.js loads with defer, so window.aaBuildCutPanel and
         its build-on-click listener do not exist until parsing ends. The
         click opened a panel that was never built.
     Now it does what the sheet reader has always done: start after
     DOMContentLoaded (theme.js and aa-cut-defer.js have both run by then),
     look the row, toggle and panel up FRESH on every attempt, build the
     panel if the click did not, fill it as before, then check the cut rows
     really hold the link's list. Three attempts, 500 ms apart; after that
     it says so in the console instead of failing silently. */
  (function () {
    var params = new URLSearchParams(window.location.search);
    var ph = params.get('p');
    var cutsParam = params.get('cuts');
    if (!ph || !cutsParam) return;
    function aaLinkRow() {
      var hit = null;
      wrapper.querySelectorAll('tr.aa-main-row').forEach(function (r) {
        if (!hit && (r.getAttribute('data-handle') || '') === ph) {
          hit = r;
        }
      });
      return hit;
    }
    if (!aaLinkRow()) return;
    if (window.__aaCutURLLoaded) return;
    window.__aaCutURLLoaded = true;
    /* r39: a cart Edit link carries edit_key = the cart line being
       edited. Remember it (with the owning handle) so submit swaps
       the old job for the new one instead of stacking a duplicate. */
    var editKey = params.get('edit_key');
    if (editKey) window.__aaCutEdit = { key: editKey, handle: ph };
    var finParam = params.get('fin');
    var lenParam = params.get('len');
    /* r-designlink-offcut 23 Sep 2026: off=1 keep the offcut, off=0 not required.
       Absent - every link made before this - is null: leave the default alone. */
    var offParam = params.get('off');
    var aaOffWant = offParam === '1' ? true : (offParam === '0' ? false : null);
    /* r-designlink-length 23 Sep 2026: al=1 "Pick the best length" ticked, al=0 unticked.
       Absent - every link made before this - is null: leave the default alone. */
    var alParam = params.get('al');
    var aaAlWant = alParam === '1' ? true : (alParam === '0' ? false : null);
    var aaLinkTries = 0;
    function aaLinkFill() {
      aaLinkTries++;
      var target = aaLinkRow();
      var toggle = target && target.querySelector('.aa-cut-toggle');
      var panelRow = target && getCutPanelRow(target);
      if (!toggle || !panelRow) { aaLinkRetry('row, toggle or panel not found'); return; }
      if (!aaIsCutPanelOpen(panelRow)) toggle.click();
      /* The click normally builds the panel (aa-cut-defer.js listens in
         the capture phase). If it did not, build it here. */
      if (!panelRow.querySelector('.aa-cut-rows') && typeof window.aaBuildCutPanel === 'function') {
        try { window.aaBuildCutPanel(panelRow); } catch (aaBx) {}
      }
      /* finish-restore (9 Aug): reselect the finish the link was built
         with, through the row's own select and a real change event, so
         every existing price/label handler runs. Label match, case-
         insensitive; no match = leave the default and say nothing. */
      if (finParam) {
        try {
          var aaFinSel = target.querySelector('.aa-finish-choice');
          if (aaFinSel) {
            var aaWant = String(finParam).trim().toLowerCase();
            for (var aaFi = 0; aaFi < aaFinSel.options.length; aaFi++) {
              var aaFo = aaFinSel.options[aaFi];
              var aaLab = (aaFo.getAttribute('data-finish-label') || aaFo.textContent || '').trim().toLowerCase();
              var aaVal = (aaFo.value || '').trim().toLowerCase();
              if (aaLab === aaWant || aaVal === aaWant) {
                aaFinSel.selectedIndex = aaFi;
                aaFinSel.setAttribute('data-selected-value', aaFo.value || '');
                aaFinSel.dispatchEvent(new Event('change', { bubbles: true }));
                break;
              }
            }
          }
        } catch (aaFx) {}
      }
      /* length-restore (10 Aug): reselect the stock length the link was
         built with, through the row's own select and a real change event.
         Match on data-length-mm; no match = leave the default silently. */
      if (lenParam) {
        try {
          var aaLenSel = target.querySelector('.aa-length-select');
          if (aaLenSel) {
            var aaLWant = String(parseInt(lenParam, 10));
            for (var aaLi = 0; aaLi < aaLenSel.options.length; aaLi++) {
              var aaLo = aaLenSel.options[aaLi];
              var aaLmm = String(parseInt(aaLo.getAttribute('data-length-mm') || aaLo.value || '0', 10));
              if (aaLmm === aaLWant) {
                aaLenSel.selectedIndex = aaLi;
                aaLenSel.dispatchEvent(new Event('change', { bubbles: true }));
                break;
              }
            }
          }
        } catch (aaLx) {}
      }
      /* finish-restore v2 (13 Aug): the block above restores the ROW's
         finish, but the cut job prices off the popup's OWN select
         (.aa-cut-finish) - "read the finish off the popup, not the row" -
         and that select inherits from the row only when it is rebuilt: at
         page load and at panel open, both of which run BEFORE these
         restores. Proven live: a White Pearl $29.21 link reopened as Mill
         Finish $25.93 - and add-to-cart would have carted the Mill bar.
         Set it directly, mark it touched so any later rebuild keeps it
         (aaBuildCutFinishSelect honours data-aa-touched), and fire its own
         change so the estimate reprices. No match = silent default. */
      if (finParam) {
        try {
          var aaCfSel = panelRow.querySelector('.aa-cut-finish');
          if (aaCfSel) {
            var aaCfWant = normalizeColour(String(finParam));
            for (var aaCfi = 0; aaCfi < aaCfSel.options.length; aaCfi++) {
              var aaCfo = aaCfSel.options[aaCfi];
              if (normalizeColour(aaCfo.value || aaCfo.textContent || '') === aaCfWant) {
                aaCfSel.selectedIndex = aaCfi;
                aaCfSel.setAttribute('data-aa-touched', '1');
                aaCfSel.dispatchEvent(new Event('change', { bubbles: true }));
                break;
              }
            }
          }
        } catch (aaCfx) {}
      }
      /* r-designlink-length 23 Sep 2026: restore "Pick the best length for my cuts" as
         the link was made - BEFORE the cut rows fill, so no estimate is asked for on the
         wrong basis. aaAutoPickOn reads the box directly; its change listener (bound when
         the box opened) re-prices, and updateCutEstimate below runs anyway. No al = the
         default (ticked), exactly as before. */
      if (aaAlWant !== null) {
        try {
          var aaAlCb = panelRow.querySelector('.aa-cut-autolen');
          if (aaAlCb && aaAlCb.checked !== aaAlWant) {
            aaAlCb.checked = aaAlWant;
            aaAlCb.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } catch (aaAx) {}
      }
      var pairs = [];
      cutsParam.split('_').forEach(function (tok) {
        var bits = tok.split('x');
        if (bits.length !== 2) return;
        var q = parseInt(bits[0], 10);
        var l = parseInt(bits[1], 10);
        if (q > 0 && l > 0) pairs.push({ qty: q, len: l });
      });
      if (!pairs.length) return;
      var rowsWrap = panelRow.querySelector('.aa-cut-rows');
      if (!rowsWrap) { aaLinkRetry('the cut panel was not built'); return; }
      pairs.forEach(function (p, i) {
        var all = rowsWrap.querySelectorAll('.aa-cut-row');
        if (i >= all.length) {
          var addBtn = panelRow.querySelector('.aa-cut-add-row');
          if (addBtn) addBtn.click();
          all = rowsWrap.querySelectorAll('.aa-cut-row');
        }
        var cutRow = all[Math.min(i, all.length - 1)];
        if (!cutRow) return;
        var qEl = cutRow.querySelector('.aa-cut-qty');
        var lEl = cutRow.querySelector('.aa-cut-length');
        if (!qEl || !lEl) return;
        qEl.value = p.qty;
        lEl.value = p.len;
        qEl.dispatchEvent(new Event('input', { bubbles: true }));
        lEl.dispatchEvent(new Event('input', { bubbles: true }));
      });
      var job = params.get('job');
      if (job) {
        var pj = panelRow.querySelector('.aa-cut-project');
        if (pj && !pj.value) pj.value = job;
      }
      /* r-designlink-offcut 23 Sep 2026: restore the offcut choice the link was
         made with. Keep is the FIRST .aa-cut-offcut-checkbox and "No offcuts
         needed" the second (a lone checkbox means keep) - the same read the cart
         line's Offcut property makes. Set it, then fire a real change event, as
         the finish restore does. No off = the default, exactly as before. */
      if (aaOffWant !== null) {
        try {
          var aaOffR = panelRow.querySelectorAll('.aa-cut-offcut-checkbox');
          if (aaOffR.length > 1) {
            var aaOffPick = aaOffWant ? aaOffR[0] : aaOffR[1];
            aaOffPick.checked = true;
            aaOffPick.dispatchEvent(new Event('change', { bubbles: true }));
          } else if (aaOffR.length === 1) {
            aaOffR[0].checked = aaOffWant;
            aaOffR[0].dispatchEvent(new Event('change', { bubbles: true }));
          }
        } catch (aaOx) {}
      }
      updateCutEstimate(target);
      /* Check it took: the filled cut rows must hold exactly the link's
         list (any order), on a row that is still in the page. */
      var want = pairs.map(function (p) { return p.qty + 'x' + p.len; }).sort().join('_');
      var got = [];
      rowsWrap.querySelectorAll('.aa-cut-row').forEach(function (cr) {
        var cq = cr.querySelector('.aa-cut-qty');
        var cl = cr.querySelector('.aa-cut-length');
        if (cq && cl && cq.value !== '' && cl.value !== '') got.push(parseInt(cq.value, 10) + 'x' + parseInt(cl.value, 10));
      });
      got = got.sort().join('_');
      var aaOffNow = panelRow.querySelector('.aa-cut-offcut-checkbox');
      var aaAlNow = panelRow.querySelector('.aa-cut-autolen');
      if (!target.isConnected || got !== want) {
        aaLinkRetry('the cut rows hold ' + (got || 'nothing') + ', the link says ' + want);
      } else if (aaOffWant !== null && aaOffNow && aaOffNow.checked !== aaOffWant) {
        aaLinkRetry('the offcut choice did not take - the link says ' + (aaOffWant ? 'keep it' : 'not required'));
      } else if (aaAlWant !== null && aaAlNow && aaAlNow.checked !== aaAlWant) {
        aaLinkRetry('the length choice did not take - the link says ' + (aaAlWant ? 'pick the best length' : 'use the selected length'));
      }
    }
    function aaLinkRetry(why) {
      if (aaLinkTries < 3) { setTimeout(aaLinkFill, 500); return; }
      if (window.console && console.warn) console.warn('[aa-cut-link] could not load the cut list from this link: ' + why);
    }
    function aaLinkStart() { setTimeout(aaLinkFill, 400); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aaLinkStart);
    else aaLinkStart();
  })();

  // Highlight row from product page redirect — stays until customer interacts
  (function() {
    var params = new URLSearchParams(window.location.search);
    var highlight = params.get('highlight');
    if (!highlight) return;

    setTimeout(function() {
      var rows = wrapper.querySelectorAll('tr.aa-main-row');
      var targetRow = null;

      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var titleHandle = row.getAttribute('data-handle') || '';
        if (titleHandle === highlight) {
          targetRow = row;
          break;
        }
      }

      if (!targetRow) return;

      targetRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
      targetRow.style.transition = 'box-shadow 0.4s ease, outline 0.4s ease';
      targetRow.style.outline = '2px solid #12b8e5';
      targetRow.style.boxShadow = '0 0 0 5px rgba(18,184,229,0.18)';

      /* r183: OPEN THE CUT PANEL ON A PRODUCT-PAGE REDIRECT.
         The product pages only ever had the cut-down "Cut to size" modal - no
         AluCut branding, no split presets, no layout diagram, no Copy link. The
         real tool has always been here on the collection row. This reuses the
         highlight redirect that already scrolls to the row and adds &cut=1 to
         open the panel, so "Order cut to size" on a PDP lands the customer in
         the genuine AluCut tool. Idempotent - it only clicks when closed. */
      if (params.get('cut') === '1') {
        var aaCutTg = targetRow.querySelector('.aa-cut-toggle');
        var aaCutPr = (typeof getCutPanelRow === 'function') ? getCutPanelRow(targetRow) : null;
        if (aaCutTg && aaCutPr && !aaIsCutPanelOpen(aaCutPr)) aaCutTg.click();
      }

      // Remove highlight when customer interacts with the row
      function removeHighlight() {
        targetRow.style.outline = '';
        targetRow.style.boxShadow = '';
        targetRow.removeEventListener('click', removeHighlight);
        targetRow.removeEventListener('change', removeHighlight);
      }
      targetRow.addEventListener('click', removeHighlight);
      targetRow.addEventListener('change', removeHighlight);

    }, 400);
  })();
})();

// ── Mobile filter drawer ──────────────────────────────────────────────
if (!window.aaToggleFilterDrawer) {
  window.aaToggleFilterDrawer = function(sid) {
    var drawer = document.getElementById('aa-filter-drawer-' + sid);
    var btn    = document.getElementById('aa-filter-btn-' + sid);
    if (!drawer) return;
    var isOpen = drawer.classList.contains('is-open');
    drawer.classList.toggle('is-open', !isOpen);
    if (btn) { btn.classList.toggle('is-active', !isOpen); btn.setAttribute('aria-expanded', String(!isOpen)); }
  };
  window.aaUpdateFilterCount = function(sid) {
    var selects = document.querySelectorAll('#aa-filter-drawer-' + sid + ' select');
    var count = 0;
    selects.forEach(function(s) { if (s.value && s.value !== 'all') count++; });
    var badge  = document.getElementById('aa-filter-count-' + sid);
    var btn    = document.getElementById('aa-filter-btn-' + sid);
    var drawer = document.getElementById('aa-filter-drawer-' + sid);
    if (!badge) return;
    if (count > 0) {
      badge.textContent = count; badge.style.display = 'inline-flex';
      if (btn) btn.classList.add('is-active');
    } else {
      badge.style.display = 'none';
      if (btn && drawer && !drawer.classList.contains('is-open')) btn.classList.remove('is-active');
    }
  };
}
(function() {
  var sid = '' + SID + '';
  var drawer = document.getElementById('aa-filter-drawer-' + sid);
  if (!drawer) return;
  drawer.querySelectorAll('select').forEach(function(s) {
    s.addEventListener('change', function() { window.aaUpdateFilterCount(sid); });
  });
  var clearBtn = document.getElementById('aa-filter-clear-' + sid);
  if (clearBtn) clearBtn.addEventListener('click', function() { setTimeout(function() { window.aaUpdateFilterCount(sid); }, 50); });
})();

  // ── Powder coat pill — focus finish dropdown ──────────────────────────────
  function aaFocusFinish(btn) {
    var row = btn.closest('tr');
    if (!row) return;
    var lengthSel = row.querySelector('.aa-length-select');
    var finishSel = row.querySelector('.aa-finish-choice');
    if (!finishSel) return;

    function doHighlight() {
      // Find the finish/powder coat TD (contains .aa-finish-choice)
      var td = finishSel.closest('td');

      // Scroll row into view only if not already fully visible
      var sticky = 0;
      ['[data-section-type="header"] header','header.header','.nav-bar'].forEach(function(sel) {
        var el = document.querySelector(sel);
        if (el) sticky = Math.max(sticky, el.getBoundingClientRect().bottom);
      });
      var rowRect = row.getBoundingClientRect();
      if (rowRect.top < sticky + 10 || rowRect.bottom > window.innerHeight - 10) {
        var top = rowRect.top + window.scrollY - sticky - 10;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }

      // Highlight the whole finish TD with a pulsing background + border
      if (td) {
        td.style.transition = 'background 0.2s, outline 0.2s';
        td.style.background = '#fdf4ff';
        td.style.outline = '2px solid #9d174d';
        td.style.borderRadius = '6px';
        setTimeout(function() {
          td.style.background = '';
          td.style.outline = '';
          td.style.borderRadius = '';
        }, 2200);
      }
      finishSel.focus();
    }

    // If current length has no powder coat options, reset to first full-length
    var hasPowder = Array.from(finishSel.options).some(function(o) {
      return o.text.toLowerCase().indexOf('powder') > -1 || o.text.toLowerCase().indexOf('coat') > -1;
    });

    if (!hasPowder && lengthSel && lengthSel.options.length > 0) {
      // Reset to first option (typically full length) and rebuild finishes
      lengthSel.selectedIndex = 0;
      lengthSel.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(doHighlight, 400); // Wait for rebuild
    } else {
      doHighlight();
    }
  }

  // ── Info ticker ───────────────────────────────────────────────────────────
  (function() {
    var wrap = document.getElementById('aa-ticker-' + SID + '');
    if (!wrap) return;
    var items = wrap.querySelectorAll('.aa-ticker-item');
    if (items.length < 2) return;
    var current = 0;
    setInterval(function() {
      items[current].classList.remove('active');
      current = (current + 1) % items.length;
      items[current].classList.add('active');
    }, 3500);
  })();
